export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * A type that can store integers, strings, floats, and nulls without any validation.
   * This is used for flexible data storage in reports, and is not intended for general use.
   * Please avoid using this for anything outside of reports. We may hopefully be able to remove this type in the future.
   */
  Any: { input: any; output: any; }
  /**
   * The `Date` scalar type represents a date. The Date appears in a JSON
   * response as an ISO8601 formatted string, without a time component.
   */
  Date: { input: any; output: any; }
  /**
   * The `DateTime` scalar type represents a date and time in the UTC
   * timezone. The DateTime appears in a JSON response as an ISO8601 formatted
   * string, including UTC timezone ("Z"). The parsed date and time string will
   * be converted to UTC if there is an offset.
   */
  DateTime: { input: any; output: any; }
  /**
   * The `Decimal` scalar type represents signed double-precision fractional
   * values parsed by the `Decimal` library. The Decimal appears in a JSON
   * response as a string to preserve precision.
   */
  Decimal: { input: any; output: any; }
  /**
   * The `Json` scalar type represents arbitrary json string data, represented as UTF-8
   * character sequences. The Json type is most often used to represent a free-form
   * human-readable json string.
   */
  Json: { input: any; output: any; }
  /**
   * The `Json` scalar type represents arbitrary json string data, represented as UTF-8
   * character sequences. The Json type is most often used to represent a free-form
   * human-readable json string.
   */
  JsonString: { input: any; output: any; }
};

export type AbQuestionCountEntry = {
  __typename?: 'AbQuestionCountEntry';
  count: Scalars['Int']['output'];
  key: Scalars['String']['output'];
};

export type AbQuestionCountOptsInput = {
  guideLevels?: InputMaybe<Array<Scalars['ID']['input']>>;
  hideAssessmentQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  hidePreviouslyAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  negateStandardsFilter?: InputMaybe<Scalars['Boolean']['input']>;
  questionDifficulties?: InputMaybe<Array<Scalars['Int']['input']>>;
  questionTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  standardSets?: InputMaybe<Array<Scalars['ID']['input']>>;
  standards?: InputMaybe<Array<Scalars['ID']['input']>>;
  subjects?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AdaptivePractice = {
  __typename?: 'AdaptivePractice';
  advanceThreshold?: Maybe<Scalars['Int']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  currentQuestion?: Maybe<Question>;
  currentQuestionId?: Maybe<Scalars['ID']['output']>;
  fallbackThreshold?: Maybe<Scalars['Int']['output']>;
  guesses: Array<Guess>;
  guideLevel: GuideLevel;
  guideLevelId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  level: Scalars['Int']['output'];
  levelAt?: Maybe<Scalars['Int']['output']>;
  levelChangedAt: Scalars['DateTime']['output'];
  /** Whether this practice counts toward some but not all of the active settings for this skill on the student's skill path. */
  partialSkillPathConflict?: Maybe<Scalars['Boolean']['output']>;
  proficiencyLevelChanges: Array<ProficiencyLevelChange>;
  range?: Maybe<Scalars['Int']['output']>;
  rollingAccuracy?: Maybe<Scalars['Float']['output']>;
  rollingCorrectCount?: Maybe<Scalars['Int']['output']>;
  rollingGuessCount?: Maybe<Scalars['Int']['output']>;
  rollingIncorrectCount?: Maybe<Scalars['Int']['output']>;
  student: User;
  studentId: Scalars['ID']['output'];
  /** Whether this practice won't count toward any of the active settings for this skill on the student's skill path. */
  totalSkillPathConflict?: Maybe<Scalars['Boolean']['output']>;
  unfilteredGuideLevel: GuideLevel;
  updatedAt: Scalars['DateTime']['output'];
};


export type AdaptivePracticeGuessesArgs = {
  filter?: InputMaybe<GuessFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuessSortInput>>>;
};


export type AdaptivePracticeLevelAtArgs = {
  at: Scalars['DateTime']['input'];
};


export type AdaptivePracticeProficiencyLevelChangesArgs = {
  filter?: InputMaybe<ProficiencyLevelChangeFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ProficiencyLevelChangeSortInput>>>;
};

export type AdaptivePracticeFilterAdvanceThreshold = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type AdaptivePracticeFilterCompletedAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AdaptivePracticeFilterCurrentQuestionId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type AdaptivePracticeFilterFallbackThreshold = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type AdaptivePracticeFilterGuideLevelId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type AdaptivePracticeFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type AdaptivePracticeFilterInput = {
  advanceThreshold?: InputMaybe<AdaptivePracticeFilterAdvanceThreshold>;
  and?: InputMaybe<Array<AdaptivePracticeFilterInput>>;
  completedAt?: InputMaybe<AdaptivePracticeFilterCompletedAt>;
  currentQuestion?: InputMaybe<QuestionFilterInput>;
  currentQuestionId?: InputMaybe<AdaptivePracticeFilterCurrentQuestionId>;
  fallbackThreshold?: InputMaybe<AdaptivePracticeFilterFallbackThreshold>;
  guesses?: InputMaybe<GuessFilterInput>;
  guideLevel?: InputMaybe<GuideLevelFilterInput>;
  guideLevelId?: InputMaybe<AdaptivePracticeFilterGuideLevelId>;
  id?: InputMaybe<AdaptivePracticeFilterId>;
  insertedAt?: InputMaybe<AdaptivePracticeFilterInsertedAt>;
  level?: InputMaybe<AdaptivePracticeFilterLevel>;
  levelAt?: InputMaybe<AdaptivePracticeFilterLevelAt>;
  levelChangedAt?: InputMaybe<AdaptivePracticeFilterLevelChangedAt>;
  not?: InputMaybe<Array<AdaptivePracticeFilterInput>>;
  or?: InputMaybe<Array<AdaptivePracticeFilterInput>>;
  /** Whether this practice counts toward some but not all of the active settings for this skill on the student's skill path. */
  partialSkillPathConflict?: InputMaybe<AdaptivePracticeFilterPartialSkillPathConflict>;
  proficiencyLevelChanges?: InputMaybe<ProficiencyLevelChangeFilterInput>;
  range?: InputMaybe<AdaptivePracticeFilterRange>;
  rollingAccuracy?: InputMaybe<AdaptivePracticeFilterRollingAccuracy>;
  student?: InputMaybe<UserFilterInput>;
  studentId?: InputMaybe<AdaptivePracticeFilterStudentId>;
  /** Whether this practice won't count toward any of the active settings for this skill on the student's skill path. */
  totalSkillPathConflict?: InputMaybe<AdaptivePracticeFilterTotalSkillPathConflict>;
  unfilteredGuideLevel?: InputMaybe<GuideLevelFilterInput>;
  updatedAt?: InputMaybe<AdaptivePracticeFilterUpdatedAt>;
};

export type AdaptivePracticeFilterInsertedAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AdaptivePracticeFilterLevel = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type AdaptivePracticeFilterLevelAt = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  input?: InputMaybe<AdaptivePracticeLevelAtFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type AdaptivePracticeFilterLevelChangedAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AdaptivePracticeFilterPartialSkillPathConflict = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdaptivePracticeFilterRange = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type AdaptivePracticeFilterRollingAccuracy = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Float']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Float']['input']>;
  lessThan?: InputMaybe<Scalars['Float']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Float']['input']>;
  notEq?: InputMaybe<Scalars['Float']['input']>;
};

export type AdaptivePracticeFilterStudentId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type AdaptivePracticeFilterTotalSkillPathConflict = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdaptivePracticeFilterUpdatedAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AdaptivePracticeLevelAtFieldInput = {
  at: Scalars['DateTime']['input'];
};

export enum AdaptivePracticeSortField {
  AdvanceThreshold = 'ADVANCE_THRESHOLD',
  CompletedAt = 'COMPLETED_AT',
  CurrentQuestionId = 'CURRENT_QUESTION_ID',
  FallbackThreshold = 'FALLBACK_THRESHOLD',
  GuideLevelId = 'GUIDE_LEVEL_ID',
  Id = 'ID',
  InsertedAt = 'INSERTED_AT',
  Level = 'LEVEL',
  LevelAt = 'LEVEL_AT',
  LevelChangedAt = 'LEVEL_CHANGED_AT',
  PartialSkillPathConflict = 'PARTIAL_SKILL_PATH_CONFLICT',
  Range = 'RANGE',
  RollingAccuracy = 'ROLLING_ACCURACY',
  StudentId = 'STUDENT_ID',
  TotalSkillPathConflict = 'TOTAL_SKILL_PATH_CONFLICT',
  UpdatedAt = 'UPDATED_AT'
}

export type AdaptivePracticeSortInput = {
  field: AdaptivePracticeSortField;
  levelAtInput?: InputMaybe<AdaptivePracticeLevelAtFieldInput>;
  order?: InputMaybe<SortOrder>;
};

export type AnalyticsClassroomAssignment = {
  __typename?: 'AnalyticsClassroomAssignment';
  assignment: AnalyticsReportAssignment;
  assignmentId: Scalars['ID']['output'];
  classroom: AnalyticsReportClassroom;
  classroomId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  settings: Scalars['Json']['output'];
};

export type AnalyticsClassroomAssignmentFilterAssignmentId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type AnalyticsClassroomAssignmentFilterClassroomId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type AnalyticsClassroomAssignmentFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type AnalyticsClassroomAssignmentFilterInput = {
  and?: InputMaybe<Array<AnalyticsClassroomAssignmentFilterInput>>;
  assignment?: InputMaybe<AnalyticsReportAssignmentFilterInput>;
  assignmentId?: InputMaybe<AnalyticsClassroomAssignmentFilterAssignmentId>;
  classroom?: InputMaybe<AnalyticsReportClassroomFilterInput>;
  classroomId?: InputMaybe<AnalyticsClassroomAssignmentFilterClassroomId>;
  id?: InputMaybe<AnalyticsClassroomAssignmentFilterId>;
  not?: InputMaybe<Array<AnalyticsClassroomAssignmentFilterInput>>;
  or?: InputMaybe<Array<AnalyticsClassroomAssignmentFilterInput>>;
  settings?: InputMaybe<AnalyticsClassroomAssignmentFilterSettings>;
};

export type AnalyticsClassroomAssignmentFilterSettings = {
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AnalyticsClassroomAssignmentSortField {
  AssignmentId = 'ASSIGNMENT_ID',
  ClassroomId = 'CLASSROOM_ID',
  Id = 'ID',
  Settings = 'SETTINGS'
}

export type AnalyticsClassroomAssignmentSortInput = {
  field: AnalyticsClassroomAssignmentSortField;
  order?: InputMaybe<SortOrder>;
};

export type AnalyticsQuestionSet = {
  __typename?: 'AnalyticsQuestionSet';
  id: Scalars['ID']['output'];
  subject: AnalyticsSubject;
  subjectId: Scalars['ID']['output'];
};

export type AnalyticsReport = {
  __typename?: 'AnalyticsReport';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  countPrimaryDimension?: Maybe<Scalars['Int']['output']>;
  countSecondaryDimension?: Maybe<Scalars['Int']['output']>;
  dimensions: Array<Scalars['String']['output']>;
  filters?: Maybe<Array<ReportFilter>>;
  hash: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  metricInputs?: Maybe<Array<MetricInput>>;
  metrics?: Maybe<Array<Scalars['String']['output']>>;
  persist: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AnalyticsReportAssignment = {
  __typename?: 'AnalyticsReportAssignment';
  classroomAssignments: Array<AnalyticsClassroomAssignment>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  settings: Scalars['Json']['output'];
  studentAssignments: Array<AnalyticsStudentAssignment>;
  students: Array<AnalyticsStudent>;
};


export type AnalyticsReportAssignmentClassroomAssignmentsArgs = {
  filter?: InputMaybe<AnalyticsClassroomAssignmentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AnalyticsClassroomAssignmentSortInput>>>;
};


export type AnalyticsReportAssignmentStudentAssignmentsArgs = {
  filter?: InputMaybe<AnalyticsStudentAssignmentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AnalyticsStudentAssignmentSortInput>>>;
};


export type AnalyticsReportAssignmentStudentsArgs = {
  filter?: InputMaybe<AnalyticsStudentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AnalyticsStudentSortInput>>>;
};

export type AnalyticsReportAssignmentFilterDueDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnalyticsReportAssignmentFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type AnalyticsReportAssignmentFilterInput = {
  and?: InputMaybe<Array<AnalyticsReportAssignmentFilterInput>>;
  classroomAssignments?: InputMaybe<AnalyticsClassroomAssignmentFilterInput>;
  dueDate?: InputMaybe<AnalyticsReportAssignmentFilterDueDate>;
  id?: InputMaybe<AnalyticsReportAssignmentFilterId>;
  name?: InputMaybe<AnalyticsReportAssignmentFilterName>;
  not?: InputMaybe<Array<AnalyticsReportAssignmentFilterInput>>;
  or?: InputMaybe<Array<AnalyticsReportAssignmentFilterInput>>;
  settings?: InputMaybe<AnalyticsReportAssignmentFilterSettings>;
  studentAssignments?: InputMaybe<AnalyticsStudentAssignmentFilterInput>;
  students?: InputMaybe<AnalyticsStudentFilterInput>;
};

export type AnalyticsReportAssignmentFilterName = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type AnalyticsReportAssignmentFilterSettings = {
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AnalyticsReportAssignmentSortField {
  DueDate = 'DUE_DATE',
  Id = 'ID',
  Name = 'NAME',
  Settings = 'SETTINGS'
}

export type AnalyticsReportAssignmentSortInput = {
  field: AnalyticsReportAssignmentSortField;
  order?: InputMaybe<SortOrder>;
};

export type AnalyticsReportClassroom = {
  __typename?: 'AnalyticsReportClassroom';
  autoArchiveDate?: Maybe<Scalars['DateTime']['output']>;
  classroomAssignments: Array<AnalyticsClassroomAssignment>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};


export type AnalyticsReportClassroomClassroomAssignmentsArgs = {
  filter?: InputMaybe<AnalyticsClassroomAssignmentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AnalyticsClassroomAssignmentSortInput>>>;
};

export type AnalyticsReportClassroomFilterAutoArchiveDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnalyticsReportClassroomFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type AnalyticsReportClassroomFilterInput = {
  and?: InputMaybe<Array<AnalyticsReportClassroomFilterInput>>;
  autoArchiveDate?: InputMaybe<AnalyticsReportClassroomFilterAutoArchiveDate>;
  classroomAssignments?: InputMaybe<AnalyticsClassroomAssignmentFilterInput>;
  id?: InputMaybe<AnalyticsReportClassroomFilterId>;
  name?: InputMaybe<AnalyticsReportClassroomFilterName>;
  not?: InputMaybe<Array<AnalyticsReportClassroomFilterInput>>;
  or?: InputMaybe<Array<AnalyticsReportClassroomFilterInput>>;
  status?: InputMaybe<AnalyticsReportClassroomFilterStatus>;
};

export type AnalyticsReportClassroomFilterName = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type AnalyticsReportClassroomFilterStatus = {
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type AnalyticsReportFiltersInput = {
  field?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<Scalars['Any']['input']>>;
};

export type AnalyticsReportGuide = {
  __typename?: 'AnalyticsReportGuide';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  published: Scalars['Boolean']['output'];
  subject: AnalyticsSubject;
  subjectId: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export type AnalyticsReportGuideLevel = {
  __typename?: 'AnalyticsReportGuideLevel';
  code: Scalars['String']['output'];
  countChildren: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  level: Scalars['Json']['output'];
  name: Scalars['String']['output'];
  nlevel?: Maybe<Scalars['Int']['output']>;
  position: Scalars['Int']['output'];
  published: Scalars['Boolean']['output'];
  subject: AnalyticsSubject;
  subjectId: Scalars['ID']['output'];
};

export type AnalyticsReportQuestion = {
  __typename?: 'AnalyticsReportQuestion';
  difficulty?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isAdaptive?: Maybe<Scalars['Boolean']['output']>;
  questionSet?: Maybe<AnalyticsQuestionSet>;
  questionSetId: Scalars['ID']['output'];
  slugId?: Maybe<Scalars['String']['output']>;
  standards: Array<AnalyticsStandard>;
  title: Scalars['String']['output'];
};


export type AnalyticsReportQuestionStandardsArgs = {
  filter?: InputMaybe<AnalyticsStandardFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AnalyticsStandardSortInput>>>;
};

export type AnalyticsSchool = {
  __typename?: 'AnalyticsSchool';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type AnalyticsStandard = {
  __typename?: 'AnalyticsStandard';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  standardSet: AnalyticsStandardSet;
  standardSetId: Scalars['ID']['output'];
  statusEndDate?: Maybe<Scalars['DateTime']['output']>;
  statusStartDate?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
};

export type AnalyticsStandardFilterDescription = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type AnalyticsStandardFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type AnalyticsStandardFilterInput = {
  and?: InputMaybe<Array<AnalyticsStandardFilterInput>>;
  description?: InputMaybe<AnalyticsStandardFilterDescription>;
  id?: InputMaybe<AnalyticsStandardFilterId>;
  not?: InputMaybe<Array<AnalyticsStandardFilterInput>>;
  or?: InputMaybe<Array<AnalyticsStandardFilterInput>>;
  standardSet?: InputMaybe<AnalyticsStandardSetFilterInput>;
  standardSetId?: InputMaybe<AnalyticsStandardFilterStandardSetId>;
  statusEndDate?: InputMaybe<AnalyticsStandardFilterStatusEndDate>;
  statusStartDate?: InputMaybe<AnalyticsStandardFilterStatusStartDate>;
  title?: InputMaybe<AnalyticsStandardFilterTitle>;
};

export type AnalyticsStandardFilterStandardSetId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type AnalyticsStandardFilterStatusEndDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnalyticsStandardFilterStatusStartDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnalyticsStandardFilterTitle = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type AnalyticsStandardSet = {
  __typename?: 'AnalyticsStandardSet';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type AnalyticsStandardSetFilterDescription = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type AnalyticsStandardSetFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type AnalyticsStandardSetFilterInput = {
  and?: InputMaybe<Array<AnalyticsStandardSetFilterInput>>;
  description?: InputMaybe<AnalyticsStandardSetFilterDescription>;
  id?: InputMaybe<AnalyticsStandardSetFilterId>;
  not?: InputMaybe<Array<AnalyticsStandardSetFilterInput>>;
  or?: InputMaybe<Array<AnalyticsStandardSetFilterInput>>;
  title?: InputMaybe<AnalyticsStandardSetFilterTitle>;
};

export type AnalyticsStandardSetFilterTitle = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export enum AnalyticsStandardSortField {
  Description = 'DESCRIPTION',
  Id = 'ID',
  StandardSetId = 'STANDARD_SET_ID',
  StatusEndDate = 'STATUS_END_DATE',
  StatusStartDate = 'STATUS_START_DATE',
  Title = 'TITLE'
}

export type AnalyticsStandardSortInput = {
  field: AnalyticsStandardSortField;
  order?: InputMaybe<SortOrder>;
};

export type AnalyticsStudent = {
  __typename?: 'AnalyticsStudent';
  assignments: Array<AnalyticsReportAssignment>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  studentAssignments: Array<AnalyticsStudentAssignment>;
  username: Scalars['String']['output'];
};


export type AnalyticsStudentAssignmentsArgs = {
  filter?: InputMaybe<AnalyticsReportAssignmentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AnalyticsReportAssignmentSortInput>>>;
};


export type AnalyticsStudentStudentAssignmentsArgs = {
  filter?: InputMaybe<AnalyticsStudentAssignmentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AnalyticsStudentAssignmentSortInput>>>;
};

export type AnalyticsStudentAssignment = {
  __typename?: 'AnalyticsStudentAssignment';
  assignment: AnalyticsReportAssignment;
  assignmentId: Scalars['ID']['output'];
  classroomAssignments: Array<AnalyticsClassroomAssignment>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  lockdownAutoSubmitReason?: Maybe<StudentAssignmentLockdownAutoSubmitReason>;
  lockdownViolations: Scalars['Json']['output'];
  settings?: Maybe<Scalars['Json']['output']>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  student: AnalyticsStudent;
  studentId: Scalars['ID']['output'];
  submitted?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


export type AnalyticsStudentAssignmentClassroomAssignmentsArgs = {
  filter?: InputMaybe<AnalyticsClassroomAssignmentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AnalyticsClassroomAssignmentSortInput>>>;
};

export type AnalyticsStudentAssignmentFilterAssignmentId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type AnalyticsStudentAssignmentFilterDeletedAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnalyticsStudentAssignmentFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type AnalyticsStudentAssignmentFilterInput = {
  and?: InputMaybe<Array<AnalyticsStudentAssignmentFilterInput>>;
  assignment?: InputMaybe<AnalyticsReportAssignmentFilterInput>;
  assignmentId?: InputMaybe<AnalyticsStudentAssignmentFilterAssignmentId>;
  classroomAssignments?: InputMaybe<AnalyticsClassroomAssignmentFilterInput>;
  deletedAt?: InputMaybe<AnalyticsStudentAssignmentFilterDeletedAt>;
  id?: InputMaybe<AnalyticsStudentAssignmentFilterId>;
  insertedAt?: InputMaybe<AnalyticsStudentAssignmentFilterInsertedAt>;
  lockdownAutoSubmitReason?: InputMaybe<AnalyticsStudentAssignmentFilterLockdownAutoSubmitReason>;
  lockdownViolations?: InputMaybe<AnalyticsStudentAssignmentFilterLockdownViolations>;
  not?: InputMaybe<Array<AnalyticsStudentAssignmentFilterInput>>;
  or?: InputMaybe<Array<AnalyticsStudentAssignmentFilterInput>>;
  settings?: InputMaybe<AnalyticsStudentAssignmentFilterSettings>;
  startTime?: InputMaybe<AnalyticsStudentAssignmentFilterStartTime>;
  student?: InputMaybe<AnalyticsStudentFilterInput>;
  studentId?: InputMaybe<AnalyticsStudentAssignmentFilterStudentId>;
  submitted?: InputMaybe<AnalyticsStudentAssignmentFilterSubmitted>;
  updatedAt?: InputMaybe<AnalyticsStudentAssignmentFilterUpdatedAt>;
};

export type AnalyticsStudentAssignmentFilterInsertedAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnalyticsStudentAssignmentFilterLockdownAutoSubmitReason = {
  eq?: InputMaybe<StudentAssignmentLockdownAutoSubmitReason>;
  greaterThan?: InputMaybe<StudentAssignmentLockdownAutoSubmitReason>;
  greaterThanOrEqual?: InputMaybe<StudentAssignmentLockdownAutoSubmitReason>;
  in?: InputMaybe<Array<InputMaybe<StudentAssignmentLockdownAutoSubmitReason>>>;
  isDistinctFrom?: InputMaybe<StudentAssignmentLockdownAutoSubmitReason>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<StudentAssignmentLockdownAutoSubmitReason>;
  lessThan?: InputMaybe<StudentAssignmentLockdownAutoSubmitReason>;
  lessThanOrEqual?: InputMaybe<StudentAssignmentLockdownAutoSubmitReason>;
  notEq?: InputMaybe<StudentAssignmentLockdownAutoSubmitReason>;
};

export type AnalyticsStudentAssignmentFilterLockdownViolations = {
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AnalyticsStudentAssignmentFilterSettings = {
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AnalyticsStudentAssignmentFilterStartTime = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnalyticsStudentAssignmentFilterStudentId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type AnalyticsStudentAssignmentFilterSubmitted = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnalyticsStudentAssignmentFilterUpdatedAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum AnalyticsStudentAssignmentSortField {
  AssignmentId = 'ASSIGNMENT_ID',
  DeletedAt = 'DELETED_AT',
  Id = 'ID',
  InsertedAt = 'INSERTED_AT',
  LockdownAutoSubmitReason = 'LOCKDOWN_AUTO_SUBMIT_REASON',
  LockdownViolations = 'LOCKDOWN_VIOLATIONS',
  Settings = 'SETTINGS',
  StartTime = 'START_TIME',
  StudentId = 'STUDENT_ID',
  Submitted = 'SUBMITTED',
  UpdatedAt = 'UPDATED_AT'
}

export type AnalyticsStudentAssignmentSortInput = {
  field: AnalyticsStudentAssignmentSortField;
  order?: InputMaybe<SortOrder>;
};

export type AnalyticsStudentFilterEmail = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type AnalyticsStudentFilterFirstName = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type AnalyticsStudentFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type AnalyticsStudentFilterInput = {
  and?: InputMaybe<Array<AnalyticsStudentFilterInput>>;
  assignments?: InputMaybe<AnalyticsReportAssignmentFilterInput>;
  email?: InputMaybe<AnalyticsStudentFilterEmail>;
  firstName?: InputMaybe<AnalyticsStudentFilterFirstName>;
  id?: InputMaybe<AnalyticsStudentFilterId>;
  lastName?: InputMaybe<AnalyticsStudentFilterLastName>;
  not?: InputMaybe<Array<AnalyticsStudentFilterInput>>;
  or?: InputMaybe<Array<AnalyticsStudentFilterInput>>;
  studentAssignments?: InputMaybe<AnalyticsStudentAssignmentFilterInput>;
  username?: InputMaybe<AnalyticsStudentFilterUsername>;
};

export type AnalyticsStudentFilterLastName = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type AnalyticsStudentFilterUsername = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export enum AnalyticsStudentSortField {
  Email = 'EMAIL',
  FirstName = 'FIRST_NAME',
  Id = 'ID',
  LastName = 'LAST_NAME',
  Username = 'USERNAME'
}

export type AnalyticsStudentSortInput = {
  field: AnalyticsStudentSortField;
  order?: InputMaybe<SortOrder>;
};

export type AnalyticsSubject = {
  __typename?: 'AnalyticsSubject';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  urlSlug: Scalars['String']['output'];
};

export type AnalyticsTeacher = {
  __typename?: 'AnalyticsTeacher';
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

/** The result of the :archive_question mutation */
export type ArchiveQuestionResult = {
  __typename?: 'ArchiveQuestionResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<Question>;
};

export type AudioSupplementContent = {
  __typename?: 'AudioSupplementContent';
  audio: Scalars['String']['output'];
  audioStatus?: Maybe<Scalars['String']['output']>;
  audioText?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  languageCode?: Maybe<Scalars['String']['output']>;
  voiceId?: Maybe<Scalars['String']['output']>;
};

export type AudioSupplementContentInput = {
  audio: Scalars['String']['input'];
  audioStatus?: InputMaybe<Scalars['String']['input']>;
  audioText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  voiceId?: InputMaybe<Scalars['String']['input']>;
};

export type BulkCreateManagedUsersInput = {
  coppaConsentEmail: Scalars['String']['input'];
  schoolId: Scalars['ID']['input'];
  students: Array<ManagedUserStudentInput>;
};

/** The result of the :bulk_create_managed_users mutation */
export type BulkCreateManagedUsersResult = {
  __typename?: 'BulkCreateManagedUsersResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<Array<ManagedUserCreateResult>>;
};

export type BulkSetLicenseAccessStatusInput = {
  ids: Array<Scalars['ID']['input']>;
  status: Scalars['String']['input'];
};

export type BulkStatusUpdateResult = {
  __typename?: 'BulkStatusUpdateResult';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ClassroomAssignment = {
  __typename?: 'ClassroomAssignment';
  assignmentId: Scalars['ID']['output'];
  assignmentType: Scalars['String']['output'];
  countOfQuestions: Scalars['Int']['output'];
  hasStarted?: Maybe<Scalars['Boolean']['output']>;
  hasStudentSubmitted?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  settings: ClassroomAssignmentSettings;
  studentAllowLateSubmissions: Scalars['Boolean']['output'];
  studentCorrectAnswerSetting: Scalars['String']['output'];
  studentCountOfCorrectGuesses: Scalars['Int']['output'];
  studentDueDate: Scalars['DateTime']['output'];
  studentPartialCreditEnabled: Scalars['Boolean']['output'];
  studentPartialCreditGrade?: Maybe<Scalars['Float']['output']>;
};

export type ClassroomAssignmentFilterAssignmentId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type ClassroomAssignmentFilterAssignmentType = {
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type ClassroomAssignmentFilterCountOfQuestions = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type ClassroomAssignmentFilterHasStarted = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClassroomAssignmentFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type ClassroomAssignmentFilterInput = {
  and?: InputMaybe<Array<ClassroomAssignmentFilterInput>>;
  assignmentId?: InputMaybe<ClassroomAssignmentFilterAssignmentId>;
  assignmentType?: InputMaybe<ClassroomAssignmentFilterAssignmentType>;
  countOfQuestions?: InputMaybe<ClassroomAssignmentFilterCountOfQuestions>;
  hasStarted?: InputMaybe<ClassroomAssignmentFilterHasStarted>;
  id?: InputMaybe<ClassroomAssignmentFilterId>;
  name?: InputMaybe<ClassroomAssignmentFilterName>;
  not?: InputMaybe<Array<ClassroomAssignmentFilterInput>>;
  or?: InputMaybe<Array<ClassroomAssignmentFilterInput>>;
  settings?: InputMaybe<ClassroomAssignmentFilterSettings>;
  studentAllowLateSubmissions?: InputMaybe<ClassroomAssignmentFilterStudentAllowLateSubmissions>;
  studentCorrectAnswerSetting?: InputMaybe<ClassroomAssignmentFilterStudentCorrectAnswerSetting>;
  studentCountOfCorrectGuesses?: InputMaybe<ClassroomAssignmentFilterStudentCountOfCorrectGuesses>;
  studentDueDate?: InputMaybe<ClassroomAssignmentFilterStudentDueDate>;
  studentPartialCreditEnabled?: InputMaybe<ClassroomAssignmentFilterStudentPartialCreditEnabled>;
};

export type ClassroomAssignmentFilterName = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type ClassroomAssignmentFilterSettings = {
  eq?: InputMaybe<ClassroomAssignmentSettingsInput>;
  greaterThan?: InputMaybe<ClassroomAssignmentSettingsInput>;
  greaterThanOrEqual?: InputMaybe<ClassroomAssignmentSettingsInput>;
  in?: InputMaybe<Array<ClassroomAssignmentSettingsInput>>;
  isDistinctFrom?: InputMaybe<ClassroomAssignmentSettingsInput>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<ClassroomAssignmentSettingsInput>;
  lessThan?: InputMaybe<ClassroomAssignmentSettingsInput>;
  lessThanOrEqual?: InputMaybe<ClassroomAssignmentSettingsInput>;
  notEq?: InputMaybe<ClassroomAssignmentSettingsInput>;
};

export type ClassroomAssignmentFilterStudentAllowLateSubmissions = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClassroomAssignmentFilterStudentCorrectAnswerSetting = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type ClassroomAssignmentFilterStudentCountOfCorrectGuesses = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type ClassroomAssignmentFilterStudentDueDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ClassroomAssignmentFilterStudentPartialCreditEnabled = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClassroomAssignmentSettings = {
  __typename?: 'ClassroomAssignmentSettings';
  allowLateSubmissions: Scalars['Boolean']['output'];
  autoAssignNewClassroomEnrollees?: Maybe<Scalars['Boolean']['output']>;
  correctAnswerSetting: Scalars['String']['output'];
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  lockdownModeEnabled: Scalars['Boolean']['output'];
  ltiLineItemId?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  partialCreditEnabled?: Maybe<Scalars['Boolean']['output']>;
  randomizeQuestionOrder?: Maybe<Scalars['Boolean']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  timeLimit?: Maybe<Scalars['Int']['output']>;
  translationAccess?: Maybe<Scalars['Boolean']['output']>;
};

export type ClassroomAssignmentSettingsInput = {
  allowLateSubmissions: Scalars['Boolean']['input'];
  autoAssignNewClassroomEnrollees?: InputMaybe<Scalars['Boolean']['input']>;
  correctAnswerSetting: Scalars['String']['input'];
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  lockdownModeEnabled: Scalars['Boolean']['input'];
  ltiLineItemId?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  partialCreditEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  randomizeQuestionOrder?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  timeLimit?: InputMaybe<Scalars['Int']['input']>;
  translationAccess?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ClassroomAssignmentSortField {
  AssignmentId = 'ASSIGNMENT_ID',
  AssignmentType = 'ASSIGNMENT_TYPE',
  CountOfQuestions = 'COUNT_OF_QUESTIONS',
  HasStarted = 'HAS_STARTED',
  Id = 'ID',
  Name = 'NAME',
  Settings = 'SETTINGS',
  StudentAllowLateSubmissions = 'STUDENT_ALLOW_LATE_SUBMISSIONS',
  StudentCorrectAnswerSetting = 'STUDENT_CORRECT_ANSWER_SETTING',
  StudentCountOfCorrectGuesses = 'STUDENT_COUNT_OF_CORRECT_GUESSES',
  StudentDueDate = 'STUDENT_DUE_DATE',
  StudentPartialCreditEnabled = 'STUDENT_PARTIAL_CREDIT_ENABLED'
}

export type ClassroomAssignmentSortInput = {
  field: ClassroomAssignmentSortField;
  order?: InputMaybe<SortOrder>;
};

export type ClassroomSkillPathConfig = {
  __typename?: 'ClassroomSkillPathConfig';
  classroom: ClassroomsClassroom;
  classroomId: Scalars['ID']['output'];
  guideLevel: GuideLevel;
  guideLevelId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  skillPathSettings: SkillPathSettings;
  skillPathSettingsId: Scalars['ID']['output'];
  unfilteredGuideLevel: GuideLevel;
};

export type ClassroomSkillPathConfigFilterClassroomId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type ClassroomSkillPathConfigFilterGuideLevelId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type ClassroomSkillPathConfigFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type ClassroomSkillPathConfigFilterInput = {
  and?: InputMaybe<Array<ClassroomSkillPathConfigFilterInput>>;
  classroom?: InputMaybe<ClassroomsClassroomFilterInput>;
  classroomId?: InputMaybe<ClassroomSkillPathConfigFilterClassroomId>;
  guideLevel?: InputMaybe<GuideLevelFilterInput>;
  guideLevelId?: InputMaybe<ClassroomSkillPathConfigFilterGuideLevelId>;
  id?: InputMaybe<ClassroomSkillPathConfigFilterId>;
  not?: InputMaybe<Array<ClassroomSkillPathConfigFilterInput>>;
  or?: InputMaybe<Array<ClassroomSkillPathConfigFilterInput>>;
  skillPathSettings?: InputMaybe<SkillPathSettingsFilterInput>;
  skillPathSettingsId?: InputMaybe<ClassroomSkillPathConfigFilterSkillPathSettingsId>;
  unfilteredGuideLevel?: InputMaybe<GuideLevelFilterInput>;
};

export type ClassroomSkillPathConfigFilterSkillPathSettingsId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export enum ClassroomSkillPathConfigSortField {
  ClassroomId = 'CLASSROOM_ID',
  GuideLevelId = 'GUIDE_LEVEL_ID',
  Id = 'ID',
  SkillPathSettingsId = 'SKILL_PATH_SETTINGS_ID'
}

export type ClassroomSkillPathConfigSortInput = {
  field: ClassroomSkillPathConfigSortField;
  order?: InputMaybe<SortOrder>;
};

export type ClassroomSubject = {
  __typename?: 'ClassroomSubject';
  classroom: ClassroomsClassroom;
  classroomId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  partialCreditEnabled?: Maybe<Scalars['Boolean']['output']>;
  restrictFreePractice?: Maybe<Scalars['Boolean']['output']>;
  subject: Subject;
  subjectId: Scalars['ID']['output'];
  unfilteredSubject: Subject;
};

export type ClassroomSubjectFilterClassroomId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type ClassroomSubjectFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type ClassroomSubjectFilterInput = {
  and?: InputMaybe<Array<ClassroomSubjectFilterInput>>;
  classroom?: InputMaybe<ClassroomsClassroomFilterInput>;
  classroomId?: InputMaybe<ClassroomSubjectFilterClassroomId>;
  id?: InputMaybe<ClassroomSubjectFilterId>;
  not?: InputMaybe<Array<ClassroomSubjectFilterInput>>;
  or?: InputMaybe<Array<ClassroomSubjectFilterInput>>;
  partialCreditEnabled?: InputMaybe<ClassroomSubjectFilterPartialCreditEnabled>;
  restrictFreePractice?: InputMaybe<ClassroomSubjectFilterRestrictFreePractice>;
  subject?: InputMaybe<SubjectFilterInput>;
  subjectId?: InputMaybe<ClassroomSubjectFilterSubjectId>;
  unfilteredSubject?: InputMaybe<SubjectFilterInput>;
};

export type ClassroomSubjectFilterPartialCreditEnabled = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClassroomSubjectFilterRestrictFreePractice = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClassroomSubjectFilterSubjectId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export enum ClassroomSubjectSortField {
  ClassroomId = 'CLASSROOM_ID',
  Id = 'ID',
  PartialCreditEnabled = 'PARTIAL_CREDIT_ENABLED',
  RestrictFreePractice = 'RESTRICT_FREE_PRACTICE',
  SubjectId = 'SUBJECT_ID'
}

export type ClassroomSubjectSortInput = {
  field: ClassroomSubjectSortField;
  order?: InputMaybe<SortOrder>;
};

export type ClassroomsClassroom = {
  __typename?: 'ClassroomsClassroom';
  classroomAssignments: Array<ClassroomAssignment>;
  id: Scalars['ID']['output'];
};


export type ClassroomsClassroomClassroomAssignmentsArgs = {
  filter?: InputMaybe<ClassroomAssignmentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ClassroomAssignmentSortInput>>>;
};

export type ClassroomsClassroomFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type ClassroomsClassroomFilterInput = {
  and?: InputMaybe<Array<ClassroomsClassroomFilterInput>>;
  classroomAssignments?: InputMaybe<ClassroomAssignmentFilterInput>;
  id?: InputMaybe<ClassroomsClassroomFilterId>;
  not?: InputMaybe<Array<ClassroomsClassroomFilterInput>>;
  or?: InputMaybe<Array<ClassroomsClassroomFilterInput>>;
};

export enum ClassroomsClassroomSortField {
  Id = 'ID'
}

export type ClassroomsClassroomSortInput = {
  field: ClassroomsClassroomSortField;
  order?: InputMaybe<SortOrder>;
};

/** The result of the :clear_lockdown_violations mutation */
export type ClearLockdownViolationsResult = {
  __typename?: 'ClearLockdownViolationsResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<StudentAssignment>;
};

export type ContainsRubric = {
  __typename?: 'ContainsRubric';
  validResponse: Scalars['JsonString']['output'];
};

export type ContainsRubricInput = {
  validResponse: Scalars['JsonString']['input'];
};

export type CreateCustomerFeedbackEntryInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  grade: Scalars['Int']['input'];
  urlSlug: Scalars['String']['input'];
};

/** The result of the :create_customer_feedback_entry mutation */
export type CreateCustomerFeedbackEntryResult = {
  __typename?: 'CreateCustomerFeedbackEntryResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<CustomerFeedbackEntry>;
};

export type CreateDistrictInput = {
  cleverId?: InputMaybe<Scalars['String']['input']>;
  county: Scalars['String']['input'];
  name: Scalars['String']['input'];
  ncesId?: InputMaybe<Scalars['String']['input']>;
  ncesLocale: NcesLocale;
  state?: InputMaybe<UsState>;
};

/** The result of the :create_district mutation */
export type CreateDistrictResult = {
  __typename?: 'CreateDistrictResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<District>;
};

export type CreateGuideInput = {
  name: Scalars['String']['input'];
  published?: InputMaybe<Scalars['Boolean']['input']>;
  subjectId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

/** The result of the :create_guide mutation */
export type CreateGuideResult = {
  __typename?: 'CreateGuideResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<Guide>;
};

export type CreateQuestionInput = {
  answerBreakdown?: InputMaybe<Scalars['JsonString']['input']>;
  authorId: Scalars['ID']['input'];
  chainPath?: InputMaybe<Scalars['Json']['input']>;
  difficulty?: InputMaybe<Scalars['Int']['input']>;
  guideLevel?: InputMaybe<Scalars['ID']['input']>;
  legacyQuestionSetSlugId: Scalars['String']['input'];
  ownerId: Scalars['ID']['input'];
  prompt?: InputMaybe<Scalars['String']['input']>;
  rubric: RubricInput;
  slugId?: InputMaybe<Scalars['String']['input']>;
  solutionText?: InputMaybe<Scalars['String']['input']>;
  standards?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<Scalars['String']['input']>;
  subjectId: Scalars['ID']['input'];
  tags?: InputMaybe<Array<Scalars['ID']['input']>>;
  title: Scalars['String']['input'];
  translate?: InputMaybe<Scalars['Boolean']['input']>;
  translateSupplements?: InputMaybe<Scalars['Boolean']['input']>;
  typeAttributes: QuestionTypeAttributesInput;
};

/** The result of the :create_question mutation */
export type CreateQuestionResult = {
  __typename?: 'CreateQuestionResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<Question>;
};

export type CreateSubjectFaqInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  subjectId: Scalars['ID']['input'];
};

/** The result of the :create_subject_faq mutation */
export type CreateSubjectFaqResult = {
  __typename?: 'CreateSubjectFaqResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<SubjectFaq>;
};

export type CreateSubjectInput = {
  adaptive: Scalars['Boolean']['input'];
  alternateName?: InputMaybe<Scalars['String']['input']>;
  badge?: InputMaybe<Scalars['String']['input']>;
  banner?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  curriculumAreaId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  domain: Scalars['String']['input'];
  featuredAs?: InputMaybe<Scalars['String']['input']>;
  footerText?: InputMaybe<Scalars['String']['input']>;
  freeResponseQuestionsPublished: Scalars['Boolean']['input'];
  group?: InputMaybe<Scalars['String']['input']>;
  hidden: Scalars['Boolean']['input'];
  logoImageUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  published: Scalars['Boolean']['input'];
  shouldShowLabelTable: Scalars['Boolean']['input'];
  subscriptionsPrices?: InputMaybe<Array<Scalars['JsonString']['input']>>;
  translateQuestions: Scalars['Boolean']['input'];
  translateSupplements: Scalars['Boolean']['input'];
  urlSlug: Scalars['String']['input'];
};

/** The result of the :create_subject mutation */
export type CreateSubjectResult = {
  __typename?: 'CreateSubjectResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<Subject>;
};

export type CreateSubscriptionInput = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  subjectId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

/** The result of the :create_subscription mutation */
export type CreateSubscriptionResult = {
  __typename?: 'CreateSubscriptionResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<RetailSubscription>;
};

export type CreateSupplementInput = {
  content: SupplementContentInput;
  name: Scalars['String']['input'];
  subjectId: Scalars['ID']['input'];
  translate?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of the :create_supplement mutation */
export type CreateSupplementResult = {
  __typename?: 'CreateSupplementResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<Supplement>;
};

export type CreateUserFeedbackInput = {
  comment: Scalars['String']['input'];
  feedbackType: UserFeedbackType;
  questionId: Scalars['ID']['input'];
  reportedDevice?: InputMaybe<UserFeedbackReportedDevice>;
  userAgent?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

/** The result of the :create_user_feedback mutation */
export type CreateUserFeedbackResult = {
  __typename?: 'CreateUserFeedbackResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<UserFeedback>;
};

export type CreateUserInput = {
  cleverId?: InputMaybe<Scalars['String']['input']>;
  /** The user's content preferences for suggested content */
  contentPreferences?: InputMaybe<Scalars['JsonString']['input']>;
  coppaConsentEmail?: InputMaybe<Scalars['String']['input']>;
  customerFeedbackReminderDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The user's email address */
  email: Scalars['String']['input'];
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  isAuthor?: InputMaybe<Scalars['Boolean']['input']>;
  isSchoolAdministrator?: InputMaybe<Scalars['Boolean']['input']>;
  isTeacher?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  ltiId?: InputMaybe<Scalars['String']['input']>;
  needsCoppa?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of completed onboarding steps for the user */
  onboardingSteps?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The user's password hash */
  password: Scalars['String']['input'];
  salutation?: InputMaybe<Scalars['String']['input']>;
  schoolId?: InputMaybe<Scalars['ID']['input']>;
  signUpMethod?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subjectAuthors?: InputMaybe<Array<UserCreateSubjectAuthorsInput>>;
  /** The user's username */
  username: Scalars['String']['input'];
};

/** The result of the :create_user mutation */
export type CreateUserResult = {
  __typename?: 'CreateUserResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<User>;
};

export type CurriculumArea = {
  __typename?: 'CurriculumArea';
  color: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CurriculumAreaFilterColor = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type CurriculumAreaFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type CurriculumAreaFilterInput = {
  and?: InputMaybe<Array<CurriculumAreaFilterInput>>;
  color?: InputMaybe<CurriculumAreaFilterColor>;
  id?: InputMaybe<CurriculumAreaFilterId>;
  name?: InputMaybe<CurriculumAreaFilterName>;
  not?: InputMaybe<Array<CurriculumAreaFilterInput>>;
  or?: InputMaybe<Array<CurriculumAreaFilterInput>>;
};

export type CurriculumAreaFilterName = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export enum CurriculumAreaSortField {
  Color = 'COLOR',
  Id = 'ID',
  Name = 'NAME'
}

export type CurriculumAreaSortInput = {
  field: CurriculumAreaSortField;
  order?: InputMaybe<SortOrder>;
};

export type CustomerFeedbackEntry = {
  __typename?: 'CustomerFeedbackEntry';
  comment?: Maybe<Scalars['String']['output']>;
  grade: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  urlSlug: Scalars['String']['output'];
  user: User;
  userId: Scalars['ID']['output'];
};

export type DeleteRecipientGroupsInput = {
  skillPathSettingsIds: Array<Scalars['ID']['input']>;
};

/** The result of the :delete_subscription mutation */
export type DeleteSubscriptionResult = {
  __typename?: 'DeleteSubscriptionResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The record that was successfully deleted */
  result?: Maybe<RetailSubscription>;
};

/** The result of the :destroy_district mutation */
export type DestroyDistrictResult = {
  __typename?: 'DestroyDistrictResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The record that was successfully deleted */
  result?: Maybe<District>;
};

/** The result of the :destroy_guide mutation */
export type DestroyGuideResult = {
  __typename?: 'DestroyGuideResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The record that was successfully deleted */
  result?: Maybe<Guide>;
};

/** The result of the :destroy_subject_faq mutation */
export type DestroySubjectFaqResult = {
  __typename?: 'DestroySubjectFaqResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The record that was successfully deleted */
  result?: Maybe<SubjectFaq>;
};

/** The result of the :destroy_subject mutation */
export type DestroySubjectResult = {
  __typename?: 'DestroySubjectResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The record that was successfully deleted */
  result?: Maybe<Subject>;
};

/** The result of the :destroy_upgrade mutation */
export type DestroyUpgradeResult = {
  __typename?: 'DestroyUpgradeResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The record that was successfully deleted */
  result?: Maybe<Upgrade>;
};

/** The result of the :destroy_user_feedback mutation */
export type DestroyUserFeedbackResult = {
  __typename?: 'DestroyUserFeedbackResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The record that was successfully deleted */
  result?: Maybe<UserFeedback>;
};

export type District = {
  __typename?: 'District';
  cleverId?: Maybe<Scalars['String']['output']>;
  county: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  ncesId?: Maybe<Scalars['String']['output']>;
  ncesLocale: NcesLocale;
  state?: Maybe<UsState>;
};

export type DistrictFilterCleverId = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type DistrictFilterCounty = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type DistrictFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type DistrictFilterInput = {
  and?: InputMaybe<Array<DistrictFilterInput>>;
  cleverId?: InputMaybe<DistrictFilterCleverId>;
  county?: InputMaybe<DistrictFilterCounty>;
  id?: InputMaybe<DistrictFilterId>;
  name?: InputMaybe<DistrictFilterName>;
  ncesId?: InputMaybe<DistrictFilterNcesId>;
  ncesLocale?: InputMaybe<DistrictFilterNcesLocale>;
  not?: InputMaybe<Array<DistrictFilterInput>>;
  or?: InputMaybe<Array<DistrictFilterInput>>;
  state?: InputMaybe<DistrictFilterState>;
};

export type DistrictFilterName = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type DistrictFilterNcesId = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type DistrictFilterNcesLocale = {
  eq?: InputMaybe<NcesLocale>;
  greaterThan?: InputMaybe<NcesLocale>;
  greaterThanOrEqual?: InputMaybe<NcesLocale>;
  in?: InputMaybe<Array<NcesLocale>>;
  isDistinctFrom?: InputMaybe<NcesLocale>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<NcesLocale>;
  lessThan?: InputMaybe<NcesLocale>;
  lessThanOrEqual?: InputMaybe<NcesLocale>;
  notEq?: InputMaybe<NcesLocale>;
};

export type DistrictFilterState = {
  eq?: InputMaybe<UsState>;
  greaterThan?: InputMaybe<UsState>;
  greaterThanOrEqual?: InputMaybe<UsState>;
  in?: InputMaybe<Array<InputMaybe<UsState>>>;
  isDistinctFrom?: InputMaybe<UsState>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<UsState>;
  lessThan?: InputMaybe<UsState>;
  lessThanOrEqual?: InputMaybe<UsState>;
  notEq?: InputMaybe<UsState>;
};

export enum DistrictSortField {
  CleverId = 'CLEVER_ID',
  County = 'COUNTY',
  Id = 'ID',
  Name = 'NAME',
  NcesId = 'NCES_ID',
  NcesLocale = 'NCES_LOCALE',
  State = 'STATE'
}

export type DistrictSortInput = {
  field: DistrictSortField;
  order?: InputMaybe<SortOrder>;
};

export type EditableRegionsRubric = {
  __typename?: 'EditableRegionsRubric';
  validResponse: Scalars['Json']['output'];
};

export type EditableRegionsRubricInput = {
  validResponse: Scalars['Json']['input'];
};

export type ExactRubric = {
  __typename?: 'ExactRubric';
  validResponse: Scalars['Json']['output'];
};

export type ExactRubricInput = {
  validResponse: Scalars['Json']['input'];
};

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type FreeFormSupplementContent = {
  __typename?: 'FreeFormSupplementContent';
  text: Scalars['String']['output'];
};

export type FreeFormSupplementContentInput = {
  text: Scalars['String']['input'];
};

export type GradeLevel = {
  __typename?: 'GradeLevel';
  gradeLevelType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** A zero padded version of the grade level type for sorting purposes. */
  paddedGradeLevelType?: Maybe<Scalars['String']['output']>;
};

export type GradeLevelFilterGradeLevelType = {
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type GradeLevelFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type GradeLevelFilterInput = {
  and?: InputMaybe<Array<GradeLevelFilterInput>>;
  gradeLevelType?: InputMaybe<GradeLevelFilterGradeLevelType>;
  id?: InputMaybe<GradeLevelFilterId>;
  not?: InputMaybe<Array<GradeLevelFilterInput>>;
  or?: InputMaybe<Array<GradeLevelFilterInput>>;
  /** A zero padded version of the grade level type for sorting purposes. */
  paddedGradeLevelType?: InputMaybe<GradeLevelFilterPaddedGradeLevelType>;
};

export type GradeLevelFilterPaddedGradeLevelType = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export enum GradeLevelSortField {
  GradeLevelType = 'GRADE_LEVEL_TYPE',
  Id = 'ID',
  PaddedGradeLevelType = 'PADDED_GRADE_LEVEL_TYPE'
}

export type GradeLevelSortInput = {
  field: GradeLevelSortField;
  order?: InputMaybe<SortOrder>;
};

export type GraphContainsEntity = {
  __typename?: 'GraphContainsEntity';
  elements: Scalars['JsonString']['output'];
  type: Scalars['String']['output'];
};

export type GraphContainsEntityInput = {
  elements: Scalars['JsonString']['input'];
  type: Scalars['String']['input'];
};

export type GraphContainsRubric = {
  __typename?: 'GraphContainsRubric';
  validResponse: Array<Maybe<GraphContainsRubricValidResponseItem>>;
};

export type GraphContainsRubricAttributes = {
  __typename?: 'GraphContainsRubricAttributes';
  inclusive?: Maybe<Scalars['Boolean']['output']>;
};

export type GraphContainsRubricAttributesInput = {
  inclusive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GraphContainsRubricCorrectAnswerSettings = {
  __typename?: 'GraphContainsRubricCorrectAnswerSettings';
  centerPoint?: Maybe<Scalars['Boolean']['output']>;
  direction?: Maybe<Scalars['Boolean']['output']>;
  exact?: Maybe<Scalars['Boolean']['output']>;
  inclusive?: Maybe<Scalars['Boolean']['output']>;
  length?: Maybe<Scalars['Boolean']['output']>;
  radiusLength?: Maybe<Scalars['Boolean']['output']>;
  slope?: Maybe<Scalars['Boolean']['output']>;
  startingPoint?: Maybe<Scalars['Boolean']['output']>;
  yIntercept?: Maybe<Scalars['Boolean']['output']>;
};

export type GraphContainsRubricCorrectAnswerSettingsInput = {
  centerPoint?: InputMaybe<Scalars['Boolean']['input']>;
  direction?: InputMaybe<Scalars['Boolean']['input']>;
  exact?: InputMaybe<Scalars['Boolean']['input']>;
  inclusive?: InputMaybe<Scalars['Boolean']['input']>;
  length?: InputMaybe<Scalars['Boolean']['input']>;
  radiusLength?: InputMaybe<Scalars['Boolean']['input']>;
  slope?: InputMaybe<Scalars['Boolean']['input']>;
  startingPoint?: InputMaybe<Scalars['Boolean']['input']>;
  yIntercept?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GraphContainsRubricGraphElement = {
  __typename?: 'GraphContainsRubricGraphElement';
  center?: Maybe<Scalars['Json']['output']>;
  curvePoint?: Maybe<Scalars['Json']['output']>;
  point?: Maybe<Scalars['Json']['output']>;
  points?: Maybe<Array<Scalars['Json']['output']>>;
  radiusPoint?: Maybe<Scalars['Json']['output']>;
  vertex?: Maybe<Scalars['Json']['output']>;
};

export type GraphContainsRubricGraphElementInput = {
  center?: InputMaybe<Scalars['Json']['input']>;
  curvePoint?: InputMaybe<Scalars['Json']['input']>;
  point?: InputMaybe<Scalars['Json']['input']>;
  points?: InputMaybe<Array<Scalars['Json']['input']>>;
  radiusPoint?: InputMaybe<Scalars['Json']['input']>;
  vertex?: InputMaybe<Scalars['Json']['input']>;
};

export type GraphContainsRubricInput = {
  validResponse: Array<InputMaybe<GraphContainsRubricValidResponseItemInput>>;
};

export type GraphContainsRubricValidResponseItem = {
  __typename?: 'GraphContainsRubricValidResponseItem';
  attributes?: Maybe<GraphContainsRubricAttributes>;
  correctAnswerSettings: GraphContainsRubricCorrectAnswerSettings;
  elements: GraphContainsRubricGraphElement;
  type: Scalars['String']['output'];
};

export type GraphContainsRubricValidResponseItemInput = {
  attributes?: InputMaybe<GraphContainsRubricAttributesInput>;
  correctAnswerSettings: GraphContainsRubricCorrectAnswerSettingsInput;
  elements: GraphContainsRubricGraphElementInput;
  type: Scalars['String']['input'];
};

export type Guess = {
  __typename?: 'Guess';
  /** When a guess was placed and or updated. Updates refer only to content changes. */
  answeredAt: Scalars['DateTime']['output'];
  correct?: Maybe<Scalars['Boolean']['output']>;
  grade?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type GuessFilterAnsweredAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GuessFilterCorrect = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GuessFilterGrade = {
  eq?: InputMaybe<Scalars['Decimal']['input']>;
  greaterThan?: InputMaybe<Scalars['Decimal']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Decimal']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Decimal']['input']>;
  lessThan?: InputMaybe<Scalars['Decimal']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Decimal']['input']>;
  notEq?: InputMaybe<Scalars['Decimal']['input']>;
};

export type GuessFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type GuessFilterInput = {
  and?: InputMaybe<Array<GuessFilterInput>>;
  /** When a guess was placed and or updated. Updates refer only to content changes. */
  answeredAt?: InputMaybe<GuessFilterAnsweredAt>;
  correct?: InputMaybe<GuessFilterCorrect>;
  grade?: InputMaybe<GuessFilterGrade>;
  id?: InputMaybe<GuessFilterId>;
  insertedAt?: InputMaybe<GuessFilterInsertedAt>;
  not?: InputMaybe<Array<GuessFilterInput>>;
  or?: InputMaybe<Array<GuessFilterInput>>;
  updatedAt?: InputMaybe<GuessFilterUpdatedAt>;
};

export type GuessFilterInsertedAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GuessFilterUpdatedAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum GuessSortField {
  AnsweredAt = 'ANSWERED_AT',
  Correct = 'CORRECT',
  Grade = 'GRADE',
  Id = 'ID',
  InsertedAt = 'INSERTED_AT',
  UpdatedAt = 'UPDATED_AT'
}

export type GuessSortInput = {
  field: GuessSortField;
  order?: InputMaybe<SortOrder>;
};

export type Guide = {
  __typename?: 'Guide';
  abQuestionCount?: Maybe<Scalars['Int']['output']>;
  allSkills: Array<GuideLevel>;
  guideLevels: Array<GuideLevel>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  published: Scalars['Boolean']['output'];
  subject: Subject;
  subjectId: Scalars['ID']['output'];
  tags: Array<Tag>;
  toDoSkills: Array<GuideLevel>;
  type: Scalars['String']['output'];
  unfilteredGuideLevels: Array<GuideLevel>;
  unfilteredSubject: Subject;
};


export type GuideAbQuestionCountArgs = {
  guideLevels?: InputMaybe<Array<Scalars['ID']['input']>>;
  hideAssessmentQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  hidePreviouslyAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  questionDifficulties?: InputMaybe<Array<Scalars['Int']['input']>>;
  questionTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  standardSets?: InputMaybe<Array<Scalars['ID']['input']>>;
  standards?: InputMaybe<Array<Scalars['ID']['input']>>;
  subjects?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type GuideAllSkillsArgs = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  filter?: InputMaybe<GuideLevelFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuideLevelSortInput>>>;
};


export type GuideGuideLevelsArgs = {
  filter?: InputMaybe<GuideLevelFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuideLevelSortInput>>>;
};


export type GuideTagsArgs = {
  filter?: InputMaybe<TagFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TagSortInput>>>;
};


export type GuideToDoSkillsArgs = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  filter?: InputMaybe<GuideLevelFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  recencyRange?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuideLevelSortInput>>>;
};


export type GuideUnfilteredGuideLevelsArgs = {
  filter?: InputMaybe<GuideLevelFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuideLevelSortInput>>>;
};

export type GuideAbQuestionCountFieldInput = {
  guideLevels?: InputMaybe<Array<Scalars['ID']['input']>>;
  hideAssessmentQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  hidePreviouslyAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  questionDifficulties?: InputMaybe<Array<Scalars['Int']['input']>>;
  questionTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  standardSets?: InputMaybe<Array<Scalars['ID']['input']>>;
  standards?: InputMaybe<Array<Scalars['ID']['input']>>;
  subjects?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GuideFilterAbQuestionCount = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  input?: InputMaybe<GuideAbQuestionCountFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type GuideFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type GuideFilterInput = {
  abQuestionCount?: InputMaybe<GuideFilterAbQuestionCount>;
  allSkills?: InputMaybe<GuideLevelFilterInput>;
  and?: InputMaybe<Array<GuideFilterInput>>;
  guideLevels?: InputMaybe<GuideLevelFilterInput>;
  id?: InputMaybe<GuideFilterId>;
  name?: InputMaybe<GuideFilterName>;
  not?: InputMaybe<Array<GuideFilterInput>>;
  or?: InputMaybe<Array<GuideFilterInput>>;
  published?: InputMaybe<GuideFilterPublished>;
  subject?: InputMaybe<SubjectFilterInput>;
  subjectId?: InputMaybe<GuideFilterSubjectId>;
  tags?: InputMaybe<TagFilterInput>;
  toDoSkills?: InputMaybe<GuideLevelFilterInput>;
  type?: InputMaybe<GuideFilterType>;
  unfilteredGuideLevels?: InputMaybe<GuideLevelFilterInput>;
  unfilteredSubject?: InputMaybe<SubjectFilterInput>;
};

export type GuideFilterName = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type GuideFilterPublished = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GuideFilterSubjectId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type GuideFilterType = {
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type GuideLevel = {
  __typename?: 'GuideLevel';
  abQuestionCount?: Maybe<Scalars['Int']['output']>;
  /**
   * The adaptive advance threshold setting for this guide level, if any.
   * This is only the stored value. Clients should only use this directly in an authoring context.
   * Use the `effective_adaptive_advance_threshold` calculation to get the effective threshold for a user, which
   * falls back to ancestors if not set on this level.
   */
  adaptiveAdvanceThreshold?: Maybe<Scalars['Int']['output']>;
  /**
   * Seconds from now to the most relevant date for sort ordering.
   * NOTE: This duplicates the definitions for `nearest_skill_path_due_date` and `most_recent_practice_date`
   */
  adaptiveDateProximity?: Maybe<Scalars['Int']['output']>;
  /**
   * The adaptive fallback threshold setting for this guide level, if any.
   * This is only the stored value. Clients should only use this directly in an authoring context.
   * Use the `effective_adaptive_fallback_threshold` calculation to get the effective threshold for a user, which
   * falls back to ancestors if not set on this level.
   */
  adaptiveFallbackThreshold?: Maybe<Scalars['Int']['output']>;
  /**
   * The adaptive range setting for this guide level, if any.
   * This is only the stored value. Clients should only use this directly in an authoring context.
   * Use the `effective_adaptive_range` calculation to get the effective range for a user, which
   * falls back to ancestors if not set on this level.
   */
  adaptiveRange?: Maybe<Scalars['Int']['output']>;
  children: Array<GuideLevel>;
  code?: Maybe<Scalars['String']['output']>;
  comingSoon: Scalars['Boolean']['output'];
  countChildren: Scalars['Int']['output'];
  countMatchingQuestions?: Maybe<Scalars['Int']['output']>;
  countOfQuestions?: Maybe<Scalars['Int']['output']>;
  countStandards: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** The guide level's adaptive_advance_threshold value, or the closest ancestor's adaptive_advance_threshold value if none is set, or the default if no ancestor has it set */
  effectiveAdaptiveAdvanceThreshold?: Maybe<Scalars['Int']['output']>;
  /** The guide level's adaptive_fallback_threshold value, or the closest ancestor's adaptive_fallback_threshold value if none is set, or the default if no ancestor has it set */
  effectiveAdaptiveFallbackThreshold?: Maybe<Scalars['Int']['output']>;
  /** The guide level's adaptive_range value, or the closest ancestor's adaptive_range value if none is set, or the default if no ancestor has it set */
  effectiveAdaptiveRange?: Maybe<Scalars['Int']['output']>;
  /** The effective coming_soon value for this guide level, which is true if this level or any ancestor has coming_soon = true */
  effectiveComingSoon?: Maybe<Scalars['Boolean']['output']>;
  /** The effective published value for this guide level, which is true if this level and all ancestors are published */
  effectivePublished?: Maybe<Scalars['Boolean']['output']>;
  free: Scalars['Boolean']['output'];
  guide: Guide;
  guideId: Scalars['ID']['output'];
  hasQuestions?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** Whether the student has practiced this skill independently (not on their skill path) and hasn't mastered it */
  independentAdaptivePractice?: Maybe<Scalars['Boolean']['output']>;
  level?: Maybe<Scalars['Json']['output']>;
  /** Whether the guide level matches the given search term. Search fields may be any of name, code, description. Defaults to name and code. */
  matchesSearch?: Maybe<Scalars['Boolean']['output']>;
  /** Date at which student most recently placed a guess for this skill */
  mostRecentPracticeDate?: Maybe<Scalars['DateTime']['output']>;
  /** The student's most recent proficiency level for this skill */
  myCurrentProficiencyLevel?: Maybe<Scalars['Int']['output']>;
  /**
   * Delegate to `my_skill_path_proficiency_level` or `my_current_skill_path_level`
   * based on whether the skill is on the student's skill path.
   */
  myProficiencyLevel?: Maybe<Scalars['Int']['output']>;
  /**
   * The student's highest proficiency level for this skill across all active settings on their skill path.
   * Uses the earliest start_date among competing settings. If any setting has no start_date, considers all practices.
   */
  mySkillPathProficiencyLevel?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  /** Nearest due date to now (past or future) across active settings for this skill on the student's skill path */
  nearestSkillPathDueDate?: Maybe<Scalars['DateTime']['output']>;
  nlevel?: Maybe<Scalars['Int']['output']>;
  /** Whether this skill is on the current student's skill path */
  onSkillPath?: Maybe<Scalars['Boolean']['output']>;
  /** Whether any of the current teacher's classrooms have students with this skill on their skill path, or have a skill path config for this skill */
  onStudentsSkillPaths?: Maybe<Scalars['Boolean']['output']>;
  parent?: Maybe<GuideLevel>;
  parentId?: Maybe<Scalars['ID']['output']>;
  position: Scalars['Int']['output'];
  published: Scalars['Boolean']['output'];
  standards: Array<Standard>;
  subject: Subject;
  subjectId: Scalars['ID']['output'];
  themeImg?: Maybe<Scalars['String']['output']>;
  unfilteredAncestors: Array<GuideLevel>;
  unfilteredChildren: Array<GuideLevel>;
  unfilteredCountChildren: Scalars['Int']['output'];
  unfilteredDescendants: Array<GuideLevel>;
  unfilteredParent?: Maybe<GuideLevel>;
  unfilteredSubject: Subject;
  urlSlug?: Maybe<Scalars['String']['output']>;
};


export type GuideLevelAbQuestionCountArgs = {
  guideLevels?: InputMaybe<Array<Scalars['ID']['input']>>;
  hideAssessmentQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  hidePreviouslyAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  questionDifficulties?: InputMaybe<Array<Scalars['Int']['input']>>;
  questionTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  standardSets?: InputMaybe<Array<Scalars['ID']['input']>>;
  standards?: InputMaybe<Array<Scalars['ID']['input']>>;
  subjects?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type GuideLevelAdaptiveDateProximityArgs = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type GuideLevelChildrenArgs = {
  filter?: InputMaybe<GuideLevelFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuideLevelSortInput>>>;
};


export type GuideLevelCountMatchingQuestionsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  standardIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type GuideLevelIndependentAdaptivePracticeArgs = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type GuideLevelMatchesSearchArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  searchFields?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type GuideLevelMyProficiencyLevelArgs = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type GuideLevelMySkillPathProficiencyLevelArgs = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type GuideLevelNearestSkillPathDueDateArgs = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type GuideLevelOnSkillPathArgs = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type GuideLevelStandardsArgs = {
  filter?: InputMaybe<StandardFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<StandardSortInput>>>;
};


export type GuideLevelUnfilteredAncestorsArgs = {
  filter?: InputMaybe<GuideLevelFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuideLevelSortInput>>>;
};


export type GuideLevelUnfilteredChildrenArgs = {
  filter?: InputMaybe<GuideLevelFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuideLevelSortInput>>>;
};


export type GuideLevelUnfilteredDescendantsArgs = {
  filter?: InputMaybe<GuideLevelFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuideLevelSortInput>>>;
};

export type GuideLevelAbQuestionCountFieldInput = {
  guideLevels?: InputMaybe<Array<Scalars['ID']['input']>>;
  hideAssessmentQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  hidePreviouslyAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  questionDifficulties?: InputMaybe<Array<Scalars['Int']['input']>>;
  questionTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  standardSets?: InputMaybe<Array<Scalars['ID']['input']>>;
  standards?: InputMaybe<Array<Scalars['ID']['input']>>;
  subjects?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GuideLevelAdaptiveDateProximityFieldInput = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GuideLevelCountMatchingQuestionsFieldInput = {
  search?: InputMaybe<Scalars['String']['input']>;
  standardIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GuideLevelFilterAbQuestionCount = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  input?: InputMaybe<GuideLevelAbQuestionCountFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type GuideLevelFilterAdaptiveAdvanceThreshold = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type GuideLevelFilterAdaptiveDateProximity = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  input?: InputMaybe<GuideLevelAdaptiveDateProximityFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type GuideLevelFilterAdaptiveFallbackThreshold = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type GuideLevelFilterAdaptiveRange = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type GuideLevelFilterCode = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type GuideLevelFilterComingSoon = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GuideLevelFilterCountChildren = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type GuideLevelFilterCountMatchingQuestions = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  input?: InputMaybe<GuideLevelCountMatchingQuestionsFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type GuideLevelFilterCountOfQuestions = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type GuideLevelFilterCountStandards = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type GuideLevelFilterDescription = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type GuideLevelFilterEffectiveAdaptiveAdvanceThreshold = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type GuideLevelFilterEffectiveAdaptiveFallbackThreshold = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type GuideLevelFilterEffectiveAdaptiveRange = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type GuideLevelFilterEffectiveComingSoon = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GuideLevelFilterEffectivePublished = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GuideLevelFilterFree = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GuideLevelFilterGuideId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type GuideLevelFilterHasQuestions = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GuideLevelFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type GuideLevelFilterIndependentAdaptivePractice = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  input?: InputMaybe<GuideLevelIndependentAdaptivePracticeFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GuideLevelFilterInput = {
  abQuestionCount?: InputMaybe<GuideLevelFilterAbQuestionCount>;
  /**
   * The adaptive advance threshold setting for this guide level, if any.
   * This is only the stored value. Clients should only use this directly in an authoring context.
   * Use the `effective_adaptive_advance_threshold` calculation to get the effective threshold for a user, which
   * falls back to ancestors if not set on this level.
   */
  adaptiveAdvanceThreshold?: InputMaybe<GuideLevelFilterAdaptiveAdvanceThreshold>;
  /**
   * Seconds from now to the most relevant date for sort ordering.
   * NOTE: This duplicates the definitions for `nearest_skill_path_due_date` and `most_recent_practice_date`
   */
  adaptiveDateProximity?: InputMaybe<GuideLevelFilterAdaptiveDateProximity>;
  /**
   * The adaptive fallback threshold setting for this guide level, if any.
   * This is only the stored value. Clients should only use this directly in an authoring context.
   * Use the `effective_adaptive_fallback_threshold` calculation to get the effective threshold for a user, which
   * falls back to ancestors if not set on this level.
   */
  adaptiveFallbackThreshold?: InputMaybe<GuideLevelFilterAdaptiveFallbackThreshold>;
  /**
   * The adaptive range setting for this guide level, if any.
   * This is only the stored value. Clients should only use this directly in an authoring context.
   * Use the `effective_adaptive_range` calculation to get the effective range for a user, which
   * falls back to ancestors if not set on this level.
   */
  adaptiveRange?: InputMaybe<GuideLevelFilterAdaptiveRange>;
  and?: InputMaybe<Array<GuideLevelFilterInput>>;
  children?: InputMaybe<GuideLevelFilterInput>;
  code?: InputMaybe<GuideLevelFilterCode>;
  comingSoon?: InputMaybe<GuideLevelFilterComingSoon>;
  countChildren?: InputMaybe<GuideLevelFilterCountChildren>;
  countMatchingQuestions?: InputMaybe<GuideLevelFilterCountMatchingQuestions>;
  countOfQuestions?: InputMaybe<GuideLevelFilterCountOfQuestions>;
  countStandards?: InputMaybe<GuideLevelFilterCountStandards>;
  description?: InputMaybe<GuideLevelFilterDescription>;
  /** The guide level's adaptive_advance_threshold value, or the closest ancestor's adaptive_advance_threshold value if none is set, or the default if no ancestor has it set */
  effectiveAdaptiveAdvanceThreshold?: InputMaybe<GuideLevelFilterEffectiveAdaptiveAdvanceThreshold>;
  /** The guide level's adaptive_fallback_threshold value, or the closest ancestor's adaptive_fallback_threshold value if none is set, or the default if no ancestor has it set */
  effectiveAdaptiveFallbackThreshold?: InputMaybe<GuideLevelFilterEffectiveAdaptiveFallbackThreshold>;
  /** The guide level's adaptive_range value, or the closest ancestor's adaptive_range value if none is set, or the default if no ancestor has it set */
  effectiveAdaptiveRange?: InputMaybe<GuideLevelFilterEffectiveAdaptiveRange>;
  /** The effective coming_soon value for this guide level, which is true if this level or any ancestor has coming_soon = true */
  effectiveComingSoon?: InputMaybe<GuideLevelFilterEffectiveComingSoon>;
  /** The effective published value for this guide level, which is true if this level and all ancestors are published */
  effectivePublished?: InputMaybe<GuideLevelFilterEffectivePublished>;
  free?: InputMaybe<GuideLevelFilterFree>;
  guide?: InputMaybe<GuideFilterInput>;
  guideId?: InputMaybe<GuideLevelFilterGuideId>;
  hasQuestions?: InputMaybe<GuideLevelFilterHasQuestions>;
  id?: InputMaybe<GuideLevelFilterId>;
  /** Whether the student has practiced this skill independently (not on their skill path) and hasn't mastered it */
  independentAdaptivePractice?: InputMaybe<GuideLevelFilterIndependentAdaptivePractice>;
  level?: InputMaybe<GuideLevelFilterLevel>;
  /** Whether the guide level matches the given search term. Search fields may be any of name, code, description. Defaults to name and code. */
  matchesSearch?: InputMaybe<GuideLevelFilterMatchesSearch>;
  /** Date at which student most recently placed a guess for this skill */
  mostRecentPracticeDate?: InputMaybe<GuideLevelFilterMostRecentPracticeDate>;
  /** The student's most recent proficiency level for this skill */
  myCurrentProficiencyLevel?: InputMaybe<GuideLevelFilterMyCurrentProficiencyLevel>;
  name?: InputMaybe<GuideLevelFilterName>;
  /** Nearest due date to now (past or future) across active settings for this skill on the student's skill path */
  nearestSkillPathDueDate?: InputMaybe<GuideLevelFilterNearestSkillPathDueDate>;
  nlevel?: InputMaybe<GuideLevelFilterNlevel>;
  not?: InputMaybe<Array<GuideLevelFilterInput>>;
  /** Whether this skill is on the current student's skill path */
  onSkillPath?: InputMaybe<GuideLevelFilterOnSkillPath>;
  /** Whether any of the current teacher's classrooms have students with this skill on their skill path, or have a skill path config for this skill */
  onStudentsSkillPaths?: InputMaybe<GuideLevelFilterOnStudentsSkillPaths>;
  or?: InputMaybe<Array<GuideLevelFilterInput>>;
  parent?: InputMaybe<GuideLevelFilterInput>;
  parentId?: InputMaybe<GuideLevelFilterParentId>;
  position?: InputMaybe<GuideLevelFilterPosition>;
  published?: InputMaybe<GuideLevelFilterPublished>;
  standards?: InputMaybe<StandardFilterInput>;
  subject?: InputMaybe<SubjectFilterInput>;
  subjectId?: InputMaybe<GuideLevelFilterSubjectId>;
  themeImg?: InputMaybe<GuideLevelFilterThemeImg>;
  unfilteredAncestors?: InputMaybe<GuideLevelFilterInput>;
  unfilteredChildren?: InputMaybe<GuideLevelFilterInput>;
  unfilteredCountChildren?: InputMaybe<GuideLevelFilterUnfilteredCountChildren>;
  unfilteredDescendants?: InputMaybe<GuideLevelFilterInput>;
  unfilteredParent?: InputMaybe<GuideLevelFilterInput>;
  unfilteredSubject?: InputMaybe<SubjectFilterInput>;
  urlSlug?: InputMaybe<GuideLevelFilterUrlSlug>;
};

export type GuideLevelFilterLevel = {
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GuideLevelFilterMatchesSearch = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  input?: InputMaybe<GuideLevelMatchesSearchFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GuideLevelFilterMostRecentPracticeDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GuideLevelFilterMyCurrentProficiencyLevel = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type GuideLevelFilterName = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type GuideLevelFilterNearestSkillPathDueDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  input?: InputMaybe<GuideLevelNearestSkillPathDueDateFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GuideLevelFilterNlevel = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type GuideLevelFilterOnSkillPath = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  input?: InputMaybe<GuideLevelOnSkillPathFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GuideLevelFilterOnStudentsSkillPaths = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GuideLevelFilterParentId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type GuideLevelFilterPosition = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type GuideLevelFilterPublished = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GuideLevelFilterSubjectId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type GuideLevelFilterThemeImg = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type GuideLevelFilterUnfilteredCountChildren = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type GuideLevelFilterUrlSlug = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type GuideLevelIndependentAdaptivePracticeFieldInput = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GuideLevelMatchesSearchFieldInput = {
  search?: InputMaybe<Scalars['String']['input']>;
  searchFields?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GuideLevelMyProficiencyLevelFieldInput = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GuideLevelMySkillPathProficiencyLevelFieldInput = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GuideLevelNearestSkillPathDueDateFieldInput = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GuideLevelOnSkillPathFieldInput = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GuideLevelSearchResult = {
  __typename?: 'GuideLevelSearchResult';
  children?: Maybe<Array<Maybe<GuideLevelSearchResult>>>;
  id?: Maybe<Scalars['ID']['output']>;
  matchesSearch?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum GuideLevelSortField {
  AbQuestionCount = 'AB_QUESTION_COUNT',
  AdaptiveAdvanceThreshold = 'ADAPTIVE_ADVANCE_THRESHOLD',
  AdaptiveDateProximity = 'ADAPTIVE_DATE_PROXIMITY',
  AdaptiveFallbackThreshold = 'ADAPTIVE_FALLBACK_THRESHOLD',
  AdaptiveRange = 'ADAPTIVE_RANGE',
  Code = 'CODE',
  ComingSoon = 'COMING_SOON',
  CountChildren = 'COUNT_CHILDREN',
  CountMatchingQuestions = 'COUNT_MATCHING_QUESTIONS',
  CountOfQuestions = 'COUNT_OF_QUESTIONS',
  CountStandards = 'COUNT_STANDARDS',
  Description = 'DESCRIPTION',
  EffectiveAdaptiveAdvanceThreshold = 'EFFECTIVE_ADAPTIVE_ADVANCE_THRESHOLD',
  EffectiveAdaptiveFallbackThreshold = 'EFFECTIVE_ADAPTIVE_FALLBACK_THRESHOLD',
  EffectiveAdaptiveRange = 'EFFECTIVE_ADAPTIVE_RANGE',
  EffectiveComingSoon = 'EFFECTIVE_COMING_SOON',
  EffectivePublished = 'EFFECTIVE_PUBLISHED',
  Free = 'FREE',
  GuideId = 'GUIDE_ID',
  HasQuestions = 'HAS_QUESTIONS',
  Id = 'ID',
  IndependentAdaptivePractice = 'INDEPENDENT_ADAPTIVE_PRACTICE',
  Level = 'LEVEL',
  MatchesSearch = 'MATCHES_SEARCH',
  MostRecentPracticeDate = 'MOST_RECENT_PRACTICE_DATE',
  MyCurrentProficiencyLevel = 'MY_CURRENT_PROFICIENCY_LEVEL',
  Name = 'NAME',
  NearestSkillPathDueDate = 'NEAREST_SKILL_PATH_DUE_DATE',
  Nlevel = 'NLEVEL',
  OnSkillPath = 'ON_SKILL_PATH',
  OnStudentsSkillPaths = 'ON_STUDENTS_SKILL_PATHS',
  ParentId = 'PARENT_ID',
  Position = 'POSITION',
  Published = 'PUBLISHED',
  SubjectId = 'SUBJECT_ID',
  ThemeImg = 'THEME_IMG',
  UnfilteredCountChildren = 'UNFILTERED_COUNT_CHILDREN',
  UrlSlug = 'URL_SLUG'
}

export type GuideLevelSortInput = {
  abQuestionCountInput?: InputMaybe<GuideLevelAbQuestionCountFieldInput>;
  adaptiveDateProximityInput?: InputMaybe<GuideLevelAdaptiveDateProximityFieldInput>;
  countMatchingQuestionsInput?: InputMaybe<GuideLevelCountMatchingQuestionsFieldInput>;
  field: GuideLevelSortField;
  independentAdaptivePracticeInput?: InputMaybe<GuideLevelIndependentAdaptivePracticeFieldInput>;
  matchesSearchInput?: InputMaybe<GuideLevelMatchesSearchFieldInput>;
  myProficiencyLevelInput?: InputMaybe<GuideLevelMyProficiencyLevelFieldInput>;
  mySkillPathProficiencyLevelInput?: InputMaybe<GuideLevelMySkillPathProficiencyLevelFieldInput>;
  nearestSkillPathDueDateInput?: InputMaybe<GuideLevelNearestSkillPathDueDateFieldInput>;
  onSkillPathInput?: InputMaybe<GuideLevelOnSkillPathFieldInput>;
  order?: InputMaybe<SortOrder>;
};

export enum GuideSortField {
  AbQuestionCount = 'AB_QUESTION_COUNT',
  Id = 'ID',
  Name = 'NAME',
  Published = 'PUBLISHED',
  SubjectId = 'SUBJECT_ID',
  Type = 'TYPE'
}

export type GuideSortInput = {
  abQuestionCountInput?: InputMaybe<GuideAbQuestionCountFieldInput>;
  field: GuideSortField;
  order?: InputMaybe<SortOrder>;
};

export type ImageSupplementContent = {
  __typename?: 'ImageSupplementContent';
  alttext?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  generationMode?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  image: Scalars['String']['output'];
  imagePrompt?: Maybe<Scalars['String']['output']>;
  imageSize?: Maybe<Scalars['Int']['output']>;
  imageStatus?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
  x?: Maybe<Scalars['Int']['output']>;
  y?: Maybe<Scalars['Int']['output']>;
};

export type ImageSupplementContentInput = {
  alttext?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  generationMode?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  image: Scalars['String']['input'];
  imagePrompt?: InputMaybe<Scalars['String']['input']>;
  imageSize?: InputMaybe<Scalars['Int']['input']>;
  imageStatus?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
  x?: InputMaybe<Scalars['Int']['input']>;
  y?: InputMaybe<Scalars['Int']['input']>;
};

/** A keyset page of :adaptive_practice */
export type KeysetPageOfAdaptivePractice = {
  __typename?: 'KeysetPageOfAdaptivePractice';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** The last keyset in the results */
  endKeyset?: Maybe<Scalars['String']['output']>;
  /** The records contained in the page */
  results?: Maybe<Array<AdaptivePractice>>;
  /** The first keyset in the results */
  startKeyset?: Maybe<Scalars['String']['output']>;
};

/** A keyset page of :curriculum_area */
export type KeysetPageOfCurriculumArea = {
  __typename?: 'KeysetPageOfCurriculumArea';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** The last keyset in the results */
  endKeyset?: Maybe<Scalars['String']['output']>;
  /** The records contained in the page */
  results?: Maybe<Array<CurriculumArea>>;
  /** The first keyset in the results */
  startKeyset?: Maybe<Scalars['String']['output']>;
};

/** A keyset page of :district */
export type KeysetPageOfDistrict = {
  __typename?: 'KeysetPageOfDistrict';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** The last keyset in the results */
  endKeyset?: Maybe<Scalars['String']['output']>;
  /** The records contained in the page */
  results?: Maybe<Array<District>>;
  /** The first keyset in the results */
  startKeyset?: Maybe<Scalars['String']['output']>;
};

/** A keyset page of :grade_level */
export type KeysetPageOfGradeLevel = {
  __typename?: 'KeysetPageOfGradeLevel';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** The last keyset in the results */
  endKeyset?: Maybe<Scalars['String']['output']>;
  /** The records contained in the page */
  results?: Maybe<Array<GradeLevel>>;
  /** The first keyset in the results */
  startKeyset?: Maybe<Scalars['String']['output']>;
};

/** A keyset page of :guide */
export type KeysetPageOfGuide = {
  __typename?: 'KeysetPageOfGuide';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** The last keyset in the results */
  endKeyset?: Maybe<Scalars['String']['output']>;
  /** The records contained in the page */
  results?: Maybe<Array<Guide>>;
  /** The first keyset in the results */
  startKeyset?: Maybe<Scalars['String']['output']>;
};

/** A keyset page of :guide_level */
export type KeysetPageOfGuideLevel = {
  __typename?: 'KeysetPageOfGuideLevel';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** The last keyset in the results */
  endKeyset?: Maybe<Scalars['String']['output']>;
  /** The records contained in the page */
  results?: Maybe<Array<GuideLevel>>;
  /** The first keyset in the results */
  startKeyset?: Maybe<Scalars['String']['output']>;
};

/** A keyset page of :question */
export type KeysetPageOfQuestion = {
  __typename?: 'KeysetPageOfQuestion';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** The last keyset in the results */
  endKeyset?: Maybe<Scalars['String']['output']>;
  /** The records contained in the page */
  results?: Maybe<Array<Question>>;
  /** The first keyset in the results */
  startKeyset?: Maybe<Scalars['String']['output']>;
};

/** A keyset page of :school_license */
export type KeysetPageOfSchoolLicense = {
  __typename?: 'KeysetPageOfSchoolLicense';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** The last keyset in the results */
  endKeyset?: Maybe<Scalars['String']['output']>;
  /** The records contained in the page */
  results?: Maybe<Array<SchoolLicense>>;
  /** The first keyset in the results */
  startKeyset?: Maybe<Scalars['String']['output']>;
};

/** A keyset page of :skill_path_settings */
export type KeysetPageOfSkillPathSettings = {
  __typename?: 'KeysetPageOfSkillPathSettings';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** The last keyset in the results */
  endKeyset?: Maybe<Scalars['String']['output']>;
  /** The records contained in the page */
  results?: Maybe<Array<SkillPathSettings>>;
  /** The first keyset in the results */
  startKeyset?: Maybe<Scalars['String']['output']>;
};

/** A keyset page of :standard */
export type KeysetPageOfStandard = {
  __typename?: 'KeysetPageOfStandard';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** The last keyset in the results */
  endKeyset?: Maybe<Scalars['String']['output']>;
  /** The records contained in the page */
  results?: Maybe<Array<Standard>>;
  /** The first keyset in the results */
  startKeyset?: Maybe<Scalars['String']['output']>;
};

/** A keyset page of :standard_set */
export type KeysetPageOfStandardSet = {
  __typename?: 'KeysetPageOfStandardSet';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** The last keyset in the results */
  endKeyset?: Maybe<Scalars['String']['output']>;
  /** The records contained in the page */
  results?: Maybe<Array<StandardSet>>;
  /** The first keyset in the results */
  startKeyset?: Maybe<Scalars['String']['output']>;
};

/** A keyset page of :subject */
export type KeysetPageOfSubject = {
  __typename?: 'KeysetPageOfSubject';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** The last keyset in the results */
  endKeyset?: Maybe<Scalars['String']['output']>;
  /** The records contained in the page */
  results?: Maybe<Array<Subject>>;
  /** The first keyset in the results */
  startKeyset?: Maybe<Scalars['String']['output']>;
};

/** A keyset page of :supplement */
export type KeysetPageOfSupplement = {
  __typename?: 'KeysetPageOfSupplement';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** The last keyset in the results */
  endKeyset?: Maybe<Scalars['String']['output']>;
  /** The records contained in the page */
  results?: Maybe<Array<Supplement>>;
  /** The first keyset in the results */
  startKeyset?: Maybe<Scalars['String']['output']>;
};

/** A keyset page of :upgrade */
export type KeysetPageOfUpgrade = {
  __typename?: 'KeysetPageOfUpgrade';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** The last keyset in the results */
  endKeyset?: Maybe<Scalars['String']['output']>;
  /** The records contained in the page */
  results?: Maybe<Array<Upgrade>>;
  /** The first keyset in the results */
  startKeyset?: Maybe<Scalars['String']['output']>;
};

/** A keyset page of :user_feedback */
export type KeysetPageOfUserFeedback = {
  __typename?: 'KeysetPageOfUserFeedback';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** The last keyset in the results */
  endKeyset?: Maybe<Scalars['String']['output']>;
  /** The records contained in the page */
  results?: Maybe<Array<UserFeedback>>;
  /** The first keyset in the results */
  startKeyset?: Maybe<Scalars['String']['output']>;
};

export type ManagedUserCreateResult = {
  __typename?: 'ManagedUserCreateResult';
  email: Scalars['String']['output'];
  errorMessages?: Maybe<Array<Scalars['String']['output']>>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  username: Scalars['String']['output'];
};

export type ManagedUserSelfResetPasswordInput = {
  newPassword: Scalars['String']['input'];
};

export type ManagedUserStudentInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type MarkAsCorrectRubric = {
  __typename?: 'MarkAsCorrectRubric';
  /**
   * Must be "markAsCorrect" to identify this rubric type.
   * This field is required where it isn't on other rubric types, simply because we can't have a union type without any fields.
   */
  type: Scalars['String']['output'];
};

export type MarkAsCorrectRubricInput = {
  /**
   * Must be "markAsCorrect" to identify this rubric type.
   * This field is required where it isn't on other rubric types, simply because we can't have a union type without any fields.
   */
  type: Scalars['String']['input'];
};

export type MathContainsRubric = {
  __typename?: 'MathContainsRubric';
  threshold?: Maybe<Scalars['Float']['output']>;
  validResponse: Scalars['JsonString']['output'];
};

export type MathContainsRubricInput = {
  threshold?: InputMaybe<Scalars['Float']['input']>;
  validResponse: Scalars['JsonString']['input'];
};

export type MetricInput = MetricInputProficiencyRangeEnd | MetricInputProficiencyRangeStart;

export type MetricInputInput = {
  proficiencyRangeEnd?: InputMaybe<Scalars['JsonString']['input']>;
  proficiencyRangeStart?: InputMaybe<Scalars['JsonString']['input']>;
};

export type MetricInputProficiencyRangeEnd = {
  __typename?: 'MetricInputProficiencyRangeEnd';
  value: Scalars['JsonString']['output'];
};

export type MetricInputProficiencyRangeStart = {
  __typename?: 'MetricInputProficiencyRangeStart';
  value: Scalars['JsonString']['output'];
};

export type MostEqualRubric = {
  __typename?: 'MostEqualRubric';
  validResponse: Scalars['Json']['output'];
};

export type MostEqualRubricInput = {
  validResponse: Scalars['Json']['input'];
};

/** An error generated by a failed mutation */
export type MutationError = {
  __typename?: 'MutationError';
  /** An error code for the given error */
  code?: Maybe<Scalars['String']['output']>;
  /** The field or fields that produced the error */
  fields?: Maybe<Array<Scalars['String']['output']>>;
  /** The human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** The path to the field that produced the error */
  path?: Maybe<Array<Scalars['String']['output']>>;
  /** A shorter error message, with vars not replaced */
  shortMessage?: Maybe<Scalars['String']['output']>;
  /** Replacements for the short message */
  vars?: Maybe<Scalars['Json']['output']>;
};

export enum NcesLocale {
  CityLarge = 'CITY_LARGE',
  CityMidsize = 'CITY_MIDSIZE',
  CitySmall = 'CITY_SMALL',
  RuralDistant = 'RURAL_DISTANT',
  RuralFringe = 'RURAL_FRINGE',
  RuralRemote = 'RURAL_REMOTE',
  SuburbLarge = 'SUBURB_LARGE',
  SuburbMidsize = 'SUBURB_MIDSIZE',
  SuburbSmall = 'SUBURB_SMALL',
  TownDistant = 'TOWN_DISTANT',
  TownFringe = 'TOWN_FRINGE',
  TownRemote = 'TOWN_REMOTE'
}

/** A page of :guide_level */
export type PageOfGuideLevel = {
  __typename?: 'PageOfGuideLevel';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** Whether or not there is a next page */
  hasNextPage: Scalars['Boolean']['output'];
  /** Whether or not there is a previous page */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The number of the last page */
  lastPage: Scalars['Int']['output'];
  /** The number of records per page */
  limit: Scalars['Int']['output'];
  /** The number of the current page */
  pageNumber: Scalars['Int']['output'];
  /** The records contained in the page */
  results?: Maybe<Array<GuideLevel>>;
};

/** A page of :question */
export type PageOfQuestion = {
  __typename?: 'PageOfQuestion';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** Whether or not there is a next page */
  hasNextPage: Scalars['Boolean']['output'];
  /** Whether or not there is a previous page */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The number of the last page */
  lastPage: Scalars['Int']['output'];
  /** The number of records per page */
  limit: Scalars['Int']['output'];
  /** The number of the current page */
  pageNumber: Scalars['Int']['output'];
  /** The records contained in the page */
  results?: Maybe<Array<Question>>;
};

/** A page of :student_assignment */
export type PageOfStudentAssignment = {
  __typename?: 'PageOfStudentAssignment';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** Whether or not there is a next page */
  hasNextPage: Scalars['Boolean']['output'];
  /** Whether or not there is a previous page */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The number of the last page */
  lastPage: Scalars['Int']['output'];
  /** The number of records per page */
  limit: Scalars['Int']['output'];
  /** The number of the current page */
  pageNumber: Scalars['Int']['output'];
  /** The records contained in the page */
  results?: Maybe<Array<StudentAssignment>>;
};

/** A page of :subject */
export type PageOfSubject = {
  __typename?: 'PageOfSubject';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** Whether or not there is a next page */
  hasNextPage: Scalars['Boolean']['output'];
  /** Whether or not there is a previous page */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The number of the last page */
  lastPage: Scalars['Int']['output'];
  /** The number of records per page */
  limit: Scalars['Int']['output'];
  /** The number of the current page */
  pageNumber: Scalars['Int']['output'];
  /** The records contained in the page */
  results?: Maybe<Array<Subject>>;
};

/** A page of :tag */
export type PageOfTag = {
  __typename?: 'PageOfTag';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** Whether or not there is a next page */
  hasNextPage: Scalars['Boolean']['output'];
  /** Whether or not there is a previous page */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The number of the last page */
  lastPage: Scalars['Int']['output'];
  /** The number of records per page */
  limit: Scalars['Int']['output'];
  /** The number of the current page */
  pageNumber: Scalars['Int']['output'];
  /** The records contained in the page */
  results?: Maybe<Array<Tag>>;
};

/** A page of :user */
export type PageOfUser = {
  __typename?: 'PageOfUser';
  /** Total count on all pages */
  count?: Maybe<Scalars['Int']['output']>;
  /** Whether or not there is a next page */
  hasNextPage: Scalars['Boolean']['output'];
  /** Whether or not there is a previous page */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The number of the last page */
  lastPage: Scalars['Int']['output'];
  /** The number of records per page */
  limit: Scalars['Int']['output'];
  /** The number of the current page */
  pageNumber: Scalars['Int']['output'];
  /** The records contained in the page */
  results?: Maybe<Array<User>>;
};

export type PassageSupplementContent = {
  __typename?: 'PassageSupplementContent';
  excludeHeaders?: Maybe<Scalars['Boolean']['output']>;
  excludeWhiteSpace: Scalars['Boolean']['output'];
  hideLineNumbers: Scalars['Boolean']['output'];
  ignoreWhiteSpace: Scalars['Boolean']['output'];
  lineNumberAlignment?: Maybe<Scalars['String']['output']>;
  lineNumberIncrement?: Maybe<Scalars['Int']['output']>;
  setMaxHeight?: Maybe<Scalars['Boolean']['output']>;
  text: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type PassageSupplementContentInput = {
  excludeHeaders?: InputMaybe<Scalars['Boolean']['input']>;
  excludeWhiteSpace: Scalars['Boolean']['input'];
  hideLineNumbers: Scalars['Boolean']['input'];
  ignoreWhiteSpace: Scalars['Boolean']['input'];
  lineNumberAlignment?: InputMaybe<Scalars['String']['input']>;
  lineNumberIncrement?: InputMaybe<Scalars['Int']['input']>;
  setMaxHeight?: InputMaybe<Scalars['Boolean']['input']>;
  text: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ProficiencyLevelChange = {
  __typename?: 'ProficiencyLevelChange';
  adaptivePractice: AdaptivePractice;
  adaptivePracticeId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  newLevel: Scalars['Int']['output'];
};

export type ProficiencyLevelChangeFilterAdaptivePracticeId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type ProficiencyLevelChangeFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type ProficiencyLevelChangeFilterInput = {
  adaptivePractice?: InputMaybe<AdaptivePracticeFilterInput>;
  adaptivePracticeId?: InputMaybe<ProficiencyLevelChangeFilterAdaptivePracticeId>;
  and?: InputMaybe<Array<ProficiencyLevelChangeFilterInput>>;
  id?: InputMaybe<ProficiencyLevelChangeFilterId>;
  newLevel?: InputMaybe<ProficiencyLevelChangeFilterNewLevel>;
  not?: InputMaybe<Array<ProficiencyLevelChangeFilterInput>>;
  or?: InputMaybe<Array<ProficiencyLevelChangeFilterInput>>;
};

export type ProficiencyLevelChangeFilterNewLevel = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export enum ProficiencyLevelChangeSortField {
  AdaptivePracticeId = 'ADAPTIVE_PRACTICE_ID',
  Id = 'ID',
  NewLevel = 'NEW_LEVEL'
}

export type ProficiencyLevelChangeSortInput = {
  field: ProficiencyLevelChangeSortField;
  order?: InputMaybe<SortOrder>;
};

export type Question = {
  __typename?: 'Question';
  answerBreakdown?: Maybe<Scalars['JsonString']['output']>;
  author: User;
  authorId: Scalars['ID']['output'];
  chainPath?: Maybe<Scalars['Json']['output']>;
  difficulty?: Maybe<Scalars['Int']['output']>;
  guideLevels: Array<GuideLevel>;
  id: Scalars['ID']['output'];
  legacyQuestionSetSlugId: Scalars['String']['output'];
  /** Whether this question matched the search string. Search fields may be any of document_stems, solution_document_stems. Defaults to both. */
  matchesSearch?: Maybe<Scalars['Boolean']['output']>;
  /** The next published question in the chain, skipping non-published ones */
  nextInChainId?: Maybe<Scalars['ID']['output']>;
  owner: User;
  ownerId: Scalars['ID']['output'];
  points: Scalars['Int']['output'];
  prompt?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * A vestige of the past when questions belonged to question sets.
   * This is still used as the foreign key for some join tables, but can be thought of as an alternate ID for the question.
   * When creating a question via this resource, this will be automatically set by database triggers.
   */
  questionSetId?: Maybe<Scalars['ID']['output']>;
  questionType: Scalars['String']['output'];
  questionTypeAttributes?: Maybe<Scalars['JsonString']['output']>;
  rubric: Rubric;
  slugId?: Maybe<Scalars['String']['output']>;
  solutionText?: Maybe<Scalars['String']['output']>;
  standards: Array<Standard>;
  status: Scalars['String']['output'];
  subject: Subject;
  subjectId: Scalars['ID']['output'];
  supplements: Array<Supplement>;
  tags: Array<Tag>;
  title: Scalars['String']['output'];
  translate?: Maybe<Scalars['Boolean']['output']>;
  translateSupplements?: Maybe<Scalars['Boolean']['output']>;
  typeAttributes: QuestionTypeAttributes;
  unfilteredGuideLevels: Array<GuideLevel>;
  unfilteredSubject: Subject;
};


export type QuestionGuideLevelsArgs = {
  filter?: InputMaybe<GuideLevelFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuideLevelSortInput>>>;
};


export type QuestionMatchesSearchArgs = {
  search: Scalars['String']['input'];
  searchFields?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QuestionStandardsArgs = {
  filter?: InputMaybe<StandardFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<StandardSortInput>>>;
};


export type QuestionSupplementsArgs = {
  filter?: InputMaybe<SupplementFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SupplementSortInput>>>;
};


export type QuestionTagsArgs = {
  filter?: InputMaybe<TagFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TagSortInput>>>;
};


export type QuestionUnfilteredGuideLevelsArgs = {
  filter?: InputMaybe<GuideLevelFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuideLevelSortInput>>>;
};

export type QuestionFilterAnswerBreakdown = {
  eq?: InputMaybe<Scalars['JsonString']['input']>;
  greaterThan?: InputMaybe<Scalars['JsonString']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['JsonString']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JsonString']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['JsonString']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['JsonString']['input']>;
  lessThan?: InputMaybe<Scalars['JsonString']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['JsonString']['input']>;
  notEq?: InputMaybe<Scalars['JsonString']['input']>;
};

export type QuestionFilterAuthorId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type QuestionFilterChainPath = {
  eq?: InputMaybe<Scalars['Json']['input']>;
  greaterThan?: InputMaybe<Scalars['Json']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Json']['input']>;
  in?: InputMaybe<Scalars['Json']['input']>;
  isDistinctFrom?: InputMaybe<Scalars['Json']['input']>;
  isNil?: InputMaybe<Scalars['Json']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Json']['input']>;
  lessThan?: InputMaybe<Scalars['Json']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Json']['input']>;
  notEq?: InputMaybe<Scalars['Json']['input']>;
};

export type QuestionFilterDifficulty = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type QuestionFilterInput = {
  and?: InputMaybe<Array<QuestionFilterInput>>;
  answerBreakdown?: InputMaybe<QuestionFilterAnswerBreakdown>;
  author?: InputMaybe<UserFilterInput>;
  authorId?: InputMaybe<QuestionFilterAuthorId>;
  chainPath?: InputMaybe<QuestionFilterChainPath>;
  difficulty?: InputMaybe<QuestionFilterDifficulty>;
  guideLevels?: InputMaybe<GuideLevelFilterInput>;
  id?: InputMaybe<QuestionFilterId>;
  legacyQuestionSetSlugId?: InputMaybe<QuestionFilterLegacyQuestionSetSlugId>;
  /** Whether this question matched the search string. Search fields may be any of document_stems, solution_document_stems. Defaults to both. */
  matchesSearch?: InputMaybe<QuestionFilterMatchesSearch>;
  /** The next published question in the chain, skipping non-published ones */
  nextInChainId?: InputMaybe<QuestionFilterNextInChainId>;
  not?: InputMaybe<Array<QuestionFilterInput>>;
  or?: InputMaybe<Array<QuestionFilterInput>>;
  owner?: InputMaybe<UserFilterInput>;
  ownerId?: InputMaybe<QuestionFilterOwnerId>;
  points?: InputMaybe<QuestionFilterPoints>;
  prompt?: InputMaybe<QuestionFilterPrompt>;
  publishedAt?: InputMaybe<QuestionFilterPublishedAt>;
  /**
   * A vestige of the past when questions belonged to question sets.
   * This is still used as the foreign key for some join tables, but can be thought of as an alternate ID for the question.
   * When creating a question via this resource, this will be automatically set by database triggers.
   */
  questionSetId?: InputMaybe<QuestionFilterQuestionSetId>;
  questionType?: InputMaybe<QuestionFilterQuestionType>;
  questionTypeAttributes?: InputMaybe<QuestionFilterQuestionTypeAttributes>;
  slugId?: InputMaybe<QuestionFilterSlugId>;
  solutionText?: InputMaybe<QuestionFilterSolutionText>;
  standards?: InputMaybe<StandardFilterInput>;
  status?: InputMaybe<QuestionFilterStatus>;
  subject?: InputMaybe<SubjectFilterInput>;
  subjectId?: InputMaybe<QuestionFilterSubjectId>;
  supplements?: InputMaybe<SupplementFilterInput>;
  tags?: InputMaybe<TagFilterInput>;
  title?: InputMaybe<QuestionFilterTitle>;
  translate?: InputMaybe<QuestionFilterTranslate>;
  translateSupplements?: InputMaybe<QuestionFilterTranslateSupplements>;
  unfilteredGuideLevels?: InputMaybe<GuideLevelFilterInput>;
  unfilteredSubject?: InputMaybe<SubjectFilterInput>;
};

export type QuestionFilterLegacyQuestionSetSlugId = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionFilterMatchesSearch = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  input?: InputMaybe<QuestionMatchesSearchFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuestionFilterNextInChainId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type QuestionFilterOwnerId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type QuestionFilterPoints = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionFilterPrompt = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionFilterPublishedAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QuestionFilterQuestionSetId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type QuestionFilterQuestionType = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionFilterQuestionTypeAttributes = {
  eq?: InputMaybe<Scalars['JsonString']['input']>;
  greaterThan?: InputMaybe<Scalars['JsonString']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['JsonString']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JsonString']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['JsonString']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['JsonString']['input']>;
  lessThan?: InputMaybe<Scalars['JsonString']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['JsonString']['input']>;
  notEq?: InputMaybe<Scalars['JsonString']['input']>;
};

export type QuestionFilterSlugId = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionFilterSolutionText = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionFilterStatus = {
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionFilterSubjectId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type QuestionFilterTitle = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionFilterTranslate = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuestionFilterTranslateSupplements = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuestionMatchesSearchFieldInput = {
  search: Scalars['String']['input'];
  searchFields?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum QuestionSortField {
  AnswerBreakdown = 'ANSWER_BREAKDOWN',
  AuthorId = 'AUTHOR_ID',
  ChainPath = 'CHAIN_PATH',
  Difficulty = 'DIFFICULTY',
  Id = 'ID',
  LegacyQuestionSetSlugId = 'LEGACY_QUESTION_SET_SLUG_ID',
  MatchesSearch = 'MATCHES_SEARCH',
  NextInChainId = 'NEXT_IN_CHAIN_ID',
  OwnerId = 'OWNER_ID',
  Points = 'POINTS',
  Prompt = 'PROMPT',
  PublishedAt = 'PUBLISHED_AT',
  QuestionSetId = 'QUESTION_SET_ID',
  QuestionType = 'QUESTION_TYPE',
  QuestionTypeAttributes = 'QUESTION_TYPE_ATTRIBUTES',
  SlugId = 'SLUG_ID',
  SolutionText = 'SOLUTION_TEXT',
  Status = 'STATUS',
  SubjectId = 'SUBJECT_ID',
  Title = 'TITLE',
  Translate = 'TRANSLATE',
  TranslateSupplements = 'TRANSLATE_SUPPLEMENTS'
}

export type QuestionSortInput = {
  field: QuestionSortField;
  matchesSearchInput?: InputMaybe<QuestionMatchesSearchFieldInput>;
  order?: InputMaybe<SortOrder>;
};

export type QuestionTypeAttributes = QuestionTypeAttributesFillInTheBlank | QuestionTypeAttributesFreeEntry | QuestionTypeAttributesFreeResponse | QuestionTypeAttributesGraphContains | QuestionTypeAttributesItemBank | QuestionTypeAttributesMultipleChoice | QuestionTypeAttributesOrdering | QuestionTypeAttributesPassageCorrection | QuestionTypeAttributesSnippetSelection | QuestionTypeAttributesTextHighlight | QuestionTypeAttributesTwoWay;

export type QuestionTypeAttributesFillInTheBlank = {
  __typename?: 'QuestionTypeAttributesFillInTheBlank';
  dropdownText?: Maybe<Scalars['String']['output']>;
  dropdowns: Array<QuestionTypeAttributesFillInTheBlankDropdown>;
};

export type QuestionTypeAttributesFillInTheBlankDropdown = {
  __typename?: 'QuestionTypeAttributesFillInTheBlankDropdown';
  choices: Array<QuestionTypeAttributesFillInTheBlankDropdownChoice>;
  id: Scalars['String']['output'];
  position: Scalars['Int']['output'];
};

export type QuestionTypeAttributesFillInTheBlankDropdownChoice = {
  __typename?: 'QuestionTypeAttributesFillInTheBlankDropdownChoice';
  id: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type QuestionTypeAttributesFillInTheBlankDropdownChoiceInput = {
  id: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type QuestionTypeAttributesFillInTheBlankDropdownInput = {
  choices: Array<QuestionTypeAttributesFillInTheBlankDropdownChoiceInput>;
  id: Scalars['String']['input'];
  position: Scalars['Int']['input'];
};

export type QuestionTypeAttributesFillInTheBlankInput = {
  dropdownText?: InputMaybe<Scalars['String']['input']>;
  dropdowns: Array<QuestionTypeAttributesFillInTheBlankDropdownInput>;
};

export type QuestionTypeAttributesFreeEntry = {
  __typename?: 'QuestionTypeAttributesFreeEntry';
  inputs: Array<QuestionTypeAttributesInputElement>;
};

export type QuestionTypeAttributesFreeEntryInput = {
  inputs: Array<QuestionTypeAttributesInputElementInput>;
};

export type QuestionTypeAttributesFreeResponse = {
  __typename?: 'QuestionTypeAttributesFreeResponse';
  sample?: Maybe<Scalars['String']['output']>;
};

export type QuestionTypeAttributesFreeResponseInput = {
  sample?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionTypeAttributesGraphContains = {
  __typename?: 'QuestionTypeAttributesGraphContains';
  allowedEntities: Array<Scalars['String']['output']>;
  labelBottom?: Maybe<Scalars['String']['output']>;
  labelLeft?: Maybe<Scalars['String']['output']>;
  providedEntities?: Maybe<Array<GraphContainsEntity>>;
  xInterval: Scalars['Int']['output'];
  xLabel?: Maybe<Scalars['String']['output']>;
  xMax: Scalars['Int']['output'];
  xMin: Scalars['Int']['output'];
  yInterval: Scalars['Int']['output'];
  yLabel?: Maybe<Scalars['String']['output']>;
  yMax: Scalars['Int']['output'];
  yMin: Scalars['Int']['output'];
};

export type QuestionTypeAttributesGraphContainsInput = {
  allowedEntities: Array<Scalars['String']['input']>;
  labelBottom?: InputMaybe<Scalars['String']['input']>;
  labelLeft?: InputMaybe<Scalars['String']['input']>;
  providedEntities?: InputMaybe<Array<GraphContainsEntityInput>>;
  xInterval: Scalars['Int']['input'];
  xLabel?: InputMaybe<Scalars['String']['input']>;
  xMax: Scalars['Int']['input'];
  xMin: Scalars['Int']['input'];
  yInterval: Scalars['Int']['input'];
  yLabel?: InputMaybe<Scalars['String']['input']>;
  yMax: Scalars['Int']['input'];
  yMin: Scalars['Int']['input'];
};

export type QuestionTypeAttributesInput = {
  fillInTheBlank?: InputMaybe<QuestionTypeAttributesFillInTheBlankInput>;
  freeEntry?: InputMaybe<QuestionTypeAttributesFreeEntryInput>;
  freeResponse?: InputMaybe<QuestionTypeAttributesFreeResponseInput>;
  graphContains?: InputMaybe<QuestionTypeAttributesGraphContainsInput>;
  itemBank?: InputMaybe<QuestionTypeAttributesItemBankInput>;
  multipleChoice?: InputMaybe<QuestionTypeAttributesMultipleChoiceInput>;
  ordering?: InputMaybe<QuestionTypeAttributesOrderingInput>;
  passageCorrection?: InputMaybe<QuestionTypeAttributesPassageCorrectionInput>;
  snippetSelection?: InputMaybe<QuestionTypeAttributesSnippetSelectionInput>;
  textHighlight?: InputMaybe<QuestionTypeAttributesTextHighlightInput>;
  twoWay?: InputMaybe<QuestionTypeAttributesTwoWayInput>;
};

/** An object representing an input prompt for a question, used by a few different question types. */
export type QuestionTypeAttributesInputElement = {
  __typename?: 'QuestionTypeAttributesInputElement';
  id: Scalars['String']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

/** An object representing an input prompt for a question, used by a few different question types. */
export type QuestionTypeAttributesInputElementInput = {
  id: Scalars['String']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionTypeAttributesItemBank = {
  __typename?: 'QuestionTypeAttributesItemBank';
  bank: Array<Maybe<QuestionTypeAttributesItemBankElement>>;
  slots: Array<Maybe<QuestionTypeAttributesItemBankElement>>;
};

export type QuestionTypeAttributesItemBankElement = {
  __typename?: 'QuestionTypeAttributesItemBankElement';
  id: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type QuestionTypeAttributesItemBankElementInput = {
  id: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type QuestionTypeAttributesItemBankInput = {
  bank: Array<InputMaybe<QuestionTypeAttributesItemBankElementInput>>;
  slots: Array<InputMaybe<QuestionTypeAttributesItemBankElementInput>>;
};

export type QuestionTypeAttributesMultipleChoice = {
  __typename?: 'QuestionTypeAttributesMultipleChoice';
  isSelectMultiple: Scalars['Boolean']['output'];
  options: Array<QuestionTypeAttributesOption>;
};

export type QuestionTypeAttributesMultipleChoiceInput = {
  isSelectMultiple: Scalars['Boolean']['input'];
  options: Array<QuestionTypeAttributesOptionInput>;
};

export type QuestionTypeAttributesOption = {
  __typename?: 'QuestionTypeAttributesOption';
  id: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type QuestionTypeAttributesOptionInput = {
  id: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionTypeAttributesOrdering = {
  __typename?: 'QuestionTypeAttributesOrdering';
  items: Array<Maybe<QuestionTypeAttributesItemBankElement>>;
  slots: Array<Maybe<QuestionTypeAttributesOrderingSlot>>;
};

export type QuestionTypeAttributesOrderingInput = {
  items: Array<InputMaybe<QuestionTypeAttributesItemBankElementInput>>;
  slots: Array<InputMaybe<QuestionTypeAttributesOrderingSlotInput>>;
};

export type QuestionTypeAttributesOrderingSlot = {
  __typename?: 'QuestionTypeAttributesOrderingSlot';
  id: Scalars['String']['output'];
};

export type QuestionTypeAttributesOrderingSlotInput = {
  id: Scalars['String']['input'];
};

export type QuestionTypeAttributesPassageCorrection = {
  __typename?: 'QuestionTypeAttributesPassageCorrection';
  uncorrectedText?: Maybe<Scalars['String']['output']>;
};

export type QuestionTypeAttributesPassageCorrectionInput = {
  uncorrectedText?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionTypeAttributesSnippetSelection = {
  __typename?: 'QuestionTypeAttributesSnippetSelection';
  options: Array<QuestionTypeAttributesOption>;
  snippetPrompt?: Maybe<Scalars['String']['output']>;
};

export type QuestionTypeAttributesSnippetSelectionInput = {
  options: Array<QuestionTypeAttributesOptionInput>;
  snippetPrompt?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionTypeAttributesTextHighlight = {
  __typename?: 'QuestionTypeAttributesTextHighlight';
  highlightPrompt?: Maybe<Scalars['String']['output']>;
  preferredPermutation?: Maybe<Scalars['String']['output']>;
};

export type QuestionTypeAttributesTextHighlightInput = {
  highlightPrompt?: InputMaybe<Scalars['String']['input']>;
  preferredPermutation?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionTypeAttributesTwoWay = {
  __typename?: 'QuestionTypeAttributesTwoWay';
  headerLeft?: Maybe<Scalars['String']['output']>;
  headerRight?: Maybe<Scalars['String']['output']>;
  rows: Array<QuestionTypeAttributesTwoWayRow>;
};

export type QuestionTypeAttributesTwoWayColumn = {
  __typename?: 'QuestionTypeAttributesTwoWayColumn';
  id: Scalars['String']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

export type QuestionTypeAttributesTwoWayColumnInput = {
  id: Scalars['String']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionTypeAttributesTwoWayColumns = {
  __typename?: 'QuestionTypeAttributesTwoWayColumns';
  left: QuestionTypeAttributesTwoWayColumn;
  right: QuestionTypeAttributesTwoWayColumn;
};

export type QuestionTypeAttributesTwoWayColumnsInput = {
  left: QuestionTypeAttributesTwoWayColumnInput;
  right: QuestionTypeAttributesTwoWayColumnInput;
};

export type QuestionTypeAttributesTwoWayInput = {
  headerLeft?: InputMaybe<Scalars['String']['input']>;
  headerRight?: InputMaybe<Scalars['String']['input']>;
  rows: Array<QuestionTypeAttributesTwoWayRowInput>;
};

export type QuestionTypeAttributesTwoWayRow = {
  __typename?: 'QuestionTypeAttributesTwoWayRow';
  columns: QuestionTypeAttributesTwoWayColumns;
  id: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  statement?: Maybe<Scalars['String']['output']>;
};

export type QuestionTypeAttributesTwoWayRowInput = {
  columns: QuestionTypeAttributesTwoWayColumnsInput;
  id: Scalars['String']['input'];
  index: Scalars['Int']['input'];
  statement?: InputMaybe<Scalars['String']['input']>;
};

export type RecipientGroupClassroomSkillPathConfigsInput = {
  classroomId: Scalars['ID']['input'];
};

export type RecipientGroupInput = {
  classroomSkillPathConfigs: Array<InputMaybe<RecipientGroupClassroomSkillPathConfigsInput>>;
  settings: RecipientGroupSettingsInput;
  skillId: Scalars['ID']['input'];
  skillPathSettingsId?: InputMaybe<Scalars['ID']['input']>;
  studentSkillPaths: Array<InputMaybe<RecipientGroupStudentSkillPathsInput>>;
};

export type RecipientGroupSettingsInput = {
  dueDate: Scalars['DateTime']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RecipientGroupStudentSkillPathsInput = {
  classroomId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};

export type RecordLockdownViolationInput = {
  violationType: Scalars['String']['input'];
};

/** The result of the :record_lockdown_violation mutation */
export type RecordLockdownViolationResult = {
  __typename?: 'RecordLockdownViolationResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<StudentAssignment>;
};

/** The result of the :regenerate_report mutation */
export type RegenerateReportResult = {
  __typename?: 'RegenerateReportResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<AnalyticsReport>;
};

/** The result of the :regenerate_supplement mutation */
export type RegenerateSupplementResult = {
  __typename?: 'RegenerateSupplementResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<Supplement>;
};

export type ReportFilter = {
  __typename?: 'ReportFilter';
  field?: Maybe<Scalars['String']['output']>;
  operator: Scalars['String']['output'];
  type: Scalars['String']['output'];
  values?: Maybe<Array<Scalars['Any']['output']>>;
};

export type ReportResult = {
  __typename?: 'ReportResult';
  assignment?: Maybe<AnalyticsReportAssignment>;
  assignmentsStudentAssignments: Array<AnalyticsStudentAssignment>;
  classroom?: Maybe<AnalyticsReportClassroom>;
  gradebookStudentAssignment?: Maybe<AnalyticsStudentAssignment>;
  guide?: Maybe<AnalyticsReportGuide>;
  guideLevel?: Maybe<AnalyticsReportGuideLevel>;
  id: Scalars['ID']['output'];
  metrics: Scalars['Json']['output'];
  primaryDimensionId: Scalars['ID']['output'];
  primaryDimensionType: Scalars['String']['output'];
  question?: Maybe<AnalyticsReportQuestion>;
  report?: Maybe<AnalyticsReport>;
  reportId: Scalars['ID']['output'];
  school?: Maybe<AnalyticsSchool>;
  secondaryAssignment?: Maybe<AnalyticsReportAssignment>;
  secondaryClassroom?: Maybe<AnalyticsReportClassroom>;
  secondaryDimensionId?: Maybe<Scalars['ID']['output']>;
  secondaryDimensionType?: Maybe<Scalars['String']['output']>;
  standard?: Maybe<AnalyticsStandard>;
  standardSet?: Maybe<AnalyticsStandardSet>;
  student?: Maybe<AnalyticsStudent>;
  studentsStudentAssignments: Array<AnalyticsStudentAssignment>;
  subject?: Maybe<AnalyticsSubject>;
  teacher?: Maybe<AnalyticsTeacher>;
};


export type ReportResultAssignmentsStudentAssignmentsArgs = {
  filter?: InputMaybe<AnalyticsStudentAssignmentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AnalyticsStudentAssignmentSortInput>>>;
};


export type ReportResultStudentsStudentAssignmentsArgs = {
  filter?: InputMaybe<AnalyticsStudentAssignmentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AnalyticsStudentAssignmentSortInput>>>;
};

export type ReportResultPaginationInput = {
  primaryLimit: Scalars['Int']['input'];
  primaryOffset?: InputMaybe<Scalars['Int']['input']>;
  secondaryLimit?: InputMaybe<Scalars['Int']['input']>;
  secondaryOffset?: InputMaybe<Scalars['Int']['input']>;
};

/** The result of the :resend_confirmation_email mutation */
export type ResendConfirmationEmailResult = {
  __typename?: 'ResendConfirmationEmailResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<User>;
};

/** The result of the :resend_created_user_email mutation */
export type ResendCreatedUserEmailResult = {
  __typename?: 'ResendCreatedUserEmailResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<User>;
};

/** The result of the :resend_password_reset_email mutation */
export type ResendPasswordResetEmailResult = {
  __typename?: 'ResendPasswordResetEmailResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<User>;
};

export type ResetManagedUserPasswordInput = {
  newPassword: Scalars['String']['input'];
};

export type ResetPasswordResult = {
  __typename?: 'ResetPasswordResult';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ResetPasswordWithOldPasswordInput = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};

export type ResetPasswordWithTokenInput = {
  newPassword: Scalars['String']['input'];
  passwordResetLink: Scalars['String']['input'];
};

export type RetailSubscription = {
  __typename?: 'RetailSubscription';
  endDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  startDate: Scalars['DateTime']['output'];
  subject: Subject;
  subjectId: Scalars['ID']['output'];
  unfilteredSubject: Subject;
  user: User;
  userId: Scalars['ID']['output'];
};

export type RetailSubscriptionFilterEndDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RetailSubscriptionFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type RetailSubscriptionFilterInput = {
  and?: InputMaybe<Array<RetailSubscriptionFilterInput>>;
  endDate?: InputMaybe<RetailSubscriptionFilterEndDate>;
  id?: InputMaybe<RetailSubscriptionFilterId>;
  not?: InputMaybe<Array<RetailSubscriptionFilterInput>>;
  or?: InputMaybe<Array<RetailSubscriptionFilterInput>>;
  startDate?: InputMaybe<RetailSubscriptionFilterStartDate>;
  subject?: InputMaybe<SubjectFilterInput>;
  subjectId?: InputMaybe<RetailSubscriptionFilterSubjectId>;
  unfilteredSubject?: InputMaybe<SubjectFilterInput>;
  user?: InputMaybe<UserFilterInput>;
  userId?: InputMaybe<RetailSubscriptionFilterUserId>;
};

export type RetailSubscriptionFilterStartDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RetailSubscriptionFilterSubjectId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type RetailSubscriptionFilterUserId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export enum RetailSubscriptionSortField {
  EndDate = 'END_DATE',
  Id = 'ID',
  StartDate = 'START_DATE',
  SubjectId = 'SUBJECT_ID',
  UserId = 'USER_ID'
}

export type RetailSubscriptionSortInput = {
  field: RetailSubscriptionSortField;
  order?: InputMaybe<SortOrder>;
};

export type RootMutationType = {
  __typename?: 'RootMutationType';
  archiveQuestion: ArchiveQuestionResult;
  bulkCreateManagedUsers: BulkCreateManagedUsersResult;
  /**
   * Sets the license access status for multiple school personnel at once.
   *
   * Accepts a list of school personnel IDs and a status, and updates all matching records.
   * Returns a result for each ID indicating success or failure.
   */
  bulkSetLicenseAccessStatus: Array<BulkStatusUpdateResult>;
  /** Clears all lockdown violations and the auto-submit reason. Used by teachers to reset lockdown state. */
  clearLockdownViolations: ClearLockdownViolationsResult;
  createCustomerFeedbackEntry: CreateCustomerFeedbackEntryResult;
  createDistrict: CreateDistrictResult;
  createGuide: CreateGuideResult;
  createQuestion: CreateQuestionResult;
  createSubject: CreateSubjectResult;
  createSubjectFaq: CreateSubjectFaqResult;
  createSubscription: CreateSubscriptionResult;
  createSupplement: CreateSupplementResult;
  createUser: CreateUserResult;
  createUserFeedback: CreateUserFeedbackResult;
  deleteRecipientGroups: Scalars['String']['output'];
  deleteSubscription: DeleteSubscriptionResult;
  destroyDistrict: DestroyDistrictResult;
  destroyGuide: DestroyGuideResult;
  destroySubject: DestroySubjectResult;
  destroySubjectFaq: DestroySubjectFaqResult;
  destroyUpgrade: DestroyUpgradeResult;
  destroyUserFeedback: DestroyUserFeedbackResult;
  forgotPassword: Scalars['Boolean']['output'];
  /** Allow a managed user to reset their own password without providing the old password. */
  managedUserSelfResetPassword: ResetPasswordResult;
  /** Records a lockdown violation by appending to the violations array. */
  recordLockdownViolation: RecordLockdownViolationResult;
  regenerateReport: RegenerateReportResult;
  regenerateSupplement: RegenerateSupplementResult;
  /** Reorder the FAQs for a subject to be in the order of the given list of FAQ IDs */
  reorderSubjectFaqs: Scalars['Boolean']['output'];
  resendConfirmationEmail: ResendConfirmationEmailResult;
  resendCreatedUserEmail: ResendCreatedUserEmailResult;
  resendPasswordResetEmail: ResendPasswordResetEmailResult;
  /** Reset a user's password if they are a managed user that the current actor has permission to manage. */
  resetManagedUserPassword: ResetPasswordResult;
  resetPasswordWithOldPassword: ResetPasswordResult;
  resetPasswordWithToken: ResetPasswordResult;
  saveRecipientGroups: Array<SkillPathSettings>;
  /**
   * Sets a school personnel's license access approval status.
   *
   * Accepts a status argument (:approved, :pending, or :rejected) and sets it directly.
   */
  setLicenseAccessStatus: SetLicenseAccessStatusResult;
  /**
   * Default behavior is to retrieve the most recently created practice.
   *   A new practice is created if the student hasn't started one yet.
   *   Optionally, the student may choose to 'repractice', in which case a new practice is created and their proficiency begins again back at 0.
   */
  startAdaptivePractice: StartAdaptivePracticeResult;
  updateClassroomSubjectAccess: UpdateClassroomSubjectAccessResult;
  updateDistrict: UpdateDistrictResult;
  updateGuide: UpdateGuideResult;
  updateQuestion: UpdateQuestionResult;
  updateSchoolLicense: UpdateSchoolLicenseResult;
  updateSubject: UpdateSubjectResult;
  updateSubjectFaq: UpdateSubjectFaqResult;
  updateSubscription: UpdateSubscriptionResult;
  updateSupplement: UpdateSupplementResult;
  updateUpgrade: UpdateUpgradeResult;
  updateUser: UpdateUserResult;
  upsertReport: UpsertReportResult;
};


export type RootMutationTypeArchiveQuestionArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeBulkCreateManagedUsersArgs = {
  input: BulkCreateManagedUsersInput;
};


export type RootMutationTypeBulkSetLicenseAccessStatusArgs = {
  input: BulkSetLicenseAccessStatusInput;
};


export type RootMutationTypeClearLockdownViolationsArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeCreateCustomerFeedbackEntryArgs = {
  input: CreateCustomerFeedbackEntryInput;
};


export type RootMutationTypeCreateDistrictArgs = {
  input: CreateDistrictInput;
};


export type RootMutationTypeCreateGuideArgs = {
  input: CreateGuideInput;
};


export type RootMutationTypeCreateQuestionArgs = {
  input: CreateQuestionInput;
};


export type RootMutationTypeCreateSubjectArgs = {
  input: CreateSubjectInput;
};


export type RootMutationTypeCreateSubjectFaqArgs = {
  input: CreateSubjectFaqInput;
};


export type RootMutationTypeCreateSubscriptionArgs = {
  input: CreateSubscriptionInput;
};


export type RootMutationTypeCreateSupplementArgs = {
  input: CreateSupplementInput;
};


export type RootMutationTypeCreateUserArgs = {
  input: CreateUserInput;
};


export type RootMutationTypeCreateUserFeedbackArgs = {
  input: CreateUserFeedbackInput;
};


export type RootMutationTypeDeleteRecipientGroupsArgs = {
  input: DeleteRecipientGroupsInput;
};


export type RootMutationTypeDeleteSubscriptionArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDestroyDistrictArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDestroyGuideArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDestroySubjectArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDestroySubjectFaqArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDestroyUpgradeArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDestroyUserFeedbackArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


export type RootMutationTypeManagedUserSelfResetPasswordArgs = {
  input: ManagedUserSelfResetPasswordInput;
};


export type RootMutationTypeRecordLockdownViolationArgs = {
  id: Scalars['ID']['input'];
  input: RecordLockdownViolationInput;
};


export type RootMutationTypeRegenerateReportArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeRegenerateSupplementArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeReorderSubjectFaqsArgs = {
  newOrder: Array<Scalars['ID']['input']>;
  subjectId: Scalars['ID']['input'];
};


export type RootMutationTypeResendConfirmationEmailArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeResendCreatedUserEmailArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeResendPasswordResetEmailArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeResetManagedUserPasswordArgs = {
  input: ResetManagedUserPasswordInput;
  userId: Scalars['ID']['input'];
};


export type RootMutationTypeResetPasswordWithOldPasswordArgs = {
  input: ResetPasswordWithOldPasswordInput;
};


export type RootMutationTypeResetPasswordWithTokenArgs = {
  input: ResetPasswordWithTokenInput;
  userId: Scalars['ID']['input'];
};


export type RootMutationTypeSaveRecipientGroupsArgs = {
  input: SaveRecipientGroupsInput;
};


export type RootMutationTypeSetLicenseAccessStatusArgs = {
  id: Scalars['ID']['input'];
  input: SetLicenseAccessStatusInput;
};


export type RootMutationTypeStartAdaptivePracticeArgs = {
  input: StartAdaptivePracticeInput;
};


export type RootMutationTypeUpdateClassroomSubjectAccessArgs = {
  classroomId: Scalars['ID']['input'];
  input?: InputMaybe<UpdateClassroomSubjectAccessInput>;
  subjectId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateDistrictArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<UpdateDistrictInput>;
};


export type RootMutationTypeUpdateGuideArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<UpdateGuideInput>;
};


export type RootMutationTypeUpdateQuestionArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<UpdateQuestionInput>;
};


export type RootMutationTypeUpdateSchoolLicenseArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<UpdateSchoolLicenseInput>;
};


export type RootMutationTypeUpdateSubjectArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<UpdateSubjectInput>;
};


export type RootMutationTypeUpdateSubjectFaqArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<UpdateSubjectFaqInput>;
};


export type RootMutationTypeUpdateSubscriptionArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<UpdateSubscriptionInput>;
};


export type RootMutationTypeUpdateSupplementArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<UpdateSupplementInput>;
};


export type RootMutationTypeUpdateUpgradeArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<UpdateUpgradeInput>;
};


export type RootMutationTypeUpdateUserArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<UpdateUserInput>;
};


export type RootMutationTypeUpsertReportArgs = {
  input: UpsertReportInput;
};

export type RootQueryType = {
  __typename?: 'RootQueryType';
  /** Returns AB total question count given the provided filters. */
  abQuestionCount: Scalars['Int']['output'];
  /** Returns AB question counts grouped by a dimension given the provided filters. */
  abQuestionCountsByDimension: Array<AbQuestionCountEntry>;
  /** Total count of adaptive practices on in scope classroom subjects at each level */
  adaptiveAchievement: Scalars['JsonString']['output'];
  adaptivePractice?: Maybe<AdaptivePractice>;
  adaptivePractices?: Maybe<KeysetPageOfAdaptivePractice>;
  /** Returns skills that are on the student's skill path or have independent practice, scoped to non-restricted classrooms, sorted by date proximity. */
  allSkills: Array<GuideLevel>;
  classroom?: Maybe<ClassroomsClassroom>;
  classroomAssignment?: Maybe<ClassroomAssignment>;
  currentUser?: Maybe<User>;
  curriculumArea?: Maybe<CurriculumArea>;
  curriculumAreas?: Maybe<KeysetPageOfCurriculumArea>;
  customerFeedbackEntry?: Maybe<CustomerFeedbackEntry>;
  district?: Maybe<District>;
  districts?: Maybe<KeysetPageOfDistrict>;
  featureFlag?: Maybe<FeatureFlag>;
  gradeLevels?: Maybe<KeysetPageOfGradeLevel>;
  guide?: Maybe<Guide>;
  guideLevel?: Maybe<GuideLevel>;
  /** tree aware search for guide levels */
  guideLevelTreeSearch: Array<GuideLevelSearchResult>;
  /** Tree aware search for guide levels within standards and standard sets. */
  guideLevelTreeSearchByStandard: Array<GuideLevelSearchResult>;
  guideLevels?: Maybe<KeysetPageOfGuideLevel>;
  guideLevelsOffset?: Maybe<PageOfGuideLevel>;
  guides?: Maybe<KeysetPageOfGuide>;
  question?: Maybe<Question>;
  questions?: Maybe<KeysetPageOfQuestion>;
  questionsOffset?: Maybe<PageOfQuestion>;
  report?: Maybe<AnalyticsReport>;
  reportResults: Array<ReportResult>;
  schoolLicense?: Maybe<SchoolLicense>;
  schoolLicenses?: Maybe<KeysetPageOfSchoolLicense>;
  skillPathSetting?: Maybe<SkillPathSettings>;
  skillPathSettings?: Maybe<KeysetPageOfSkillPathSettings>;
  standard?: Maybe<Standard>;
  standardSet?: Maybe<StandardSet>;
  standardSets?: Maybe<KeysetPageOfStandardSet>;
  standards?: Maybe<KeysetPageOfStandard>;
  /** Reads a student assignment as an educator. Used by teachers to view lockdown violation details. */
  studentAssignmentAsEducator?: Maybe<StudentAssignment>;
  subject?: Maybe<Subject>;
  subjects?: Maybe<KeysetPageOfSubject>;
  subjectsOffset?: Maybe<PageOfSubject>;
  supplement?: Maybe<Supplement>;
  supplements?: Maybe<KeysetPageOfSupplement>;
  tag?: Maybe<Tag>;
  tags?: Maybe<PageOfTag>;
  /** Returns skills the student should work on next: skills currently on the student's skill path or recently practiced independent skills, scoped to non-restricted classrooms, sorted by date proximity. */
  toDoSkills: Array<GuideLevel>;
  unfilteredGuideLevel?: Maybe<GuideLevel>;
  unfilteredGuideLevels?: Maybe<KeysetPageOfGuideLevel>;
  unfilteredGuideLevelsOffset?: Maybe<PageOfGuideLevel>;
  unfilteredSubject?: Maybe<Subject>;
  unfilteredSubjects?: Maybe<KeysetPageOfSubject>;
  unfilteredSubjectsOffset?: Maybe<PageOfSubject>;
  upgrade?: Maybe<Upgrade>;
  upgrades?: Maybe<KeysetPageOfUpgrade>;
  user?: Maybe<User>;
  userFeedbacks?: Maybe<KeysetPageOfUserFeedback>;
  users?: Maybe<PageOfUser>;
};


export type RootQueryTypeAbQuestionCountArgs = {
  countOpts?: InputMaybe<AbQuestionCountOptsInput>;
};


export type RootQueryTypeAbQuestionCountsByDimensionArgs = {
  countOpts?: InputMaybe<AbQuestionCountOptsInput>;
  dimension: Scalars['String']['input'];
};


export type RootQueryTypeAdaptiveAchievementArgs = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type RootQueryTypeAdaptivePracticeArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeAdaptivePracticesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AdaptivePracticeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AdaptivePracticeSortInput>>>;
};


export type RootQueryTypeAllSkillsArgs = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  filter?: InputMaybe<GuideLevelFilterInput>;
  sort?: InputMaybe<Array<InputMaybe<GuideLevelSortInput>>>;
};


export type RootQueryTypeClassroomArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeClassroomAssignmentArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeCurriculumAreaArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeCurriculumAreasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CurriculumAreaFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CurriculumAreaSortInput>>>;
};


export type RootQueryTypeCustomerFeedbackEntryArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeDistrictArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeDistrictsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DistrictFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DistrictSortInput>>>;
};


export type RootQueryTypeFeatureFlagArgs = {
  name: Scalars['String']['input'];
};


export type RootQueryTypeGradeLevelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<GradeLevelFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GradeLevelSortInput>>>;
};


export type RootQueryTypeGuideArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeGuideLevelArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeGuideLevelTreeSearchArgs = {
  guideId: Scalars['ID']['input'];
  proficiencyLevels?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  standardIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  standardSetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type RootQueryTypeGuideLevelTreeSearchByStandardArgs = {
  applyPersonalizationSettings?: InputMaybe<Scalars['Boolean']['input']>;
  curriculumAreaIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  guideId: Scalars['ID']['input'];
  proficiencyLevels?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  standardIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  standardSetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type RootQueryTypeGuideLevelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<GuideLevelFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuideLevelSortInput>>>;
};


export type RootQueryTypeGuideLevelsOffsetArgs = {
  filter?: InputMaybe<GuideLevelFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuideLevelSortInput>>>;
};


export type RootQueryTypeGuidesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<GuideFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuideSortInput>>>;
};


export type RootQueryTypeQuestionArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeQuestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<QuestionFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<QuestionSortInput>>>;
};


export type RootQueryTypeQuestionsOffsetArgs = {
  filter?: InputMaybe<QuestionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<QuestionSortInput>>>;
};


export type RootQueryTypeReportArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeReportResultsArgs = {
  pagination: ReportResultPaginationInput;
  reportId: Scalars['ID']['input'];
  sorts?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeSchoolLicenseArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeSchoolLicensesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SchoolLicenseFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SchoolLicenseSortInput>>>;
};


export type RootQueryTypeSkillPathSettingArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeSkillPathSettingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SkillPathSettingsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SkillPathSettingsSortInput>>>;
};


export type RootQueryTypeStandardArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeStandardSetArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeStandardSetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<StandardSetFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<StandardSetSortInput>>>;
};


export type RootQueryTypeStandardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<StandardFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<StandardSortInput>>>;
};


export type RootQueryTypeStudentAssignmentAsEducatorArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeSubjectArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeSubjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SubjectFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SubjectSortInput>>>;
};


export type RootQueryTypeSubjectsOffsetArgs = {
  filter?: InputMaybe<SubjectFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SubjectSortInput>>>;
};


export type RootQueryTypeSupplementArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeSupplementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SupplementFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SupplementSortInput>>>;
};


export type RootQueryTypeTagArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeTagsArgs = {
  filter?: InputMaybe<TagFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TagSortInput>>>;
};


export type RootQueryTypeToDoSkillsArgs = {
  classroomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  filter?: InputMaybe<GuideLevelFilterInput>;
  recencyRange?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuideLevelSortInput>>>;
};


export type RootQueryTypeUnfilteredGuideLevelArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeUnfilteredGuideLevelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<GuideLevelFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuideLevelSortInput>>>;
};


export type RootQueryTypeUnfilteredGuideLevelsOffsetArgs = {
  filter?: InputMaybe<GuideLevelFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuideLevelSortInput>>>;
};


export type RootQueryTypeUnfilteredSubjectArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeUnfilteredSubjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SubjectFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SubjectSortInput>>>;
};


export type RootQueryTypeUnfilteredSubjectsOffsetArgs = {
  filter?: InputMaybe<SubjectFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SubjectSortInput>>>;
};


export type RootQueryTypeUpgradeArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeUpgradesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<UpgradeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<UpgradeSortInput>>>;
};


export type RootQueryTypeUserArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeUserFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<UserFeedbackFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<UserFeedbackSortInput>>>;
};


export type RootQueryTypeUsersArgs = {
  filter?: InputMaybe<UserFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<UserSortInput>>>;
};

export type Rubric = ContainsRubric | EditableRegionsRubric | ExactRubric | GraphContainsRubric | MarkAsCorrectRubric | MathContainsRubric | MostEqualRubric;

export type RubricInput = {
  contains?: InputMaybe<ContainsRubricInput>;
  editableRegions?: InputMaybe<EditableRegionsRubricInput>;
  exact?: InputMaybe<ExactRubricInput>;
  graphContains?: InputMaybe<GraphContainsRubricInput>;
  markAsCorrect?: InputMaybe<MarkAsCorrectRubricInput>;
  mathContains?: InputMaybe<MathContainsRubricInput>;
  mostEqual?: InputMaybe<MostEqualRubricInput>;
};

export type SaveRecipientGroupsInput = {
  recipientGroups: Array<RecipientGroupInput>;
};

export type SchoolLicense = {
  __typename?: 'SchoolLicense';
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
};

export type SchoolLicenseFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type SchoolLicenseFilterInput = {
  and?: InputMaybe<Array<SchoolLicenseFilterInput>>;
  id?: InputMaybe<SchoolLicenseFilterId>;
  isActive?: InputMaybe<SchoolLicenseFilterIsActive>;
  not?: InputMaybe<Array<SchoolLicenseFilterInput>>;
  or?: InputMaybe<Array<SchoolLicenseFilterInput>>;
};

export type SchoolLicenseFilterIsActive = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SchoolLicenseSortField {
  Id = 'ID',
  IsActive = 'IS_ACTIVE'
}

export type SchoolLicenseSortInput = {
  field: SchoolLicenseSortField;
  order?: InputMaybe<SortOrder>;
};

export type SchoolPersonnel = {
  __typename?: 'SchoolPersonnel';
  id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  teacherId?: Maybe<Scalars['ID']['output']>;
};

export type SetLicenseAccessStatusInput = {
  status: Scalars['String']['input'];
};

/** The result of the :set_license_access_status mutation */
export type SetLicenseAccessStatusResult = {
  __typename?: 'SetLicenseAccessStatusResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<SchoolPersonnel>;
};

export type SkillPathSettings = {
  __typename?: 'SkillPathSettings';
  classroomSkillPathConfigs: Array<ClassroomSkillPathConfig>;
  dueDate: Scalars['DateTime']['output'];
  guideLevel: GuideLevel;
  guideLevelId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
  studentSkillPaths: Array<StudentSkillPath>;
  unfilteredGuideLevel: GuideLevel;
};


export type SkillPathSettingsClassroomSkillPathConfigsArgs = {
  filter?: InputMaybe<ClassroomSkillPathConfigFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ClassroomSkillPathConfigSortInput>>>;
};


export type SkillPathSettingsStudentSkillPathsArgs = {
  filter?: InputMaybe<StudentSkillPathFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<StudentSkillPathSortInput>>>;
};

export type SkillPathSettingsFilterDueDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SkillPathSettingsFilterGuideLevelId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type SkillPathSettingsFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type SkillPathSettingsFilterInput = {
  and?: InputMaybe<Array<SkillPathSettingsFilterInput>>;
  classroomSkillPathConfigs?: InputMaybe<ClassroomSkillPathConfigFilterInput>;
  dueDate?: InputMaybe<SkillPathSettingsFilterDueDate>;
  guideLevel?: InputMaybe<GuideLevelFilterInput>;
  guideLevelId?: InputMaybe<SkillPathSettingsFilterGuideLevelId>;
  id?: InputMaybe<SkillPathSettingsFilterId>;
  not?: InputMaybe<Array<SkillPathSettingsFilterInput>>;
  or?: InputMaybe<Array<SkillPathSettingsFilterInput>>;
  startDate?: InputMaybe<SkillPathSettingsFilterStartDate>;
  studentSkillPaths?: InputMaybe<StudentSkillPathFilterInput>;
  unfilteredGuideLevel?: InputMaybe<GuideLevelFilterInput>;
};

export type SkillPathSettingsFilterStartDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum SkillPathSettingsSortField {
  DueDate = 'DUE_DATE',
  GuideLevelId = 'GUIDE_LEVEL_ID',
  Id = 'ID',
  StartDate = 'START_DATE'
}

export type SkillPathSettingsSortInput = {
  field: SkillPathSettingsSortField;
  order?: InputMaybe<SortOrder>;
};

export enum SortOrder {
  Asc = 'ASC',
  AscNullsFirst = 'ASC_NULLS_FIRST',
  AscNullsLast = 'ASC_NULLS_LAST',
  Desc = 'DESC',
  DescNullsFirst = 'DESC_NULLS_FIRST',
  DescNullsLast = 'DESC_NULLS_LAST'
}

export type SortableTableSupplementContent = {
  __typename?: 'SortableTableSupplementContent';
  hasTotal: Scalars['Boolean']['output'];
  text: Scalars['String']['output'];
};

export type SortableTableSupplementContentInput = {
  hasTotal: Scalars['Boolean']['input'];
  text: Scalars['String']['input'];
};

export type Standard = {
  __typename?: 'Standard';
  abQuestionCount?: Maybe<Scalars['Int']['output']>;
  caseId?: Maybe<Scalars['ID']['output']>;
  countGuideLevels: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  guideLevels: Array<GuideLevel>;
  id: Scalars['ID']['output'];
  matchesSearch?: Maybe<Scalars['Boolean']['output']>;
  questions: Array<Question>;
  standardSet: StandardSet;
  standardSetId: Scalars['ID']['output'];
  statusEndDate?: Maybe<Scalars['Date']['output']>;
  statusStartDate?: Maybe<Scalars['Date']['output']>;
  title: Scalars['String']['output'];
  unfilteredGuideLevels: Array<GuideLevel>;
  uri?: Maybe<Scalars['String']['output']>;
};


export type StandardAbQuestionCountArgs = {
  guideLevels?: InputMaybe<Array<Scalars['ID']['input']>>;
  hideAssessmentQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  hidePreviouslyAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  questionDifficulties?: InputMaybe<Array<Scalars['Int']['input']>>;
  questionTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  subjects?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type StandardGuideLevelsArgs = {
  filter?: InputMaybe<GuideLevelFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuideLevelSortInput>>>;
};


export type StandardMatchesSearchArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type StandardQuestionsArgs = {
  filter?: InputMaybe<QuestionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<QuestionSortInput>>>;
};


export type StandardUnfilteredGuideLevelsArgs = {
  filter?: InputMaybe<GuideLevelFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuideLevelSortInput>>>;
};

export type StandardAbQuestionCountFieldInput = {
  guideLevels?: InputMaybe<Array<Scalars['ID']['input']>>;
  hideAssessmentQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  hidePreviouslyAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  questionDifficulties?: InputMaybe<Array<Scalars['Int']['input']>>;
  questionTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  subjects?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type StandardFilterAbQuestionCount = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  input?: InputMaybe<StandardAbQuestionCountFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type StandardFilterCaseId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type StandardFilterCountGuideLevels = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type StandardFilterDescription = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type StandardFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type StandardFilterInput = {
  abQuestionCount?: InputMaybe<StandardFilterAbQuestionCount>;
  and?: InputMaybe<Array<StandardFilterInput>>;
  caseId?: InputMaybe<StandardFilterCaseId>;
  countGuideLevels?: InputMaybe<StandardFilterCountGuideLevels>;
  description?: InputMaybe<StandardFilterDescription>;
  guideLevels?: InputMaybe<GuideLevelFilterInput>;
  id?: InputMaybe<StandardFilterId>;
  matchesSearch?: InputMaybe<StandardFilterMatchesSearch>;
  not?: InputMaybe<Array<StandardFilterInput>>;
  or?: InputMaybe<Array<StandardFilterInput>>;
  questions?: InputMaybe<QuestionFilterInput>;
  standardSet?: InputMaybe<StandardSetFilterInput>;
  standardSetId?: InputMaybe<StandardFilterStandardSetId>;
  statusEndDate?: InputMaybe<StandardFilterStatusEndDate>;
  statusStartDate?: InputMaybe<StandardFilterStatusStartDate>;
  title?: InputMaybe<StandardFilterTitle>;
  unfilteredGuideLevels?: InputMaybe<GuideLevelFilterInput>;
  uri?: InputMaybe<StandardFilterUri>;
};

export type StandardFilterMatchesSearch = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  input?: InputMaybe<StandardMatchesSearchFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StandardFilterStandardSetId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type StandardFilterStatusEndDate = {
  eq?: InputMaybe<Scalars['Date']['input']>;
  greaterThan?: InputMaybe<Scalars['Date']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Date']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Date']['input']>;
  lessThan?: InputMaybe<Scalars['Date']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Date']['input']>;
  notEq?: InputMaybe<Scalars['Date']['input']>;
};

export type StandardFilterStatusStartDate = {
  eq?: InputMaybe<Scalars['Date']['input']>;
  greaterThan?: InputMaybe<Scalars['Date']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Date']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Date']['input']>;
  lessThan?: InputMaybe<Scalars['Date']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Date']['input']>;
  notEq?: InputMaybe<Scalars['Date']['input']>;
};

export type StandardFilterTitle = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type StandardFilterUri = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type StandardMatchesSearchFieldInput = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export type StandardSet = {
  __typename?: 'StandardSet';
  abQuestionCount?: Maybe<Scalars['Int']['output']>;
  adoptionStatus?: Maybe<Scalars['String']['output']>;
  caseId?: Maybe<Scalars['ID']['output']>;
  curriculumAreas: Array<CurriculumArea>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  matchesSearch?: Maybe<Scalars['Boolean']['output']>;
  officialSourceUrl?: Maybe<Scalars['String']['output']>;
  standardSetCreator: StandardSetCreator;
  standardSetCreatorId: Scalars['ID']['output'];
  standards: Array<Standard>;
  statusEndDate?: Maybe<Scalars['Date']['output']>;
  statusStartDate?: Maybe<Scalars['Date']['output']>;
  subjects: Array<Subject>;
  title: Scalars['String']['output'];
  uri?: Maybe<Scalars['String']['output']>;
};


export type StandardSetAbQuestionCountArgs = {
  guideLevels?: InputMaybe<Array<Scalars['ID']['input']>>;
  hideAssessmentQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  hidePreviouslyAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  negateStandardsFilter?: InputMaybe<Scalars['Boolean']['input']>;
  questionDifficulties?: InputMaybe<Array<Scalars['Int']['input']>>;
  questionTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  standards?: InputMaybe<Array<Scalars['ID']['input']>>;
  subjects?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type StandardSetCurriculumAreasArgs = {
  filter?: InputMaybe<CurriculumAreaFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CurriculumAreaSortInput>>>;
};


export type StandardSetMatchesSearchArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type StandardSetStandardsArgs = {
  filter?: InputMaybe<StandardFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<StandardSortInput>>>;
};


export type StandardSetSubjectsArgs = {
  filter?: InputMaybe<SubjectFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SubjectSortInput>>>;
};

export type StandardSetAbQuestionCountFieldInput = {
  guideLevels?: InputMaybe<Array<Scalars['ID']['input']>>;
  hideAssessmentQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  hidePreviouslyAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  negateStandardsFilter?: InputMaybe<Scalars['Boolean']['input']>;
  questionDifficulties?: InputMaybe<Array<Scalars['Int']['input']>>;
  questionTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  standards?: InputMaybe<Array<Scalars['ID']['input']>>;
  subjects?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type StandardSetCreator = {
  __typename?: 'StandardSetCreator';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type StandardSetCreatorFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type StandardSetCreatorFilterInput = {
  and?: InputMaybe<Array<StandardSetCreatorFilterInput>>;
  id?: InputMaybe<StandardSetCreatorFilterId>;
  name?: InputMaybe<StandardSetCreatorFilterName>;
  not?: InputMaybe<Array<StandardSetCreatorFilterInput>>;
  or?: InputMaybe<Array<StandardSetCreatorFilterInput>>;
  type?: InputMaybe<StandardSetCreatorFilterType>;
};

export type StandardSetCreatorFilterName = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type StandardSetCreatorFilterType = {
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type StandardSetFilterAbQuestionCount = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  input?: InputMaybe<StandardSetAbQuestionCountFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type StandardSetFilterAdoptionStatus = {
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type StandardSetFilterCaseId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type StandardSetFilterDescription = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type StandardSetFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type StandardSetFilterInput = {
  abQuestionCount?: InputMaybe<StandardSetFilterAbQuestionCount>;
  adoptionStatus?: InputMaybe<StandardSetFilterAdoptionStatus>;
  and?: InputMaybe<Array<StandardSetFilterInput>>;
  caseId?: InputMaybe<StandardSetFilterCaseId>;
  curriculumAreas?: InputMaybe<CurriculumAreaFilterInput>;
  description?: InputMaybe<StandardSetFilterDescription>;
  id?: InputMaybe<StandardSetFilterId>;
  matchesSearch?: InputMaybe<StandardSetFilterMatchesSearch>;
  not?: InputMaybe<Array<StandardSetFilterInput>>;
  officialSourceUrl?: InputMaybe<StandardSetFilterOfficialSourceUrl>;
  or?: InputMaybe<Array<StandardSetFilterInput>>;
  standardSetCreator?: InputMaybe<StandardSetCreatorFilterInput>;
  standardSetCreatorId?: InputMaybe<StandardSetFilterStandardSetCreatorId>;
  standards?: InputMaybe<StandardFilterInput>;
  statusEndDate?: InputMaybe<StandardSetFilterStatusEndDate>;
  statusStartDate?: InputMaybe<StandardSetFilterStatusStartDate>;
  subjects?: InputMaybe<SubjectFilterInput>;
  title?: InputMaybe<StandardSetFilterTitle>;
  uri?: InputMaybe<StandardSetFilterUri>;
};

export type StandardSetFilterMatchesSearch = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  input?: InputMaybe<StandardSetMatchesSearchFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StandardSetFilterOfficialSourceUrl = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type StandardSetFilterStandardSetCreatorId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type StandardSetFilterStatusEndDate = {
  eq?: InputMaybe<Scalars['Date']['input']>;
  greaterThan?: InputMaybe<Scalars['Date']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Date']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Date']['input']>;
  lessThan?: InputMaybe<Scalars['Date']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Date']['input']>;
  notEq?: InputMaybe<Scalars['Date']['input']>;
};

export type StandardSetFilterStatusStartDate = {
  eq?: InputMaybe<Scalars['Date']['input']>;
  greaterThan?: InputMaybe<Scalars['Date']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Date']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Date']['input']>;
  lessThan?: InputMaybe<Scalars['Date']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Date']['input']>;
  notEq?: InputMaybe<Scalars['Date']['input']>;
};

export type StandardSetFilterTitle = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type StandardSetFilterUri = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type StandardSetMatchesSearchFieldInput = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export enum StandardSetSortField {
  AbQuestionCount = 'AB_QUESTION_COUNT',
  AdoptionStatus = 'ADOPTION_STATUS',
  CaseId = 'CASE_ID',
  Description = 'DESCRIPTION',
  Id = 'ID',
  MatchesSearch = 'MATCHES_SEARCH',
  OfficialSourceUrl = 'OFFICIAL_SOURCE_URL',
  StandardSetCreatorId = 'STANDARD_SET_CREATOR_ID',
  StatusEndDate = 'STATUS_END_DATE',
  StatusStartDate = 'STATUS_START_DATE',
  Title = 'TITLE',
  Uri = 'URI'
}

export type StandardSetSortInput = {
  abQuestionCountInput?: InputMaybe<StandardSetAbQuestionCountFieldInput>;
  field: StandardSetSortField;
  matchesSearchInput?: InputMaybe<StandardSetMatchesSearchFieldInput>;
  order?: InputMaybe<SortOrder>;
};

export enum StandardSortField {
  AbQuestionCount = 'AB_QUESTION_COUNT',
  CaseId = 'CASE_ID',
  CountGuideLevels = 'COUNT_GUIDE_LEVELS',
  Description = 'DESCRIPTION',
  Id = 'ID',
  MatchesSearch = 'MATCHES_SEARCH',
  StandardSetId = 'STANDARD_SET_ID',
  StatusEndDate = 'STATUS_END_DATE',
  StatusStartDate = 'STATUS_START_DATE',
  Title = 'TITLE',
  Uri = 'URI'
}

export type StandardSortInput = {
  abQuestionCountInput?: InputMaybe<StandardAbQuestionCountFieldInput>;
  field: StandardSortField;
  matchesSearchInput?: InputMaybe<StandardMatchesSearchFieldInput>;
  order?: InputMaybe<SortOrder>;
};

export type StartAdaptivePracticeInput = {
  guideLevelId: Scalars['ID']['input'];
  repractice?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of the :start_adaptive_practice mutation */
export type StartAdaptivePracticeResult = {
  __typename?: 'StartAdaptivePracticeResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<AdaptivePractice>;
};

export type StudentAssignment = {
  __typename?: 'StudentAssignment';
  allowLateSubmissions?: Maybe<Scalars['Boolean']['output']>;
  assignmentId: Scalars['ID']['output'];
  assignmentType: Scalars['String']['output'];
  /** Classrooms this assignment is assigned in where the student is actively enrolled. */
  classrooms: Array<ClassroomsClassroom>;
  correctAnswerSetting?: Maybe<Scalars['String']['output']>;
  countOfQuestions?: Maybe<Scalars['Int']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  dueDateProximity?: Maybe<Scalars['Int']['output']>;
  grade?: Maybe<Scalars['Float']['output']>;
  /** Whether the assignment has started, cascading from student settings to classroom settings. */
  hasStarted?: Maybe<Scalars['Boolean']['output']>;
  hasSubmitted?: Maybe<Scalars['Boolean']['output']>;
  /** A unique identifier */
  id: Scalars['ID']['output'];
  /** Whether the student can still submit. True when not submitted and either no due date, due date is in the future, or due date is past but late submissions are allowed. */
  isOpen?: Maybe<Scalars['Boolean']['output']>;
  /** The reason the assignment was auto-submitted by lockdown mode. nil means not auto-submitted. */
  lockdownAutoSubmitReason?: Maybe<StudentAssignmentLockdownAutoSubmitReason>;
  /** Chronological list of lockdown violations. Each entry is a map with `type` and `recorded_at` keys. */
  lockdownViolations: Scalars['Json']['output'];
  name: Scalars['String']['output'];
  partialCreditEnabled?: Maybe<Scalars['Boolean']['output']>;
  settings?: Maybe<StudentAssignmentSettings>;
  /** The time the assignment becomes available to the student */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** The time the student actually began working on the assignment */
  startTime?: Maybe<Scalars['DateTime']['output']>;
  /** The current status of the assignment for the student, calculated based on submission status, due date, late submission policy, and start time. */
  status?: Maybe<StudentAssignmentStatus>;
  student: User;
  studentId: Scalars['ID']['output'];
  submitted?: Maybe<Scalars['DateTime']['output']>;
};


export type StudentAssignmentClassroomsArgs = {
  filter?: InputMaybe<ClassroomsClassroomFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ClassroomsClassroomSortInput>>>;
};

export type StudentAssignmentFilterAllowLateSubmissions = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentAssignmentFilterAssignmentId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type StudentAssignmentFilterAssignmentType = {
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAssignmentFilterCorrectAnswerSetting = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAssignmentFilterCountOfQuestions = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type StudentAssignmentFilterDueDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StudentAssignmentFilterDueDateProximity = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type StudentAssignmentFilterHasStarted = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentAssignmentFilterHasSubmitted = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentAssignmentFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type StudentAssignmentFilterInput = {
  allowLateSubmissions?: InputMaybe<StudentAssignmentFilterAllowLateSubmissions>;
  and?: InputMaybe<Array<StudentAssignmentFilterInput>>;
  assignmentId?: InputMaybe<StudentAssignmentFilterAssignmentId>;
  assignmentType?: InputMaybe<StudentAssignmentFilterAssignmentType>;
  /** Classrooms this assignment is assigned in where the student is actively enrolled. */
  classrooms?: InputMaybe<ClassroomsClassroomFilterInput>;
  correctAnswerSetting?: InputMaybe<StudentAssignmentFilterCorrectAnswerSetting>;
  countOfQuestions?: InputMaybe<StudentAssignmentFilterCountOfQuestions>;
  dueDate?: InputMaybe<StudentAssignmentFilterDueDate>;
  dueDateProximity?: InputMaybe<StudentAssignmentFilterDueDateProximity>;
  /** Whether the assignment has started, cascading from student settings to classroom settings. */
  hasStarted?: InputMaybe<StudentAssignmentFilterHasStarted>;
  hasSubmitted?: InputMaybe<StudentAssignmentFilterHasSubmitted>;
  id?: InputMaybe<StudentAssignmentFilterId>;
  /** Whether the student can still submit. True when not submitted and either no due date, due date is in the future, or due date is past but late submissions are allowed. */
  isOpen?: InputMaybe<StudentAssignmentFilterIsOpen>;
  /** The reason the assignment was auto-submitted by lockdown mode. nil means not auto-submitted. */
  lockdownAutoSubmitReason?: InputMaybe<StudentAssignmentFilterLockdownAutoSubmitReason>;
  /** Chronological list of lockdown violations. Each entry is a map with `type` and `recorded_at` keys. */
  lockdownViolations?: InputMaybe<StudentAssignmentFilterLockdownViolations>;
  name?: InputMaybe<StudentAssignmentFilterName>;
  not?: InputMaybe<Array<StudentAssignmentFilterInput>>;
  or?: InputMaybe<Array<StudentAssignmentFilterInput>>;
  partialCreditEnabled?: InputMaybe<StudentAssignmentFilterPartialCreditEnabled>;
  settings?: InputMaybe<StudentAssignmentFilterSettings>;
  /** The time the assignment becomes available to the student */
  startDate?: InputMaybe<StudentAssignmentFilterStartDate>;
  /** The time the student actually began working on the assignment */
  startTime?: InputMaybe<StudentAssignmentFilterStartTime>;
  /** The current status of the assignment for the student, calculated based on submission status, due date, late submission policy, and start time. */
  status?: InputMaybe<StudentAssignmentFilterStatus>;
  student?: InputMaybe<UserFilterInput>;
  studentId?: InputMaybe<StudentAssignmentFilterStudentId>;
  submitted?: InputMaybe<StudentAssignmentFilterSubmitted>;
};

export type StudentAssignmentFilterIsOpen = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentAssignmentFilterLockdownAutoSubmitReason = {
  eq?: InputMaybe<StudentAssignmentLockdownAutoSubmitReason>;
  greaterThan?: InputMaybe<StudentAssignmentLockdownAutoSubmitReason>;
  greaterThanOrEqual?: InputMaybe<StudentAssignmentLockdownAutoSubmitReason>;
  in?: InputMaybe<Array<InputMaybe<StudentAssignmentLockdownAutoSubmitReason>>>;
  isDistinctFrom?: InputMaybe<StudentAssignmentLockdownAutoSubmitReason>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<StudentAssignmentLockdownAutoSubmitReason>;
  lessThan?: InputMaybe<StudentAssignmentLockdownAutoSubmitReason>;
  lessThanOrEqual?: InputMaybe<StudentAssignmentLockdownAutoSubmitReason>;
  notEq?: InputMaybe<StudentAssignmentLockdownAutoSubmitReason>;
};

export type StudentAssignmentFilterLockdownViolations = {
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentAssignmentFilterName = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAssignmentFilterPartialCreditEnabled = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentAssignmentFilterSettings = {
  eq?: InputMaybe<StudentAssignmentSettingsInput>;
  greaterThan?: InputMaybe<StudentAssignmentSettingsInput>;
  greaterThanOrEqual?: InputMaybe<StudentAssignmentSettingsInput>;
  in?: InputMaybe<Array<InputMaybe<StudentAssignmentSettingsInput>>>;
  isDistinctFrom?: InputMaybe<StudentAssignmentSettingsInput>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<StudentAssignmentSettingsInput>;
  lessThan?: InputMaybe<StudentAssignmentSettingsInput>;
  lessThanOrEqual?: InputMaybe<StudentAssignmentSettingsInput>;
  notEq?: InputMaybe<StudentAssignmentSettingsInput>;
};

export type StudentAssignmentFilterStartDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StudentAssignmentFilterStartTime = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StudentAssignmentFilterStatus = {
  eq?: InputMaybe<StudentAssignmentStatus>;
  greaterThan?: InputMaybe<StudentAssignmentStatus>;
  greaterThanOrEqual?: InputMaybe<StudentAssignmentStatus>;
  in?: InputMaybe<Array<StudentAssignmentStatus>>;
  isDistinctFrom?: InputMaybe<StudentAssignmentStatus>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<StudentAssignmentStatus>;
  lessThan?: InputMaybe<StudentAssignmentStatus>;
  lessThanOrEqual?: InputMaybe<StudentAssignmentStatus>;
  notEq?: InputMaybe<StudentAssignmentStatus>;
};

export type StudentAssignmentFilterStudentId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type StudentAssignmentFilterSubmitted = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum StudentAssignmentLockdownAutoSubmitReason {
  CountdownTimeout = 'COUNTDOWN_TIMEOUT',
  ViolationsExceeded = 'VIOLATIONS_EXCEEDED'
}

export type StudentAssignmentSettings = {
  __typename?: 'StudentAssignmentSettings';
  allowLateSubmissions: Scalars['Boolean']['output'];
  autoAssignNewClassroomEnrollees?: Maybe<Scalars['Boolean']['output']>;
  correctAnswerSetting: Scalars['String']['output'];
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  lockdownModeEnabled?: Maybe<Scalars['Boolean']['output']>;
  ltiLineItemId?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  randomizeQuestionOrder?: Maybe<Scalars['Boolean']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  timeLimit?: Maybe<Scalars['Int']['output']>;
  translationAccess?: Maybe<Scalars['Boolean']['output']>;
};

export type StudentAssignmentSettingsInput = {
  allowLateSubmissions: Scalars['Boolean']['input'];
  autoAssignNewClassroomEnrollees?: InputMaybe<Scalars['Boolean']['input']>;
  correctAnswerSetting: Scalars['String']['input'];
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  lockdownModeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  ltiLineItemId?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  randomizeQuestionOrder?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  timeLimit?: InputMaybe<Scalars['Int']['input']>;
  translationAccess?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum StudentAssignmentSortField {
  AllowLateSubmissions = 'ALLOW_LATE_SUBMISSIONS',
  AssignmentId = 'ASSIGNMENT_ID',
  AssignmentType = 'ASSIGNMENT_TYPE',
  CorrectAnswerSetting = 'CORRECT_ANSWER_SETTING',
  CountOfQuestions = 'COUNT_OF_QUESTIONS',
  DueDate = 'DUE_DATE',
  DueDateProximity = 'DUE_DATE_PROXIMITY',
  HasStarted = 'HAS_STARTED',
  HasSubmitted = 'HAS_SUBMITTED',
  Id = 'ID',
  IsOpen = 'IS_OPEN',
  LockdownAutoSubmitReason = 'LOCKDOWN_AUTO_SUBMIT_REASON',
  LockdownViolations = 'LOCKDOWN_VIOLATIONS',
  Name = 'NAME',
  PartialCreditEnabled = 'PARTIAL_CREDIT_ENABLED',
  Settings = 'SETTINGS',
  StartDate = 'START_DATE',
  StartTime = 'START_TIME',
  Status = 'STATUS',
  StudentId = 'STUDENT_ID',
  Submitted = 'SUBMITTED'
}

export type StudentAssignmentSortInput = {
  field: StudentAssignmentSortField;
  order?: InputMaybe<SortOrder>;
};

export enum StudentAssignmentStatus {
  Closed = 'CLOSED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  PastDue = 'PAST_DUE'
}

export type StudentSkillPath = {
  __typename?: 'StudentSkillPath';
  classroom: ClassroomsClassroom;
  classroomId: Scalars['ID']['output'];
  guideLevel: GuideLevel;
  guideLevelId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  skillPathSettings: SkillPathSettings;
  skillPathSettingsId: Scalars['ID']['output'];
  student: User;
  studentId: Scalars['ID']['output'];
  unfilteredGuideLevel: GuideLevel;
};

export type StudentSkillPathFilterClassroomId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type StudentSkillPathFilterGuideLevelId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type StudentSkillPathFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type StudentSkillPathFilterInput = {
  and?: InputMaybe<Array<StudentSkillPathFilterInput>>;
  classroom?: InputMaybe<ClassroomsClassroomFilterInput>;
  classroomId?: InputMaybe<StudentSkillPathFilterClassroomId>;
  guideLevel?: InputMaybe<GuideLevelFilterInput>;
  guideLevelId?: InputMaybe<StudentSkillPathFilterGuideLevelId>;
  id?: InputMaybe<StudentSkillPathFilterId>;
  not?: InputMaybe<Array<StudentSkillPathFilterInput>>;
  or?: InputMaybe<Array<StudentSkillPathFilterInput>>;
  skillPathSettings?: InputMaybe<SkillPathSettingsFilterInput>;
  skillPathSettingsId?: InputMaybe<StudentSkillPathFilterSkillPathSettingsId>;
  student?: InputMaybe<UserFilterInput>;
  studentId?: InputMaybe<StudentSkillPathFilterStudentId>;
  unfilteredGuideLevel?: InputMaybe<GuideLevelFilterInput>;
};

export type StudentSkillPathFilterSkillPathSettingsId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type StudentSkillPathFilterStudentId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export enum StudentSkillPathSortField {
  ClassroomId = 'CLASSROOM_ID',
  GuideLevelId = 'GUIDE_LEVEL_ID',
  Id = 'ID',
  SkillPathSettingsId = 'SKILL_PATH_SETTINGS_ID',
  StudentId = 'STUDENT_ID'
}

export type StudentSkillPathSortInput = {
  field: StudentSkillPathSortField;
  order?: InputMaybe<SortOrder>;
};

export type Subject = {
  __typename?: 'Subject';
  abQuestionCount?: Maybe<Scalars['Int']['output']>;
  adaptive: Scalars['Boolean']['output'];
  alternateName?: Maybe<Scalars['String']['output']>;
  badge?: Maybe<Scalars['String']['output']>;
  banner?: Maybe<Scalars['String']['output']>;
  belongsToStandard?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  countOfDifficultQuestions?: Maybe<Scalars['Int']['output']>;
  countOfEasyQuestions?: Maybe<Scalars['Int']['output']>;
  countOfFreeResponseQuestions?: Maybe<Scalars['Int']['output']>;
  countOfMediumQuestions?: Maybe<Scalars['Int']['output']>;
  countOfQuestions?: Maybe<Scalars['Int']['output']>;
  curriculumArea?: Maybe<CurriculumArea>;
  curriculumAreaId?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  domain: Scalars['String']['output'];
  featuredAs?: Maybe<Scalars['String']['output']>;
  footerText?: Maybe<Scalars['String']['output']>;
  freeResponseQuestionsPublished: Scalars['Boolean']['output'];
  group?: Maybe<Scalars['String']['output']>;
  guides: Array<Guide>;
  hasAccessViaLicense?: Maybe<Scalars['Boolean']['output']>;
  hasAccessViaLicenseAsStudent?: Maybe<Scalars['Boolean']['output']>;
  hasAccessViaLicenseAsTeacher?: Maybe<Scalars['Boolean']['output']>;
  hasAccessViaSubscription?: Maybe<Scalars['Boolean']['output']>;
  hasFreeAccess?: Maybe<Scalars['Boolean']['output']>;
  hasFreeAccessAsStudent?: Maybe<Scalars['Boolean']['output']>;
  hasFreeAccessAsTeacher?: Maybe<Scalars['Boolean']['output']>;
  hasRestrictedFreePractice?: Maybe<Scalars['Boolean']['output']>;
  hidden: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  includedInPersonalizationSettings?: Maybe<Scalars['Boolean']['output']>;
  logoImageUrl?: Maybe<Scalars['String']['output']>;
  /** Whether the subject matches the given search term. searchFields may be any of name, description. Defaults to name. */
  matchesSearch?: Maybe<Scalars['Boolean']['output']>;
  matchingGuideLevelsSearchCount?: Maybe<Scalars['Int']['output']>;
  /** The subscriptions for this subject that belong to the current user. */
  mySubscriptions: Array<RetailSubscription>;
  name: Scalars['String']['output'];
  published: Scalars['Boolean']['output'];
  /**
   * The search relevance score for the subject given the search term. Use include_description to also match on description.
   * This should be used mostly for sorting. For filtering, use the `matches_search` calculation, which is more efficient.
   */
  searchRelevance?: Maybe<Scalars['Float']['output']>;
  shouldShowLabelTable: Scalars['Boolean']['output'];
  studentClassroomSubjects: Array<ClassroomSubject>;
  subjectFaqs: Array<SubjectFaq>;
  subscriptionsPrices?: Maybe<Array<Scalars['JsonString']['output']>>;
  translateQuestions: Scalars['Boolean']['output'];
  translateSupplements: Scalars['Boolean']['output'];
  urlSlug: Scalars['String']['output'];
  userHasAccess?: Maybe<Scalars['Boolean']['output']>;
};


export type SubjectAbQuestionCountArgs = {
  guideLevels?: InputMaybe<Array<Scalars['ID']['input']>>;
  hideAssessmentQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  hidePreviouslyAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  questionDifficulties?: InputMaybe<Array<Scalars['Int']['input']>>;
  questionTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  standardSets?: InputMaybe<Array<Scalars['ID']['input']>>;
  standards?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type SubjectBelongsToStandardArgs = {
  standardId: Scalars['ID']['input'];
};


export type SubjectGuidesArgs = {
  filter?: InputMaybe<GuideFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GuideSortInput>>>;
};


export type SubjectMatchesSearchArgs = {
  search: Scalars['String']['input'];
  searchFields?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SubjectMatchingGuideLevelsSearchCountArgs = {
  search: Scalars['String']['input'];
};


export type SubjectMySubscriptionsArgs = {
  filter?: InputMaybe<RetailSubscriptionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<RetailSubscriptionSortInput>>>;
};


export type SubjectSearchRelevanceArgs = {
  includeDescription?: InputMaybe<Scalars['Boolean']['input']>;
  search: Scalars['String']['input'];
};


export type SubjectStudentClassroomSubjectsArgs = {
  filter?: InputMaybe<ClassroomSubjectFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ClassroomSubjectSortInput>>>;
};


export type SubjectSubjectFaqsArgs = {
  filter?: InputMaybe<SubjectFaqFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SubjectFaqSortInput>>>;
};

export type SubjectAbQuestionCountFieldInput = {
  guideLevels?: InputMaybe<Array<Scalars['ID']['input']>>;
  hideAssessmentQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  hidePreviouslyAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  questionDifficulties?: InputMaybe<Array<Scalars['Int']['input']>>;
  questionTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  standardSets?: InputMaybe<Array<Scalars['ID']['input']>>;
  standards?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SubjectAuthor = {
  __typename?: 'SubjectAuthor';
  author?: Maybe<User>;
  canEditGuideLevels?: Maybe<Scalars['Boolean']['output']>;
  canEditQuestions?: Maybe<Scalars['Boolean']['output']>;
  canEditSupplements?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  subject: Subject;
  subjectId?: Maybe<Scalars['ID']['output']>;
  unfilteredSubject?: Maybe<Subject>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type SubjectAuthorFilterCanEditGuideLevels = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectAuthorFilterCanEditQuestions = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectAuthorFilterCanEditSupplements = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectAuthorFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type SubjectAuthorFilterInput = {
  and?: InputMaybe<Array<SubjectAuthorFilterInput>>;
  author?: InputMaybe<UserFilterInput>;
  canEditGuideLevels?: InputMaybe<SubjectAuthorFilterCanEditGuideLevels>;
  canEditQuestions?: InputMaybe<SubjectAuthorFilterCanEditQuestions>;
  canEditSupplements?: InputMaybe<SubjectAuthorFilterCanEditSupplements>;
  id?: InputMaybe<SubjectAuthorFilterId>;
  not?: InputMaybe<Array<SubjectAuthorFilterInput>>;
  or?: InputMaybe<Array<SubjectAuthorFilterInput>>;
  subject?: InputMaybe<SubjectFilterInput>;
  subjectId?: InputMaybe<SubjectAuthorFilterSubjectId>;
  unfilteredSubject?: InputMaybe<SubjectFilterInput>;
  userId?: InputMaybe<SubjectAuthorFilterUserId>;
};

export type SubjectAuthorFilterSubjectId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type SubjectAuthorFilterUserId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export enum SubjectAuthorSortField {
  CanEditGuideLevels = 'CAN_EDIT_GUIDE_LEVELS',
  CanEditQuestions = 'CAN_EDIT_QUESTIONS',
  CanEditSupplements = 'CAN_EDIT_SUPPLEMENTS',
  Id = 'ID',
  SubjectId = 'SUBJECT_ID',
  UserId = 'USER_ID'
}

export type SubjectAuthorSortInput = {
  field: SubjectAuthorSortField;
  order?: InputMaybe<SortOrder>;
};

export type SubjectBelongsToStandardFieldInput = {
  standardId: Scalars['ID']['input'];
};

export type SubjectFaq = {
  __typename?: 'SubjectFaq';
  answer?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  orderPosition?: Maybe<Scalars['Int']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  subject: Subject;
  subjectId: Scalars['ID']['output'];
  unfilteredSubject: Subject;
};

export type SubjectFaqFilterAnswer = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type SubjectFaqFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type SubjectFaqFilterInput = {
  and?: InputMaybe<Array<SubjectFaqFilterInput>>;
  answer?: InputMaybe<SubjectFaqFilterAnswer>;
  id?: InputMaybe<SubjectFaqFilterId>;
  not?: InputMaybe<Array<SubjectFaqFilterInput>>;
  or?: InputMaybe<Array<SubjectFaqFilterInput>>;
  orderPosition?: InputMaybe<SubjectFaqFilterOrderPosition>;
  question?: InputMaybe<SubjectFaqFilterQuestion>;
  subject?: InputMaybe<SubjectFilterInput>;
  subjectId?: InputMaybe<SubjectFaqFilterSubjectId>;
  unfilteredSubject?: InputMaybe<SubjectFilterInput>;
};

export type SubjectFaqFilterOrderPosition = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type SubjectFaqFilterQuestion = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type SubjectFaqFilterSubjectId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export enum SubjectFaqSortField {
  Answer = 'ANSWER',
  Id = 'ID',
  OrderPosition = 'ORDER_POSITION',
  Question = 'QUESTION',
  SubjectId = 'SUBJECT_ID'
}

export type SubjectFaqSortInput = {
  field: SubjectFaqSortField;
  order?: InputMaybe<SortOrder>;
};

export type SubjectFilterAbQuestionCount = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  input?: InputMaybe<SubjectAbQuestionCountFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type SubjectFilterAdaptive = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectFilterAlternateName = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type SubjectFilterBadge = {
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type SubjectFilterBanner = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type SubjectFilterBelongsToStandard = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  input?: InputMaybe<SubjectBelongsToStandardFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectFilterCode = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type SubjectFilterCountOfDifficultQuestions = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type SubjectFilterCountOfEasyQuestions = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type SubjectFilterCountOfFreeResponseQuestions = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type SubjectFilterCountOfMediumQuestions = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type SubjectFilterCountOfQuestions = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type SubjectFilterCurriculumAreaId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type SubjectFilterDescription = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type SubjectFilterDomain = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type SubjectFilterFeaturedAs = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type SubjectFilterFooterText = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type SubjectFilterFreeResponseQuestionsPublished = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectFilterGroup = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type SubjectFilterHasAccessViaLicense = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectFilterHasAccessViaLicenseAsStudent = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectFilterHasAccessViaLicenseAsTeacher = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectFilterHasAccessViaSubscription = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectFilterHasFreeAccess = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectFilterHasFreeAccessAsStudent = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectFilterHasFreeAccessAsTeacher = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectFilterHasRestrictedFreePractice = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectFilterHidden = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type SubjectFilterIncludedInPersonalizationSettings = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectFilterInput = {
  abQuestionCount?: InputMaybe<SubjectFilterAbQuestionCount>;
  adaptive?: InputMaybe<SubjectFilterAdaptive>;
  alternateName?: InputMaybe<SubjectFilterAlternateName>;
  and?: InputMaybe<Array<SubjectFilterInput>>;
  badge?: InputMaybe<SubjectFilterBadge>;
  banner?: InputMaybe<SubjectFilterBanner>;
  belongsToStandard?: InputMaybe<SubjectFilterBelongsToStandard>;
  code?: InputMaybe<SubjectFilterCode>;
  countOfDifficultQuestions?: InputMaybe<SubjectFilterCountOfDifficultQuestions>;
  countOfEasyQuestions?: InputMaybe<SubjectFilterCountOfEasyQuestions>;
  countOfFreeResponseQuestions?: InputMaybe<SubjectFilterCountOfFreeResponseQuestions>;
  countOfMediumQuestions?: InputMaybe<SubjectFilterCountOfMediumQuestions>;
  countOfQuestions?: InputMaybe<SubjectFilterCountOfQuestions>;
  curriculumArea?: InputMaybe<CurriculumAreaFilterInput>;
  curriculumAreaId?: InputMaybe<SubjectFilterCurriculumAreaId>;
  description?: InputMaybe<SubjectFilterDescription>;
  domain?: InputMaybe<SubjectFilterDomain>;
  featuredAs?: InputMaybe<SubjectFilterFeaturedAs>;
  footerText?: InputMaybe<SubjectFilterFooterText>;
  freeResponseQuestionsPublished?: InputMaybe<SubjectFilterFreeResponseQuestionsPublished>;
  group?: InputMaybe<SubjectFilterGroup>;
  guides?: InputMaybe<GuideFilterInput>;
  hasAccessViaLicense?: InputMaybe<SubjectFilterHasAccessViaLicense>;
  hasAccessViaLicenseAsStudent?: InputMaybe<SubjectFilterHasAccessViaLicenseAsStudent>;
  hasAccessViaLicenseAsTeacher?: InputMaybe<SubjectFilterHasAccessViaLicenseAsTeacher>;
  hasAccessViaSubscription?: InputMaybe<SubjectFilterHasAccessViaSubscription>;
  hasFreeAccess?: InputMaybe<SubjectFilterHasFreeAccess>;
  hasFreeAccessAsStudent?: InputMaybe<SubjectFilterHasFreeAccessAsStudent>;
  hasFreeAccessAsTeacher?: InputMaybe<SubjectFilterHasFreeAccessAsTeacher>;
  hasRestrictedFreePractice?: InputMaybe<SubjectFilterHasRestrictedFreePractice>;
  hidden?: InputMaybe<SubjectFilterHidden>;
  id?: InputMaybe<SubjectFilterId>;
  includedInPersonalizationSettings?: InputMaybe<SubjectFilterIncludedInPersonalizationSettings>;
  logoImageUrl?: InputMaybe<SubjectFilterLogoImageUrl>;
  /** Whether the subject matches the given search term. searchFields may be any of name, description. Defaults to name. */
  matchesSearch?: InputMaybe<SubjectFilterMatchesSearch>;
  matchingGuideLevelsSearchCount?: InputMaybe<SubjectFilterMatchingGuideLevelsSearchCount>;
  /** The subscriptions for this subject that belong to the current user. */
  mySubscriptions?: InputMaybe<RetailSubscriptionFilterInput>;
  name?: InputMaybe<SubjectFilterName>;
  not?: InputMaybe<Array<SubjectFilterInput>>;
  or?: InputMaybe<Array<SubjectFilterInput>>;
  published?: InputMaybe<SubjectFilterPublished>;
  /**
   * The search relevance score for the subject given the search term. Use include_description to also match on description.
   * This should be used mostly for sorting. For filtering, use the `matches_search` calculation, which is more efficient.
   */
  searchRelevance?: InputMaybe<SubjectFilterSearchRelevance>;
  shouldShowLabelTable?: InputMaybe<SubjectFilterShouldShowLabelTable>;
  studentClassroomSubjects?: InputMaybe<ClassroomSubjectFilterInput>;
  subjectFaqs?: InputMaybe<SubjectFaqFilterInput>;
  translateQuestions?: InputMaybe<SubjectFilterTranslateQuestions>;
  translateSupplements?: InputMaybe<SubjectFilterTranslateSupplements>;
  urlSlug?: InputMaybe<SubjectFilterUrlSlug>;
  userHasAccess?: InputMaybe<SubjectFilterUserHasAccess>;
};

export type SubjectFilterLogoImageUrl = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type SubjectFilterMatchesSearch = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  input?: InputMaybe<SubjectMatchesSearchFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectFilterMatchingGuideLevelsSearchCount = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  input?: InputMaybe<SubjectMatchingGuideLevelsSearchCountFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type SubjectFilterName = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type SubjectFilterPublished = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectFilterSearchRelevance = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  input?: InputMaybe<SubjectSearchRelevanceFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Float']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Float']['input']>;
  lessThan?: InputMaybe<Scalars['Float']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Float']['input']>;
  notEq?: InputMaybe<Scalars['Float']['input']>;
};

export type SubjectFilterShouldShowLabelTable = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectFilterTranslateQuestions = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectFilterTranslateSupplements = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectFilterUrlSlug = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type SubjectFilterUserHasAccess = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectMatchesSearchFieldInput = {
  search: Scalars['String']['input'];
  searchFields?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SubjectMatchingGuideLevelsSearchCountFieldInput = {
  search: Scalars['String']['input'];
};

export type SubjectSearchRelevanceFieldInput = {
  includeDescription?: InputMaybe<Scalars['Boolean']['input']>;
  search: Scalars['String']['input'];
};

export enum SubjectSortField {
  AbQuestionCount = 'AB_QUESTION_COUNT',
  Adaptive = 'ADAPTIVE',
  AlternateName = 'ALTERNATE_NAME',
  Badge = 'BADGE',
  Banner = 'BANNER',
  BelongsToStandard = 'BELONGS_TO_STANDARD',
  Code = 'CODE',
  CountOfDifficultQuestions = 'COUNT_OF_DIFFICULT_QUESTIONS',
  CountOfEasyQuestions = 'COUNT_OF_EASY_QUESTIONS',
  CountOfFreeResponseQuestions = 'COUNT_OF_FREE_RESPONSE_QUESTIONS',
  CountOfMediumQuestions = 'COUNT_OF_MEDIUM_QUESTIONS',
  CountOfQuestions = 'COUNT_OF_QUESTIONS',
  CurriculumAreaId = 'CURRICULUM_AREA_ID',
  Description = 'DESCRIPTION',
  Domain = 'DOMAIN',
  FeaturedAs = 'FEATURED_AS',
  FooterText = 'FOOTER_TEXT',
  FreeResponseQuestionsPublished = 'FREE_RESPONSE_QUESTIONS_PUBLISHED',
  Group = 'GROUP',
  HasAccessViaLicense = 'HAS_ACCESS_VIA_LICENSE',
  HasAccessViaLicenseAsStudent = 'HAS_ACCESS_VIA_LICENSE_AS_STUDENT',
  HasAccessViaLicenseAsTeacher = 'HAS_ACCESS_VIA_LICENSE_AS_TEACHER',
  HasAccessViaSubscription = 'HAS_ACCESS_VIA_SUBSCRIPTION',
  HasFreeAccess = 'HAS_FREE_ACCESS',
  HasFreeAccessAsStudent = 'HAS_FREE_ACCESS_AS_STUDENT',
  HasFreeAccessAsTeacher = 'HAS_FREE_ACCESS_AS_TEACHER',
  HasRestrictedFreePractice = 'HAS_RESTRICTED_FREE_PRACTICE',
  Hidden = 'HIDDEN',
  Id = 'ID',
  IncludedInPersonalizationSettings = 'INCLUDED_IN_PERSONALIZATION_SETTINGS',
  LogoImageUrl = 'LOGO_IMAGE_URL',
  MatchesSearch = 'MATCHES_SEARCH',
  MatchingGuideLevelsSearchCount = 'MATCHING_GUIDE_LEVELS_SEARCH_COUNT',
  Name = 'NAME',
  Published = 'PUBLISHED',
  SearchRelevance = 'SEARCH_RELEVANCE',
  ShouldShowLabelTable = 'SHOULD_SHOW_LABEL_TABLE',
  TranslateQuestions = 'TRANSLATE_QUESTIONS',
  TranslateSupplements = 'TRANSLATE_SUPPLEMENTS',
  UrlSlug = 'URL_SLUG',
  UserHasAccess = 'USER_HAS_ACCESS'
}

export type SubjectSortInput = {
  abQuestionCountInput?: InputMaybe<SubjectAbQuestionCountFieldInput>;
  belongsToStandardInput?: InputMaybe<SubjectBelongsToStandardFieldInput>;
  field: SubjectSortField;
  matchesSearchInput?: InputMaybe<SubjectMatchesSearchFieldInput>;
  matchingGuideLevelsSearchCountInput?: InputMaybe<SubjectMatchingGuideLevelsSearchCountFieldInput>;
  order?: InputMaybe<SortOrder>;
  searchRelevanceInput?: InputMaybe<SubjectSearchRelevanceFieldInput>;
};

export type Supplement = {
  __typename?: 'Supplement';
  content: SupplementContent;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  owner?: Maybe<User>;
  ownerId?: Maybe<Scalars['ID']['output']>;
  subject: Subject;
  subjectId: Scalars['ID']['output'];
  translate?: Maybe<Scalars['Boolean']['output']>;
};

export type SupplementContent = AudioSupplementContent | FreeFormSupplementContent | ImageSupplementContent | PassageSupplementContent | SortableTableSupplementContent;

export type SupplementContentInput = {
  audio?: InputMaybe<AudioSupplementContentInput>;
  freeForm?: InputMaybe<FreeFormSupplementContentInput>;
  image?: InputMaybe<ImageSupplementContentInput>;
  passage?: InputMaybe<PassageSupplementContentInput>;
  sortableTable?: InputMaybe<SortableTableSupplementContentInput>;
};

export type SupplementFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type SupplementFilterInput = {
  and?: InputMaybe<Array<SupplementFilterInput>>;
  id?: InputMaybe<SupplementFilterId>;
  name?: InputMaybe<SupplementFilterName>;
  not?: InputMaybe<Array<SupplementFilterInput>>;
  or?: InputMaybe<Array<SupplementFilterInput>>;
  owner?: InputMaybe<UserFilterInput>;
  ownerId?: InputMaybe<SupplementFilterOwnerId>;
  subject?: InputMaybe<SubjectFilterInput>;
  subjectId?: InputMaybe<SupplementFilterSubjectId>;
  translate?: InputMaybe<SupplementFilterTranslate>;
};

export type SupplementFilterName = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type SupplementFilterOwnerId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type SupplementFilterSubjectId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type SupplementFilterTranslate = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SupplementSortField {
  Id = 'ID',
  Name = 'NAME',
  OwnerId = 'OWNER_ID',
  SubjectId = 'SUBJECT_ID',
  Translate = 'TRANSLATE'
}

export type SupplementSortInput = {
  field: SupplementSortField;
  order?: InputMaybe<SortOrder>;
};

export type Tag = {
  __typename?: 'Tag';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** A human-readable version of the tag name, with each part capitalized */
  prettyName?: Maybe<Scalars['String']['output']>;
  questions: Array<Question>;
};


export type TagQuestionsArgs = {
  filter?: InputMaybe<QuestionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<QuestionSortInput>>>;
};

export type TagFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type TagFilterInput = {
  and?: InputMaybe<Array<TagFilterInput>>;
  id?: InputMaybe<TagFilterId>;
  name?: InputMaybe<TagFilterName>;
  not?: InputMaybe<Array<TagFilterInput>>;
  or?: InputMaybe<Array<TagFilterInput>>;
  /** A human-readable version of the tag name, with each part capitalized */
  prettyName?: InputMaybe<TagFilterPrettyName>;
  questions?: InputMaybe<QuestionFilterInput>;
};

export type TagFilterName = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type TagFilterPrettyName = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export enum TagSortField {
  Id = 'ID',
  Name = 'NAME',
  PrettyName = 'PRETTY_NAME'
}

export type TagSortInput = {
  field: TagSortField;
  order?: InputMaybe<SortOrder>;
};

export type UpdateClassroomSubjectAccessInput = {
  partialCreditEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  restrictFreePractice?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of the :update_classroom_subject_access mutation */
export type UpdateClassroomSubjectAccessResult = {
  __typename?: 'UpdateClassroomSubjectAccessResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<ClassroomSubject>;
};

export type UpdateDistrictInput = {
  cleverId?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ncesId?: InputMaybe<Scalars['String']['input']>;
  ncesLocale?: InputMaybe<NcesLocale>;
  state?: InputMaybe<UsState>;
};

/** The result of the :update_district mutation */
export type UpdateDistrictResult = {
  __typename?: 'UpdateDistrictResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<District>;
};

export type UpdateGuideInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  subjectId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** The result of the :update_guide mutation */
export type UpdateGuideResult = {
  __typename?: 'UpdateGuideResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<Guide>;
};

export type UpdateQuestionInput = {
  answerBreakdown?: InputMaybe<Scalars['JsonString']['input']>;
  chainPath?: InputMaybe<Scalars['Json']['input']>;
  difficulty?: InputMaybe<Scalars['Int']['input']>;
  guideLevel?: InputMaybe<Scalars['ID']['input']>;
  prompt?: InputMaybe<Scalars['String']['input']>;
  rubric?: InputMaybe<RubricInput>;
  solutionText?: InputMaybe<Scalars['String']['input']>;
  standards?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['ID']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  translate?: InputMaybe<Scalars['Boolean']['input']>;
  translateSupplements?: InputMaybe<Scalars['Boolean']['input']>;
  typeAttributes?: InputMaybe<QuestionTypeAttributesInput>;
};

/** The result of the :update_question mutation */
export type UpdateQuestionResult = {
  __typename?: 'UpdateQuestionResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<Question>;
};

export type UpdateSchoolLicenseInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  licenseType?: InputMaybe<Scalars['String']['input']>;
  numberOfSeats?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  upgradeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** The result of the :update_school_license mutation */
export type UpdateSchoolLicenseResult = {
  __typename?: 'UpdateSchoolLicenseResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<SchoolLicense>;
};

export type UpdateSubjectFaqInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};

/** The result of the :update_subject_faq mutation */
export type UpdateSubjectFaqResult = {
  __typename?: 'UpdateSubjectFaqResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<SubjectFaq>;
};

export type UpdateSubjectInput = {
  adaptive?: InputMaybe<Scalars['Boolean']['input']>;
  alternateName?: InputMaybe<Scalars['String']['input']>;
  badge?: InputMaybe<Scalars['String']['input']>;
  banner?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  curriculumAreaId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  featuredAs?: InputMaybe<Scalars['String']['input']>;
  footerText?: InputMaybe<Scalars['String']['input']>;
  freeResponseQuestionsPublished?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  logoImageUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  shouldShowLabelTable?: InputMaybe<Scalars['Boolean']['input']>;
  subscriptionsPrices?: InputMaybe<Array<Scalars['JsonString']['input']>>;
  translateQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  translateSupplements?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of the :update_subject mutation */
export type UpdateSubjectResult = {
  __typename?: 'UpdateSubjectResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<Subject>;
};

export type UpdateSubscriptionInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** The result of the :update_subscription mutation */
export type UpdateSubscriptionResult = {
  __typename?: 'UpdateSubscriptionResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<RetailSubscription>;
};

export type UpdateSupplementInput = {
  content?: InputMaybe<SupplementContentInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  translate?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of the :update_supplement mutation */
export type UpdateSupplementResult = {
  __typename?: 'UpdateSupplementResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<Supplement>;
};

export type UpdateUpgradeInput = {
  upgradeType?: InputMaybe<Scalars['String']['input']>;
};

/** The result of the :update_upgrade mutation */
export type UpdateUpgradeResult = {
  __typename?: 'UpdateUpgradeResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<Upgrade>;
};

export type UpdateUserInput = {
  cleverId?: InputMaybe<Scalars['String']['input']>;
  /** The user's content preferences for suggested content */
  contentPreferences?: InputMaybe<Scalars['JsonString']['input']>;
  coppaConsentEmail?: InputMaybe<Scalars['String']['input']>;
  customerFeedbackReminderDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The user's email address */
  email?: InputMaybe<Scalars['String']['input']>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  isAuthor?: InputMaybe<Scalars['Boolean']['input']>;
  isSchoolAdministrator?: InputMaybe<Scalars['Boolean']['input']>;
  isTeacher?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  ltiId?: InputMaybe<Scalars['String']['input']>;
  needsCoppa?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of completed onboarding steps for the user */
  onboardingSteps?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The user's password hash */
  password?: InputMaybe<Scalars['String']['input']>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  schoolId?: InputMaybe<Scalars['ID']['input']>;
  signUpMethod?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subjectAuthors?: InputMaybe<Array<UserUpdateSubjectAuthorsInput>>;
  /** The user's username */
  username?: InputMaybe<Scalars['String']['input']>;
};

/** The result of the :update_user mutation */
export type UpdateUserResult = {
  __typename?: 'UpdateUserResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<User>;
};

export type Upgrade = {
  __typename?: 'Upgrade';
  id: Scalars['ID']['output'];
  upgradeType: Scalars['String']['output'];
};

export type UpgradeFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type UpgradeFilterInput = {
  and?: InputMaybe<Array<UpgradeFilterInput>>;
  id?: InputMaybe<UpgradeFilterId>;
  not?: InputMaybe<Array<UpgradeFilterInput>>;
  or?: InputMaybe<Array<UpgradeFilterInput>>;
  upgradeType?: InputMaybe<UpgradeFilterUpgradeType>;
};

export type UpgradeFilterUpgradeType = {
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export enum UpgradeSortField {
  Id = 'ID',
  UpgradeType = 'UPGRADE_TYPE'
}

export type UpgradeSortInput = {
  field: UpgradeSortField;
  order?: InputMaybe<SortOrder>;
};

export type UpsertReportInput = {
  dimensions: Array<Scalars['String']['input']>;
  filters?: InputMaybe<Array<AnalyticsReportFiltersInput>>;
  metricInputs?: InputMaybe<Array<MetricInputInput>>;
  metrics?: InputMaybe<Array<Scalars['String']['input']>>;
  persist?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of the :upsert_report mutation */
export type UpsertReportResult = {
  __typename?: 'UpsertReportResult';
  /** Any errors generated, if the mutation failed */
  errors: Array<MutationError>;
  /** The successful result of the mutation */
  result?: Maybe<AnalyticsReport>;
};

export enum UsState {
  Ak = 'AK',
  Al = 'AL',
  Ar = 'AR',
  Az = 'AZ',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  Dc = 'DC',
  De = 'DE',
  Fl = 'FL',
  Ga = 'GA',
  Hi = 'HI',
  Ia = 'IA',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Ma = 'MA',
  Md = 'MD',
  Me = 'ME',
  Mi = 'MI',
  Mn = 'MN',
  Mo = 'MO',
  Ms = 'MS',
  Mt = 'MT',
  Nc = 'NC',
  Nd = 'ND',
  Ne = 'NE',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Nv = 'NV',
  Ny = 'NY',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Va = 'VA',
  Vt = 'VT',
  Wa = 'WA',
  Wi = 'WI',
  Wv = 'WV',
  Wy = 'WY'
}

export type User = {
  __typename?: 'User';
  cleverId?: Maybe<Scalars['String']['output']>;
  /** The user's content preferences for suggested content */
  contentPreferences?: Maybe<Scalars['JsonString']['output']>;
  customerFeedbackReminderDate?: Maybe<Scalars['DateTime']['output']>;
  /** The Clever ID of the district this user's Clever user belongs to */
  districtCleverId?: Maybe<Scalars['String']['output']>;
  /** The user's email address */
  email: Scalars['String']['output'];
  facebookId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  googleId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  /**
   * Whether the user is an active managed user. Active managed users are students that either:
   *
   * 1. are enrolled in at least one active classroom at a school that manages their email domain.
   * 2. have an explicit school_managed_user record at a school that manages their email domain.
   *
   * If school_id is provided, checks if the user is actively managed by that school,
   * otherwise checks if the user is actively managed by any school.
   */
  isActiveManagedUser?: Maybe<Scalars['Boolean']['output']>;
  isAuthor?: Maybe<Scalars['Boolean']['output']>;
  isBetaTesting?: Maybe<Scalars['Boolean']['output']>;
  isCompleteProfile?: Maybe<Scalars['Boolean']['output']>;
  isContentManager: Scalars['Boolean']['output'];
  isCoppaApproved?: Maybe<Scalars['Boolean']['output']>;
  isPlatformAdministrator?: Maybe<Scalars['Boolean']['output']>;
  isPointOfContact?: Maybe<Scalars['Boolean']['output']>;
  isSchoolAdministrator: Scalars['Boolean']['output'];
  isTeacher?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  licenseStatus?: Maybe<UserLicenseStatus>;
  ltiId?: Maybe<Scalars['String']['output']>;
  needsCoppa: Scalars['Boolean']['output'];
  /** List of completed onboarding steps for the user */
  onboardingSteps: Array<Scalars['String']['output']>;
  pointsEarned: Scalars['Int']['output'];
  salutation?: Maybe<Scalars['String']['output']>;
  schoolId?: Maybe<Scalars['ID']['output']>;
  /** Set to null to resend if user has not already been confirmed */
  sentConfirmationEmailAt?: Maybe<Scalars['DateTime']['output']>;
  /** Set to null to resend */
  sentCreatedUserEmailAt?: Maybe<Scalars['DateTime']['output']>;
  /** Set to null to resend */
  sentPasswordResetEmailAt?: Maybe<Scalars['DateTime']['output']>;
  signUpMethod?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  studentAssignments: PageOfStudentAssignment;
  subjectAuthors: Array<SubjectAuthor>;
  subjects: Array<Subject>;
  subscriptions: Array<RetailSubscription>;
  super?: Maybe<Scalars['Boolean']['output']>;
  unfilteredSubjects: Array<Subject>;
  /** The user's username */
  username: Scalars['String']['output'];
};


export type UserIsActiveManagedUserArgs = {
  schoolId?: InputMaybe<Scalars['ID']['input']>;
};


export type UserStudentAssignmentsArgs = {
  filter?: InputMaybe<StudentAssignmentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<StudentAssignmentSortInput>>>;
};


export type UserSubjectAuthorsArgs = {
  filter?: InputMaybe<SubjectAuthorFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SubjectAuthorSortInput>>>;
};


export type UserSubjectsArgs = {
  filter?: InputMaybe<SubjectFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SubjectSortInput>>>;
};


export type UserSubscriptionsArgs = {
  filter?: InputMaybe<RetailSubscriptionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<RetailSubscriptionSortInput>>>;
};


export type UserUnfilteredSubjectsArgs = {
  filter?: InputMaybe<SubjectFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SubjectSortInput>>>;
};

export type UserCreateSubjectAuthorsInput = {
  canEditGuideLevels?: InputMaybe<Scalars['Boolean']['input']>;
  canEditQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  canEditSupplements?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  subjectId?: InputMaybe<Scalars['ID']['input']>;
};

export type UserFeedback = {
  __typename?: 'UserFeedback';
  comment: Scalars['String']['output'];
  feedbackType: UserFeedbackType;
  id: Scalars['ID']['output'];
  question: Question;
  questionId: Scalars['ID']['output'];
  reportedDevice?: Maybe<UserFeedbackReportedDevice>;
  user: User;
  userAgent?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

export type UserFeedbackFilterComment = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type UserFeedbackFilterFeedbackType = {
  eq?: InputMaybe<UserFeedbackType>;
  greaterThan?: InputMaybe<UserFeedbackType>;
  greaterThanOrEqual?: InputMaybe<UserFeedbackType>;
  in?: InputMaybe<Array<UserFeedbackType>>;
  isDistinctFrom?: InputMaybe<UserFeedbackType>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<UserFeedbackType>;
  lessThan?: InputMaybe<UserFeedbackType>;
  lessThanOrEqual?: InputMaybe<UserFeedbackType>;
  notEq?: InputMaybe<UserFeedbackType>;
};

export type UserFeedbackFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type UserFeedbackFilterInput = {
  and?: InputMaybe<Array<UserFeedbackFilterInput>>;
  comment?: InputMaybe<UserFeedbackFilterComment>;
  feedbackType?: InputMaybe<UserFeedbackFilterFeedbackType>;
  id?: InputMaybe<UserFeedbackFilterId>;
  not?: InputMaybe<Array<UserFeedbackFilterInput>>;
  or?: InputMaybe<Array<UserFeedbackFilterInput>>;
  question?: InputMaybe<QuestionFilterInput>;
  questionId?: InputMaybe<UserFeedbackFilterQuestionId>;
  reportedDevice?: InputMaybe<UserFeedbackFilterReportedDevice>;
  user?: InputMaybe<UserFilterInput>;
  userAgent?: InputMaybe<UserFeedbackFilterUserAgent>;
  userId?: InputMaybe<UserFeedbackFilterUserId>;
};

export type UserFeedbackFilterQuestionId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type UserFeedbackFilterReportedDevice = {
  eq?: InputMaybe<UserFeedbackReportedDevice>;
  greaterThan?: InputMaybe<UserFeedbackReportedDevice>;
  greaterThanOrEqual?: InputMaybe<UserFeedbackReportedDevice>;
  in?: InputMaybe<Array<InputMaybe<UserFeedbackReportedDevice>>>;
  isDistinctFrom?: InputMaybe<UserFeedbackReportedDevice>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<UserFeedbackReportedDevice>;
  lessThan?: InputMaybe<UserFeedbackReportedDevice>;
  lessThanOrEqual?: InputMaybe<UserFeedbackReportedDevice>;
  notEq?: InputMaybe<UserFeedbackReportedDevice>;
};

export type UserFeedbackFilterUserAgent = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type UserFeedbackFilterUserId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export enum UserFeedbackReportedDevice {
  Desktop = 'DESKTOP',
  Mobile = 'MOBILE'
}

export enum UserFeedbackSortField {
  Comment = 'COMMENT',
  FeedbackType = 'FEEDBACK_TYPE',
  Id = 'ID',
  QuestionId = 'QUESTION_ID',
  ReportedDevice = 'REPORTED_DEVICE',
  UserAgent = 'USER_AGENT',
  UserId = 'USER_ID'
}

export type UserFeedbackSortInput = {
  field: UserFeedbackSortField;
  order?: InputMaybe<SortOrder>;
};

export enum UserFeedbackType {
  Formatting = 'FORMATTING',
  Image = 'IMAGE',
  Inaccuracy = 'INACCURACY',
  Suggestion = 'SUGGESTION',
  TranslationError = 'TRANSLATION_ERROR',
  Typo = 'TYPO'
}

export type UserFilterCleverId = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type UserFilterContentPreferences = {
  eq?: InputMaybe<Scalars['JsonString']['input']>;
  greaterThan?: InputMaybe<Scalars['JsonString']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['JsonString']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JsonString']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['JsonString']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['JsonString']['input']>;
  lessThan?: InputMaybe<Scalars['JsonString']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['JsonString']['input']>;
  notEq?: InputMaybe<Scalars['JsonString']['input']>;
};

export type UserFilterCustomerFeedbackReminderDate = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserFilterDistrictCleverId = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type UserFilterEmail = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type UserFilterFacebookId = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type UserFilterFirstName = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type UserFilterFullName = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type UserFilterGoogleId = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type UserFilterId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type UserFilterInput = {
  and?: InputMaybe<Array<UserFilterInput>>;
  cleverId?: InputMaybe<UserFilterCleverId>;
  /** The user's content preferences for suggested content */
  contentPreferences?: InputMaybe<UserFilterContentPreferences>;
  customerFeedbackReminderDate?: InputMaybe<UserFilterCustomerFeedbackReminderDate>;
  /** The Clever ID of the district this user's Clever user belongs to */
  districtCleverId?: InputMaybe<UserFilterDistrictCleverId>;
  /** The user's email address */
  email?: InputMaybe<UserFilterEmail>;
  facebookId?: InputMaybe<UserFilterFacebookId>;
  firstName?: InputMaybe<UserFilterFirstName>;
  fullName?: InputMaybe<UserFilterFullName>;
  googleId?: InputMaybe<UserFilterGoogleId>;
  id?: InputMaybe<UserFilterId>;
  insertedAt?: InputMaybe<UserFilterInsertedAt>;
  /**
   * Whether the user is an active managed user. Active managed users are students that either:
   *
   * 1. are enrolled in at least one active classroom at a school that manages their email domain.
   * 2. have an explicit school_managed_user record at a school that manages their email domain.
   *
   * If school_id is provided, checks if the user is actively managed by that school,
   * otherwise checks if the user is actively managed by any school.
   */
  isActiveManagedUser?: InputMaybe<UserFilterIsActiveManagedUser>;
  isAuthor?: InputMaybe<UserFilterIsAuthor>;
  isBetaTesting?: InputMaybe<UserFilterIsBetaTesting>;
  isCompleteProfile?: InputMaybe<UserFilterIsCompleteProfile>;
  isContentManager?: InputMaybe<UserFilterIsContentManager>;
  isCoppaApproved?: InputMaybe<UserFilterIsCoppaApproved>;
  isPlatformAdministrator?: InputMaybe<UserFilterIsPlatformAdministrator>;
  isPointOfContact?: InputMaybe<UserFilterIsPointOfContact>;
  isSchoolAdministrator?: InputMaybe<UserFilterIsSchoolAdministrator>;
  isTeacher?: InputMaybe<UserFilterIsTeacher>;
  lastName?: InputMaybe<UserFilterLastName>;
  licenseStatus?: InputMaybe<UserFilterLicenseStatus>;
  ltiId?: InputMaybe<UserFilterLtiId>;
  needsCoppa?: InputMaybe<UserFilterNeedsCoppa>;
  not?: InputMaybe<Array<UserFilterInput>>;
  or?: InputMaybe<Array<UserFilterInput>>;
  pointsEarned?: InputMaybe<UserFilterPointsEarned>;
  salutation?: InputMaybe<UserFilterSalutation>;
  schoolId?: InputMaybe<UserFilterSchoolId>;
  /** Set to null to resend if user has not already been confirmed */
  sentConfirmationEmailAt?: InputMaybe<UserFilterSentConfirmationEmailAt>;
  /** Set to null to resend */
  sentCreatedUserEmailAt?: InputMaybe<UserFilterSentCreatedUserEmailAt>;
  /** Set to null to resend */
  sentPasswordResetEmailAt?: InputMaybe<UserFilterSentPasswordResetEmailAt>;
  signUpMethod?: InputMaybe<UserFilterSignUpMethod>;
  status?: InputMaybe<UserFilterStatus>;
  studentAssignments?: InputMaybe<StudentAssignmentFilterInput>;
  subjectAuthors?: InputMaybe<SubjectAuthorFilterInput>;
  subjects?: InputMaybe<SubjectFilterInput>;
  subscriptions?: InputMaybe<RetailSubscriptionFilterInput>;
  super?: InputMaybe<UserFilterSuper>;
  unfilteredSubjects?: InputMaybe<SubjectFilterInput>;
  /** The user's username */
  username?: InputMaybe<UserFilterUsername>;
};

export type UserFilterInsertedAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserFilterIsActiveManagedUser = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  input?: InputMaybe<UserIsActiveManagedUserFieldInput>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserFilterIsAuthor = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserFilterIsBetaTesting = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserFilterIsCompleteProfile = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserFilterIsContentManager = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserFilterIsCoppaApproved = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserFilterIsPlatformAdministrator = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserFilterIsPointOfContact = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserFilterIsSchoolAdministrator = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserFilterIsTeacher = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserFilterLastName = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type UserFilterLicenseStatus = {
  eq?: InputMaybe<UserLicenseStatus>;
  greaterThan?: InputMaybe<UserLicenseStatus>;
  greaterThanOrEqual?: InputMaybe<UserLicenseStatus>;
  in?: InputMaybe<Array<UserLicenseStatus>>;
  isDistinctFrom?: InputMaybe<UserLicenseStatus>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<UserLicenseStatus>;
  lessThan?: InputMaybe<UserLicenseStatus>;
  lessThanOrEqual?: InputMaybe<UserLicenseStatus>;
  notEq?: InputMaybe<UserLicenseStatus>;
};

export type UserFilterLtiId = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type UserFilterNeedsCoppa = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserFilterPointsEarned = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  notEq?: InputMaybe<Scalars['Int']['input']>;
};

export type UserFilterSalutation = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type UserFilterSchoolId = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  greaterThan?: InputMaybe<Scalars['ID']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['ID']['input']>;
  lessThan?: InputMaybe<Scalars['ID']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
  notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type UserFilterSentConfirmationEmailAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserFilterSentCreatedUserEmailAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserFilterSentPasswordResetEmailAt = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserFilterSignUpMethod = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type UserFilterStatus = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type UserFilterSuper = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserFilterUsername = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  isNil?: InputMaybe<Scalars['Boolean']['input']>;
  isNotDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  lessThan?: InputMaybe<Scalars['String']['input']>;
  lessThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
};

export type UserIsActiveManagedUserFieldInput = {
  schoolId?: InputMaybe<Scalars['ID']['input']>;
};

export enum UserLicenseStatus {
  Guest = 'GUEST',
  Licensed = 'LICENSED',
  Retail = 'RETAIL'
}

export enum UserSortField {
  CleverId = 'CLEVER_ID',
  ContentPreferences = 'CONTENT_PREFERENCES',
  CustomerFeedbackReminderDate = 'CUSTOMER_FEEDBACK_REMINDER_DATE',
  DistrictCleverId = 'DISTRICT_CLEVER_ID',
  Email = 'EMAIL',
  FacebookId = 'FACEBOOK_ID',
  FirstName = 'FIRST_NAME',
  FullName = 'FULL_NAME',
  GoogleId = 'GOOGLE_ID',
  Id = 'ID',
  InsertedAt = 'INSERTED_AT',
  IsActiveManagedUser = 'IS_ACTIVE_MANAGED_USER',
  IsAuthor = 'IS_AUTHOR',
  IsBetaTesting = 'IS_BETA_TESTING',
  IsCompleteProfile = 'IS_COMPLETE_PROFILE',
  IsContentManager = 'IS_CONTENT_MANAGER',
  IsCoppaApproved = 'IS_COPPA_APPROVED',
  IsPlatformAdministrator = 'IS_PLATFORM_ADMINISTRATOR',
  IsPointOfContact = 'IS_POINT_OF_CONTACT',
  IsSchoolAdministrator = 'IS_SCHOOL_ADMINISTRATOR',
  IsTeacher = 'IS_TEACHER',
  LastName = 'LAST_NAME',
  LicenseStatus = 'LICENSE_STATUS',
  LtiId = 'LTI_ID',
  NeedsCoppa = 'NEEDS_COPPA',
  PointsEarned = 'POINTS_EARNED',
  Salutation = 'SALUTATION',
  SchoolId = 'SCHOOL_ID',
  SentConfirmationEmailAt = 'SENT_CONFIRMATION_EMAIL_AT',
  SentCreatedUserEmailAt = 'SENT_CREATED_USER_EMAIL_AT',
  SentPasswordResetEmailAt = 'SENT_PASSWORD_RESET_EMAIL_AT',
  SignUpMethod = 'SIGN_UP_METHOD',
  Status = 'STATUS',
  Super = 'SUPER',
  Username = 'USERNAME'
}

export type UserSortInput = {
  field: UserSortField;
  isActiveManagedUserInput?: InputMaybe<UserIsActiveManagedUserFieldInput>;
  order?: InputMaybe<SortOrder>;
};

export type UserUpdateSubjectAuthorsInput = {
  canEditGuideLevels?: InputMaybe<Scalars['Boolean']['input']>;
  canEditQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  canEditSupplements?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  subjectId?: InputMaybe<Scalars['ID']['input']>;
};
